//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import authService from '../components/api-authorization/AuthorizeService';
export class ApiClientBase {
    baseApiUrl: string = window.location.origin;

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        try {
            const token = await authService.getAccessToken();
            options.headers = {
                ...options.headers,
                authorization: `Bearer ${token}`,
            };
        } catch (error) {
            // If token acquisition fails (e.g., due to session expiration),
            // don't add the authorization header - let the request fail properly
            console.warn('Failed to get access token:', error);
        }
        return Promise.resolve(options);
    }

    protected transformResult(
        url: string,
        response: Response,
        processor: (response: Response) => any
    ) {
        if (response.status === 401) {
            // Session invalidated by a newer login on another device (single active session)
            if (response.headers.get('X-Session-Expired') === 'true') {
                authService.handleSessionExpiration();
                throw new Error('Session expired. Please log in again.');
            }

            // Token rejected for any other reason (e.g. expired) - re-authenticate
            authService.redirectToLogin();
            throw new Error('Authentication required. Please log in again.');
        }

        return processor(response);
    }

    protected getBaseUrl(defaultUrl: string, baseUrl?: string) {
        return this.baseApiUrl;
    }
}

export class AttachmentsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<AttachmentVm> {
        let url_ = this.baseUrl + "/api/Attachments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<AttachmentVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Attachments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    create(file: FileParameter | null | undefined, description: string | null | undefined, projectId: number | null | undefined, employeeId: number | null | undefined, documentId: number | null | undefined, projectHodogramId: number | null | undefined, toolId: number | null | undefined, isMultimedia: boolean | undefined): Promise<AttachmentVm> {
        let url_ = this.baseUrl + "/api/Attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (employeeId !== null && employeeId !== undefined)
            content_.append("EmployeeId", employeeId.toString());
        if (documentId !== null && documentId !== undefined)
            content_.append("DocumentId", documentId.toString());
        if (projectHodogramId !== null && projectHodogramId !== undefined)
            content_.append("ProjectHodogramId", projectHodogramId.toString());
        if (toolId !== null && toolId !== undefined)
            content_.append("ToolId", toolId.toString());
        if (isMultimedia === null || isMultimedia === undefined)
            throw new Error("The parameter 'isMultimedia' cannot be null.");
        else
            content_.append("IsMultimedia", isMultimedia.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<AttachmentVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AttachmentVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentVm>(null as any);
    }

    update(attachmentId: number, id: number | undefined, file: FileParameter | null | undefined, description: string | null | undefined, projectId: number | null | undefined, employeeId: number | null | undefined, documentId: number | null | undefined, projectHodogramId: number | null | undefined, toolId: number | null | undefined, isMultimedia: boolean | undefined): Promise<AttachmentVm> {
        let url_ = this.baseUrl + "/api/Attachments/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (employeeId !== null && employeeId !== undefined)
            content_.append("EmployeeId", employeeId.toString());
        if (documentId !== null && documentId !== undefined)
            content_.append("DocumentId", documentId.toString());
        if (projectHodogramId !== null && projectHodogramId !== undefined)
            content_.append("ProjectHodogramId", projectHodogramId.toString());
        if (toolId !== null && toolId !== undefined)
            content_.append("ToolId", toolId.toString());
        if (isMultimedia === null || isMultimedia === undefined)
            throw new Error("The parameter 'isMultimedia' cannot be null.");
        else
            content_.append("IsMultimedia", isMultimedia.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<AttachmentVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentVm>(null as any);
    }

    downloadFile(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Attachments/{id}/Download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CitiesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CityVm[]> {
        let url_ = this.baseUrl + "/api/Cities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CityVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm[]>(null as any);
    }

    create(command: CreateCityCommandOfCity): Promise<CityVm> {
        let url_ = this.baseUrl + "/api/Cities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CityVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm>(null as any);
    }

    getById(id: number): Promise<CityVm> {
        let url_ = this.baseUrl + "/api/Cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm>(null as any);
    }

    update(id: number, command: UpdateCityCommandOfCity): Promise<CityVm> {
        let url_ = this.baseUrl + "/api/Cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CodebooksClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getByCodebookName(codebookName: string | null | undefined): Promise<SelectOptionVm[]> {
        let url_ = this.baseUrl + "/api/Codebooks?";
        if (codebookName !== undefined && codebookName !== null)
            url_ += "codebookName=" + encodeURIComponent("" + codebookName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByCodebookName(_response));
        });
    }

    protected processGetByCodebookName(response: Response): Promise<SelectOptionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectOptionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectOptionVm[]>(null as any);
    }
}

export class CompaniesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CompanyVm[]> {
        let url_ = this.baseUrl + "/api/Companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CompanyVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyVm[]>(null as any);
    }

    getById(id: number): Promise<CompanyVm> {
        let url_ = this.baseUrl + "/api/Companies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CompanyVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyVm>(null as any);
    }
}

export class ConfigurableConstantsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getConfigurableConstants(): Promise<ConfigurableConstantsVm> {
        let url_ = this.baseUrl + "/api/ConfigurableConstants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigurableConstants(_response));
        });
    }

    protected processGetConfigurableConstants(response: Response): Promise<ConfigurableConstantsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurableConstantsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurableConstantsVm>(null as any);
    }

    updateConfigurableConstants(id: number, command: UpdateConfigurableConstantsCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ConfigurableConstants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateConfigurableConstants(_response));
        });
    }

    protected processUpdateConfigurableConstants(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CooperatorContactsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<CooperatorContactVm> {
        let url_ = this.baseUrl + "/api/CooperatorContacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CooperatorContactVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CooperatorContactVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CooperatorContactVm>(null as any);
    }

    update(id: number, command: UpdateCooperatorContactCommandOfCooperatorContact): Promise<CooperatorContactVm> {
        let url_ = this.baseUrl + "/api/CooperatorContacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CooperatorContactVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CooperatorContactVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CooperatorContactVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/CooperatorContacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    create(command: CreateCooperatorContactCommandOfCooperatorContact): Promise<CooperatorContactVm> {
        let url_ = this.baseUrl + "/api/CooperatorContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CooperatorContactVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CooperatorContactVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CooperatorContactVm>(null as any);
    }
}

export class CooperatorsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CooperatorVm[]> {
        let url_ = this.baseUrl + "/api/Cooperators";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CooperatorVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CooperatorVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CooperatorVm[]>(null as any);
    }

    create(command: CreateCooperatorCommandOfCooperator): Promise<CooperatorDetailVm> {
        let url_ = this.baseUrl + "/api/Cooperators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CooperatorDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CooperatorDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CooperatorDetailVm>(null as any);
    }

    getByAssociateType(associateTypeId: number | undefined): Promise<CooperatorVm[]> {
        let url_ = this.baseUrl + "/api/Cooperators/type?";
        if (associateTypeId === null)
            throw new Error("The parameter 'associateTypeId' cannot be null.");
        else if (associateTypeId !== undefined)
            url_ += "associateTypeId=" + encodeURIComponent("" + associateTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByAssociateType(_response));
        });
    }

    protected processGetByAssociateType(response: Response): Promise<CooperatorVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CooperatorVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CooperatorVm[]>(null as any);
    }

    getPaginated(filter_Name: string | null | undefined, filter_OIB: string | null | undefined, filter_MBG: string | null | undefined, filter_MB: string | null | undefined, filter_Address: string | null | undefined, filter_Zip: string | null | undefined, filter_City: string | null | undefined, filter_Country: string | null | undefined, filter_PersonTypeId: number[] | null | undefined, filter_AssociateTypeId: number[] | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfCooperatorVm> {
        let url_ = this.baseUrl + "/api/Cooperators/search?";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_OIB !== undefined && filter_OIB !== null)
            url_ += "Filter.OIB=" + encodeURIComponent("" + filter_OIB) + "&";
        if (filter_MBG !== undefined && filter_MBG !== null)
            url_ += "Filter.MBG=" + encodeURIComponent("" + filter_MBG) + "&";
        if (filter_MB !== undefined && filter_MB !== null)
            url_ += "Filter.MB=" + encodeURIComponent("" + filter_MB) + "&";
        if (filter_Address !== undefined && filter_Address !== null)
            url_ += "Filter.Address=" + encodeURIComponent("" + filter_Address) + "&";
        if (filter_Zip !== undefined && filter_Zip !== null)
            url_ += "Filter.Zip=" + encodeURIComponent("" + filter_Zip) + "&";
        if (filter_City !== undefined && filter_City !== null)
            url_ += "Filter.City=" + encodeURIComponent("" + filter_City) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (filter_PersonTypeId !== undefined && filter_PersonTypeId !== null)
            filter_PersonTypeId && filter_PersonTypeId.forEach(item => { url_ += "Filter.PersonTypeId=" + encodeURIComponent("" + item) + "&"; });
        if (filter_AssociateTypeId !== undefined && filter_AssociateTypeId !== null)
            filter_AssociateTypeId && filter_AssociateTypeId.forEach(item => { url_ += "Filter.AssociateTypeId=" + encodeURIComponent("" + item) + "&"; });
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfCooperatorVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCooperatorVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCooperatorVm>(null as any);
    }

    getById(id: number): Promise<CooperatorDetailVm> {
        let url_ = this.baseUrl + "/api/Cooperators/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CooperatorDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CooperatorDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CooperatorDetailVm>(null as any);
    }

    update(id: number, command: UpdateCooperatorCommandOfCooperator): Promise<CooperatorDetailVm> {
        let url_ = this.baseUrl + "/api/Cooperators/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CooperatorDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CooperatorDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CooperatorDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Cooperators/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getCooperatorContacts(cooperatorId: number): Promise<CooperatorContactVm[]> {
        let url_ = this.baseUrl + "/api/Cooperators/{cooperatorId}/CooperatorContacts";
        if (cooperatorId === undefined || cooperatorId === null)
            throw new Error("The parameter 'cooperatorId' must be defined.");
        url_ = url_.replace("{cooperatorId}", encodeURIComponent("" + cooperatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCooperatorContacts(_response));
        });
    }

    protected processGetCooperatorContacts(response: Response): Promise<CooperatorContactVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CooperatorContactVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CooperatorContactVm[]>(null as any);
    }
}

export class CountriesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CountryVm[]> {
        let url_ = this.baseUrl + "/api/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CountryVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryVm[]>(null as any);
    }

    create(command: CreateCountryCommandOfCountry): Promise<CountryDetailVm> {
        let url_ = this.baseUrl + "/api/Countries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CountryDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CountryDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailVm>(null as any);
    }

    getById(id: number): Promise<CountryDetailVm> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CountryDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailVm>(null as any);
    }

    update(id: number, command: UpdateCountryCommandOfCountry): Promise<CountryDetailVm> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CountryDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DevClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(file: FileParameter | null | undefined, projectId: number | undefined, sheetName: string | null | undefined, excelRange: string | null | undefined, labelOrder: { [key: string]: string; } | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Dev";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (projectId === null || projectId === undefined)
            throw new Error("The parameter 'projectId' cannot be null.");
        else
            content_.append("ProjectId", projectId.toString());
        if (sheetName !== null && sheetName !== undefined)
            content_.append("SheetName", sheetName.toString());
        if (excelRange !== null && excelRange !== undefined)
            content_.append("ExcelRange", excelRange.toString());
        if (labelOrder !== null && labelOrder !== undefined)
            content_.append("LabelOrder", JSON.stringify(labelOrder));

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    exportWorkHoursByYear(year: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Dev/Expo?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportWorkHoursByYear(_response));
        });
    }

    protected processExportWorkHoursByYear(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DocumentItemsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(documentTypeId: number | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, projectId: number | null | undefined, destinationProjectId: number | null | undefined, supplierId: number | null | undefined, parentDocumentStatusId: number[] | null | undefined): Promise<DocumentItemVm[]> {
        let url_ = this.baseUrl + "/api/DocumentItems?";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (destinationProjectId !== undefined && destinationProjectId !== null)
            url_ += "DestinationProjectId=" + encodeURIComponent("" + destinationProjectId) + "&";
        if (supplierId !== undefined && supplierId !== null)
            url_ += "SupplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (parentDocumentStatusId !== undefined && parentDocumentStatusId !== null)
            parentDocumentStatusId && parentDocumentStatusId.forEach(item => { url_ += "ParentDocumentStatusId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<DocumentItemVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentItemVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentItemVm[]>(null as any);
    }

    create(command: CreateDocumentItemCommandOfDocumentItem): Promise<DocumentItemVm> {
        let url_ = this.baseUrl + "/api/DocumentItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<DocumentItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DocumentItemVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentItemVm>(null as any);
    }

    getById(id: number): Promise<DocumentItemVm> {
        let url_ = this.baseUrl + "/api/DocumentItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<DocumentItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentItemVm>(null as any);
    }

    update(id: number, command: UpdateDocumentItemCommandOfDocumentItem): Promise<DocumentItemVm> {
        let url_ = this.baseUrl + "/api/DocumentItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<DocumentItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentItemVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/DocumentItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DocumentsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(documentTypeId: number | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, projectId: number | null | undefined, destinationProjectId: number | null | undefined, code: string | null | undefined, createdById: string | null | undefined, parentId: number | null | undefined, supplier: string | null | undefined, deadlineDate: Date | null | undefined, receiptCode: string | null | undefined, receiptAmount: number | null | undefined, documentStatusId: number[] | null | undefined): Promise<DocumentVm[]> {
        let url_ = this.baseUrl + "/api/Documents?";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (destinationProjectId !== undefined && destinationProjectId !== null)
            url_ += "DestinationProjectId=" + encodeURIComponent("" + destinationProjectId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (createdById !== undefined && createdById !== null)
            url_ += "CreatedById=" + encodeURIComponent("" + createdById) + "&";
        if (parentId !== undefined && parentId !== null)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (supplier !== undefined && supplier !== null)
            url_ += "Supplier=" + encodeURIComponent("" + supplier) + "&";
        if (deadlineDate !== undefined && deadlineDate !== null)
            url_ += "DeadlineDate=" + encodeURIComponent(deadlineDate ? "" + deadlineDate.toISOString() : "") + "&";
        if (receiptCode !== undefined && receiptCode !== null)
            url_ += "ReceiptCode=" + encodeURIComponent("" + receiptCode) + "&";
        if (receiptAmount !== undefined && receiptAmount !== null)
            url_ += "ReceiptAmount=" + encodeURIComponent("" + receiptAmount) + "&";
        if (documentStatusId !== undefined && documentStatusId !== null)
            documentStatusId && documentStatusId.forEach(item => { url_ += "DocumentStatusId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<DocumentVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentVm[]>(null as any);
    }

    create(command: CreateDocumentCommandOfDocument): Promise<DocumentDetailVm> {
        let url_ = this.baseUrl + "/api/Documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<DocumentDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DocumentDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDetailVm>(null as any);
    }

    getById(id: number): Promise<DocumentDetailVm> {
        let url_ = this.baseUrl + "/api/Documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<DocumentDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDetailVm>(null as any);
    }

    update(id: number, command: UpdateDocumentCommandOfDocument): Promise<DocumentDetailVm> {
        let url_ = this.baseUrl + "/api/Documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<DocumentDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    complete(command: CompleteDocumentCommand): Promise<DocumentDetailVm> {
        let url_ = this.baseUrl + "/api/Documents/Complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComplete(_response));
        });
    }

    protected processComplete(response: Response): Promise<DocumentDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDetailVm>(null as any);
    }

    process(command: ProcessDocumentCommand): Promise<DocumentDetailVm> {
        let url_ = this.baseUrl + "/api/Documents/Process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcess(_response));
        });
    }

    protected processProcess(response: Response): Promise<DocumentDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDetailVm>(null as any);
    }

    copy(command: CopyDocumentCommand): Promise<DocumentDetailVm> {
        let url_ = this.baseUrl + "/api/Documents/Copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopy(_response));
        });
    }

    protected processCopy(response: Response): Promise<DocumentDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDetailVm>(null as any);
    }

    getDocumentAttachments(documentId: number): Promise<AttachmentVm[]> {
        let url_ = this.baseUrl + "/api/Documents/{documentId}/DocumentAttachments";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDocumentAttachments(_response));
        });
    }

    protected processGetDocumentAttachments(response: Response): Promise<AttachmentVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentVm[]>(null as any);
    }

    exportPDF(command: ExportOrderPDFCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Documents/ExportPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportPDF(_response));
        });
    }

    protected processExportPDF(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportXLSX(command: ExportOrderXLSXCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Documents/ExportXLSX";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXLSX(_response));
        });
    }

    protected processExportXLSX(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EmployeeExpensesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPaginated(filter_Employee_Name: string | null | undefined, filter_CompanyId: number | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined, month: number | undefined, year: number | undefined, companyId: number | undefined): Promise<EmployeeExpensesPaginated> {
        let url_ = this.baseUrl + "/api/EmployeeExpenses/search?";
        if (filter_Employee_Name !== undefined && filter_Employee_Name !== null)
            url_ += "Filter.Employee_Name=" + encodeURIComponent("" + filter_Employee_Name) + "&";
        if (filter_CompanyId === null)
            throw new Error("The parameter 'filter_CompanyId' cannot be null.");
        else if (filter_CompanyId !== undefined)
            url_ += "Filter.CompanyId=" + encodeURIComponent("" + filter_CompanyId) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<EmployeeExpensesPaginated> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeExpensesPaginated.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeExpensesPaginated>(null as any);
    }

    uploadEmployeeExpense(companyId: number | undefined, month: number | undefined, year: number | undefined, employeeExpenses: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/EmployeeExpenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (month === null || month === undefined)
            throw new Error("The parameter 'month' cannot be null.");
        else
            content_.append("Month", month.toString());
        if (year === null || year === undefined)
            throw new Error("The parameter 'year' cannot be null.");
        else
            content_.append("Year", year.toString());
        if (employeeExpenses !== null && employeeExpenses !== undefined)
            content_.append("EmployeeExpenses", employeeExpenses.data, employeeExpenses.fileName ? employeeExpenses.fileName : "EmployeeExpenses");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadEmployeeExpense(_response));
        });
    }

    protected processUploadEmployeeExpense(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateXlsx(companyId: number | undefined, month: number | undefined, year: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/EmployeeExpenses/download?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateXlsx(_response));
        });
    }

    protected processGenerateXlsx(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EmployeesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<EmployeeVm[]> {
        let url_ = this.baseUrl + "/api/Employees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<EmployeeVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeVm[]>(null as any);
    }

    create(command: CreateEmployeeCommand): Promise<EmployeeDetailVm> {
        let url_ = this.baseUrl + "/api/Employees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<EmployeeDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = EmployeeDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDetailVm>(null as any);
    }

    getPaginated(filter_Employee_Name: string | null | undefined, filter_OIB: string | null | undefined, filter_BirthDate: Date | null | undefined, filter_Address: string | null | undefined, filter_City: string | null | undefined, filter_Country: string | null | undefined, filter_Employee_Inactive: boolean | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfEmployeeVm> {
        let url_ = this.baseUrl + "/api/Employees/search?";
        if (filter_Employee_Name !== undefined && filter_Employee_Name !== null)
            url_ += "Filter.Employee_Name=" + encodeURIComponent("" + filter_Employee_Name) + "&";
        if (filter_OIB !== undefined && filter_OIB !== null)
            url_ += "Filter.OIB=" + encodeURIComponent("" + filter_OIB) + "&";
        if (filter_BirthDate !== undefined && filter_BirthDate !== null)
            url_ += "Filter.BirthDate=" + encodeURIComponent(filter_BirthDate ? "" + filter_BirthDate.toISOString() : "") + "&";
        if (filter_Address !== undefined && filter_Address !== null)
            url_ += "Filter.Address=" + encodeURIComponent("" + filter_Address) + "&";
        if (filter_City !== undefined && filter_City !== null)
            url_ += "Filter.City=" + encodeURIComponent("" + filter_City) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (filter_Employee_Inactive === null)
            throw new Error("The parameter 'filter_Employee_Inactive' cannot be null.");
        else if (filter_Employee_Inactive !== undefined)
            url_ += "Filter.Employee_Inactive=" + encodeURIComponent("" + filter_Employee_Inactive) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfEmployeeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfEmployeeVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfEmployeeVm>(null as any);
    }

    getById(id: number): Promise<EmployeeDetailVm> {
        let url_ = this.baseUrl + "/api/Employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<EmployeeDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDetailVm>(null as any);
    }

    update(id: number, command: UpdateEmployeeCommand): Promise<EmployeeDetailVm> {
        let url_ = this.baseUrl + "/api/Employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<EmployeeDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getEmployeeDocuments(employeeId: number): Promise<AttachmentVm[]> {
        let url_ = this.baseUrl + "/api/Employees/{employeeId}/documents";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmployeeDocuments(_response));
        });
    }

    protected processGetEmployeeDocuments(response: Response): Promise<AttachmentVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentVm[]>(null as any);
    }

    getEmployeeGearRecords(employeeId: number): Promise<EmployeeGearRecordVm[]> {
        let url_ = this.baseUrl + "/api/Employees/{employeeId}/gear";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmployeeGearRecords(_response));
        });
    }

    protected processGetEmployeeGearRecords(response: Response): Promise<EmployeeGearRecordVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeGearRecordVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeGearRecordVm[]>(null as any);
    }
}

export class ExpenseGroupsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<ExpenseGroupVm> {
        let url_ = this.baseUrl + "/api/ExpenseGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ExpenseGroupVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseGroupVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseGroupVm>(null as any);
    }

    update(id: number, command: UpdateExpenseGroupCommandOfExpenseGroup): Promise<ExpenseGroupVm> {
        let url_ = this.baseUrl + "/api/ExpenseGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ExpenseGroupVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseGroupVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseGroupVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ExpenseGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAll(expenseTypeId: number | null | undefined): Promise<ExpenseGroupVm[]> {
        let url_ = this.baseUrl + "/api/ExpenseGroups?";
        if (expenseTypeId !== undefined && expenseTypeId !== null)
            url_ += "expenseTypeId=" + encodeURIComponent("" + expenseTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ExpenseGroupVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpenseGroupVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseGroupVm[]>(null as any);
    }

    create(command: CreateExpenseGroupCommandOfExpenseGroup): Promise<ExpenseGroupVm> {
        let url_ = this.baseUrl + "/api/ExpenseGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ExpenseGroupVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ExpenseGroupVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseGroupVm>(null as any);
    }
}

export class FilesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generateUploadFileProgress(contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: IHeaderDictionary | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/generate-upload-file-progress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateUploadFileProgress(_response));
        });
    }

    protected processGenerateUploadFileProgress(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class FormTemplatesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(fileName: string | null | undefined, remark: string | null | undefined): Promise<FormTemplateVm[]> {
        let url_ = this.baseUrl + "/api/FormTemplates?";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (remark !== undefined && remark !== null)
            url_ += "Remark=" + encodeURIComponent("" + remark) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<FormTemplateVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormTemplateVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormTemplateVm[]>(null as any);
    }

    create(file: FileParameter | null | undefined, remark: string | null | undefined): Promise<FormTemplateVm> {
        let url_ = this.baseUrl + "/api/FormTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (remark !== null && remark !== undefined)
            content_.append("Remark", remark.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<FormTemplateVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FormTemplateVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormTemplateVm>(null as any);
    }

    update(formTemplateId: number, id: number | undefined, file: FileParameter | null | undefined, remark: string | null | undefined): Promise<FormTemplateVm> {
        let url_ = this.baseUrl + "/api/FormTemplates/{formTemplateId}";
        if (formTemplateId === undefined || formTemplateId === null)
            throw new Error("The parameter 'formTemplateId' must be defined.");
        url_ = url_.replace("{formTemplateId}", encodeURIComponent("" + formTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (remark !== null && remark !== undefined)
            content_.append("Remark", remark.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FormTemplateVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormTemplateVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormTemplateVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/FormTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadFile(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/FormTemplates/{id}/Download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class HodogramClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAllHodogram(): Promise<HodogramVm[]> {
        let url_ = this.baseUrl + "/api/Hodogram";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllHodogram(_response));
        });
    }

    protected processGetAllHodogram(response: Response): Promise<HodogramVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HodogramVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HodogramVm[]>(null as any);
    }

    updateHodogram(command: UpdateEntireHodogramCommand): Promise<HodogramVm[]> {
        let url_ = this.baseUrl + "/api/Hodogram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateHodogram(_response));
        });
    }

    protected processUpdateHodogram(response: Response): Promise<HodogramVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HodogramVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HodogramVm[]>(null as any);
    }

    createProjectHodogram(projectId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Hodogram?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateProjectHodogram(_response));
        });
    }

    protected processCreateProjectHodogram(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAllProjectHodogram(projectId: number): Promise<ProjectHodogramVm[]> {
        let url_ = this.baseUrl + "/api/Hodogram/projectHodogram/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllProjectHodogram(_response));
        });
    }

    protected processGetAllProjectHodogram(response: Response): Promise<ProjectHodogramVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectHodogramVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectHodogramVm[]>(null as any);
    }

    updateProjectHodogram(command: UpdateProjectHodogramCommand): Promise<ProjectHodogramVm> {
        let url_ = this.baseUrl + "/api/Hodogram/projectHodogram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateProjectHodogram(_response));
        });
    }

    protected processUpdateProjectHodogram(response: Response): Promise<ProjectHodogramVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectHodogramVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectHodogramVm>(null as any);
    }
}

export class HolidaysClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(year: number | undefined): Promise<HolidayVm[]> {
        let url_ = this.baseUrl + "/api/Holidays?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<HolidayVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HolidayVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HolidayVm[]>(null as any);
    }
}

export class NewsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<NewsVm[]> {
        let url_ = this.baseUrl + "/api/News";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<NewsVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewsVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsVm[]>(null as any);
    }

    create(command: CreateNewsCommandOfNews): Promise<NewsVm> {
        let url_ = this.baseUrl + "/api/News";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<NewsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = NewsVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsVm>(null as any);
    }

    getById(id: number): Promise<NewsVm> {
        let url_ = this.baseUrl + "/api/News/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<NewsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsVm>(null as any);
    }

    update(id: number, command: UpdateNewsCommandOfNews): Promise<NewsVm> {
        let url_ = this.baseUrl + "/api/News/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<NewsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/News/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPaginated(filter_Title: string | null | undefined, filter_Text: string | null | undefined, filter_Date: Date | null | undefined, filter_Author: string | null | undefined, filter_IsArchived: boolean | null | undefined, filter_IsFeatured: boolean | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfNewsVm> {
        let url_ = this.baseUrl + "/api/News/search?";
        if (filter_Title !== undefined && filter_Title !== null)
            url_ += "Filter.Title=" + encodeURIComponent("" + filter_Title) + "&";
        if (filter_Text !== undefined && filter_Text !== null)
            url_ += "Filter.Text=" + encodeURIComponent("" + filter_Text) + "&";
        if (filter_Date !== undefined && filter_Date !== null)
            url_ += "Filter.Date=" + encodeURIComponent(filter_Date ? "" + filter_Date.toISOString() : "") + "&";
        if (filter_Author !== undefined && filter_Author !== null)
            url_ += "Filter.Author=" + encodeURIComponent("" + filter_Author) + "&";
        if (filter_IsArchived !== undefined && filter_IsArchived !== null)
            url_ += "Filter.IsArchived=" + encodeURIComponent("" + filter_IsArchived) + "&";
        if (filter_IsFeatured !== undefined && filter_IsFeatured !== null)
            url_ += "Filter.IsFeatured=" + encodeURIComponent("" + filter_IsFeatured) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfNewsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfNewsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfNewsVm>(null as any);
    }
}

export class PayrollsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(companyId: number | undefined, month: number | undefined, year: number | undefined): Promise<PayrollVm> {
        let url_ = this.baseUrl + "/api/Payrolls?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PayrollVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayrollVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayrollVm>(null as any);
    }

    createCalculations(command: CreatePayrollCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Payrolls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCalculations(_response));
        });
    }

    protected processCreateCalculations(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPaginated(filter_Employee_Name: string | null | undefined, filter_CompanyId: number | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined, month: number | undefined, year: number | undefined): Promise<PayrollPaginated> {
        let url_ = this.baseUrl + "/api/Payrolls/search?";
        if (filter_Employee_Name !== undefined && filter_Employee_Name !== null)
            url_ += "Filter.Employee_Name=" + encodeURIComponent("" + filter_Employee_Name) + "&";
        if (filter_CompanyId === null)
            throw new Error("The parameter 'filter_CompanyId' cannot be null.");
        else if (filter_CompanyId !== undefined)
            url_ += "Filter.CompanyId=" + encodeURIComponent("" + filter_CompanyId) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PayrollPaginated> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayrollPaginated.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayrollPaginated>(null as any);
    }

    update(id: number, command: UpdatePayrollCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Payrolls/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    toggleLockPayroll(id: number, command: ToggleLockPayrollCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Payrolls/{id}/toggle-lock";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processToggleLockPayroll(_response));
        });
    }

    protected processToggleLockPayroll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generatePayrollXlsx(payrollId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Payrolls/download/payroll?";
        if (payrollId === null)
            throw new Error("The parameter 'payrollId' cannot be null.");
        else if (payrollId !== undefined)
            url_ += "payrollId=" + encodeURIComponent("" + payrollId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeneratePayrollXlsx(_response));
        });
    }

    protected processGeneratePayrollXlsx(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generatePayrollFormalWorkHourRecordsXlsx(payrollId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Payrolls/download/payroll-hours?";
        if (payrollId === null)
            throw new Error("The parameter 'payrollId' cannot be null.");
        else if (payrollId !== undefined)
            url_ += "payrollId=" + encodeURIComponent("" + payrollId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeneratePayrollFormalWorkHourRecordsXlsx(_response));
        });
    }

    protected processGeneratePayrollFormalWorkHourRecordsXlsx(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PeopleScheduleClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generateXlsx(date: Date | undefined, type: PeopleScheduleXslxTypeEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PeopleSchedule/download?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateXlsx(_response));
        });
    }

    protected processGenerateXlsx(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectCooperatorItemsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<ProjectCooperatorItemVm> {
        let url_ = this.baseUrl + "/api/ProjectCooperatorItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ProjectCooperatorItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectCooperatorItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCooperatorItemVm>(null as any);
    }

    update(id: number, command: UpdateProjectCooperatorItemCommandOfProjectCooperatorItem): Promise<ProjectCooperatorItemVm> {
        let url_ = this.baseUrl + "/api/ProjectCooperatorItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ProjectCooperatorItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectCooperatorItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCooperatorItemVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ProjectCooperatorItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getProjectCooperatorItemsOverview(filter_Ordinal: number | undefined, filter_ProjectItem: string | null | undefined, filter_Unit: string | null | undefined, filter_Quantity: number | undefined, filter_UnitPrice: number | undefined, filter_TotalPrice: number | undefined, filter_Client: string | null | undefined, filter_Cooperator: string | null | undefined, filter_Project: string | null | undefined, filter_ProjectCode: string | null | undefined, filter_Year: number | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfProjectCooperatorItemsOverviewVm> {
        let url_ = this.baseUrl + "/api/ProjectCooperatorItems/search?";
        if (filter_Ordinal === null)
            throw new Error("The parameter 'filter_Ordinal' cannot be null.");
        else if (filter_Ordinal !== undefined)
            url_ += "Filter.Ordinal=" + encodeURIComponent("" + filter_Ordinal) + "&";
        if (filter_ProjectItem !== undefined && filter_ProjectItem !== null)
            url_ += "Filter.ProjectItem=" + encodeURIComponent("" + filter_ProjectItem) + "&";
        if (filter_Unit !== undefined && filter_Unit !== null)
            url_ += "Filter.Unit=" + encodeURIComponent("" + filter_Unit) + "&";
        if (filter_Quantity === null)
            throw new Error("The parameter 'filter_Quantity' cannot be null.");
        else if (filter_Quantity !== undefined)
            url_ += "Filter.Quantity=" + encodeURIComponent("" + filter_Quantity) + "&";
        if (filter_UnitPrice === null)
            throw new Error("The parameter 'filter_UnitPrice' cannot be null.");
        else if (filter_UnitPrice !== undefined)
            url_ += "Filter.UnitPrice=" + encodeURIComponent("" + filter_UnitPrice) + "&";
        if (filter_TotalPrice === null)
            throw new Error("The parameter 'filter_TotalPrice' cannot be null.");
        else if (filter_TotalPrice !== undefined)
            url_ += "Filter.TotalPrice=" + encodeURIComponent("" + filter_TotalPrice) + "&";
        if (filter_Client !== undefined && filter_Client !== null)
            url_ += "Filter.Client=" + encodeURIComponent("" + filter_Client) + "&";
        if (filter_Cooperator !== undefined && filter_Cooperator !== null)
            url_ += "Filter.Cooperator=" + encodeURIComponent("" + filter_Cooperator) + "&";
        if (filter_Project !== undefined && filter_Project !== null)
            url_ += "Filter.Project=" + encodeURIComponent("" + filter_Project) + "&";
        if (filter_ProjectCode !== undefined && filter_ProjectCode !== null)
            url_ += "Filter.ProjectCode=" + encodeURIComponent("" + filter_ProjectCode) + "&";
        if (filter_Year === null)
            throw new Error("The parameter 'filter_Year' cannot be null.");
        else if (filter_Year !== undefined)
            url_ += "Filter.Year=" + encodeURIComponent("" + filter_Year) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectCooperatorItemsOverview(_response));
        });
    }

    protected processGetProjectCooperatorItemsOverview(response: Response): Promise<PaginatedListOfProjectCooperatorItemsOverviewVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfProjectCooperatorItemsOverviewVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfProjectCooperatorItemsOverviewVm>(null as any);
    }

    create(command: CreateProjectCooperatorItemCommandOfProjectCooperatorItem): Promise<ProjectCooperatorItemVm> {
        let url_ = this.baseUrl + "/api/ProjectCooperatorItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjectCooperatorItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProjectCooperatorItemVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCooperatorItemVm>(null as any);
    }

    exportXLSX(filter_Ordinal: number | undefined, filter_ProjectItem: string | null | undefined, filter_Unit: string | null | undefined, filter_Quantity: number | undefined, filter_UnitPrice: number | undefined, filter_TotalPrice: number | undefined, filter_Client: string | null | undefined, filter_Cooperator: string | null | undefined, filter_Project: string | null | undefined, filter_ProjectCode: string | null | undefined, filter_Year: number | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectCooperatorItems/ExportXLSX?";
        if (filter_Ordinal === null)
            throw new Error("The parameter 'filter_Ordinal' cannot be null.");
        else if (filter_Ordinal !== undefined)
            url_ += "Filter.Ordinal=" + encodeURIComponent("" + filter_Ordinal) + "&";
        if (filter_ProjectItem !== undefined && filter_ProjectItem !== null)
            url_ += "Filter.ProjectItem=" + encodeURIComponent("" + filter_ProjectItem) + "&";
        if (filter_Unit !== undefined && filter_Unit !== null)
            url_ += "Filter.Unit=" + encodeURIComponent("" + filter_Unit) + "&";
        if (filter_Quantity === null)
            throw new Error("The parameter 'filter_Quantity' cannot be null.");
        else if (filter_Quantity !== undefined)
            url_ += "Filter.Quantity=" + encodeURIComponent("" + filter_Quantity) + "&";
        if (filter_UnitPrice === null)
            throw new Error("The parameter 'filter_UnitPrice' cannot be null.");
        else if (filter_UnitPrice !== undefined)
            url_ += "Filter.UnitPrice=" + encodeURIComponent("" + filter_UnitPrice) + "&";
        if (filter_TotalPrice === null)
            throw new Error("The parameter 'filter_TotalPrice' cannot be null.");
        else if (filter_TotalPrice !== undefined)
            url_ += "Filter.TotalPrice=" + encodeURIComponent("" + filter_TotalPrice) + "&";
        if (filter_Client !== undefined && filter_Client !== null)
            url_ += "Filter.Client=" + encodeURIComponent("" + filter_Client) + "&";
        if (filter_Cooperator !== undefined && filter_Cooperator !== null)
            url_ += "Filter.Cooperator=" + encodeURIComponent("" + filter_Cooperator) + "&";
        if (filter_Project !== undefined && filter_Project !== null)
            url_ += "Filter.Project=" + encodeURIComponent("" + filter_Project) + "&";
        if (filter_ProjectCode !== undefined && filter_ProjectCode !== null)
            url_ += "Filter.ProjectCode=" + encodeURIComponent("" + filter_ProjectCode) + "&";
        if (filter_Year === null)
            throw new Error("The parameter 'filter_Year' cannot be null.");
        else if (filter_Year !== undefined)
            url_ += "Filter.Year=" + encodeURIComponent("" + filter_Year) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXLSX(_response));
        });
    }

    protected processExportXLSX(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectCooperatorsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<ProjectCooperatorVm> {
        let url_ = this.baseUrl + "/api/ProjectCooperators/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ProjectCooperatorVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectCooperatorVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCooperatorVm>(null as any);
    }

    update(id: number, command: UpdateProjectCooperatorCommandOfProjectCooperator): Promise<ProjectCooperatorVm> {
        let url_ = this.baseUrl + "/api/ProjectCooperators/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ProjectCooperatorVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectCooperatorVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCooperatorVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ProjectCooperators/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    create(command: CreateProjectCooperatorCommandOfProjectCooperator): Promise<ProjectCooperatorVm> {
        let url_ = this.baseUrl + "/api/ProjectCooperators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjectCooperatorVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProjectCooperatorVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCooperatorVm>(null as any);
    }
}

export class ProjectEmployeesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<ProjectEmployeeVm> {
        let url_ = this.baseUrl + "/api/ProjectEmployees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ProjectEmployeeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectEmployeeVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectEmployeeVm>(null as any);
    }

    update(id: number, command: UpdateProjectEmployeeCommandOfProjectEmployee): Promise<ProjectEmployeeVm> {
        let url_ = this.baseUrl + "/api/ProjectEmployees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ProjectEmployeeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectEmployeeVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectEmployeeVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ProjectEmployees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    create(command: CreateProjectEmployeeCommandOfProjectEmployee): Promise<ProjectEmployeeVm> {
        let url_ = this.baseUrl + "/api/ProjectEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjectEmployeeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProjectEmployeeVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectEmployeeVm>(null as any);
    }
}

export class ProjectItemsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<ProjectItemVm> {
        let url_ = this.baseUrl + "/api/ProjectItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ProjectItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectItemVm>(null as any);
    }

    update(id: number, command: UpdateProjectItemCommandOfProjectItem): Promise<ProjectItemVm> {
        let url_ = this.baseUrl + "/api/ProjectItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ProjectItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectItemVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ProjectItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    create(command: CreateProjectItemCommand): Promise<ProjectItemVm> {
        let url_ = this.baseUrl + "/api/ProjectItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjectItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProjectItemVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectItemVm>(null as any);
    }
}

export class ProjectsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<ProjectVm[]> {
        let url_ = this.baseUrl + "/api/Projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ProjectVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectVm[]>(null as any);
    }

    create(command: CreateProjectCommandOfProject): Promise<ProjectDetailVm> {
        let url_ = this.baseUrl + "/api/Projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjectDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProjectDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDetailVm>(null as any);
    }

    getPaginated(filter_Name: string | null | undefined, filter_ShortName: string | null | undefined, filter_Address: string | null | undefined, filter_Country: string | null | undefined, filter_City: string | null | undefined, filter_Project_Investor: string | null | undefined, filter_ProjectStatusId: number[] | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfProjectVm> {
        let url_ = this.baseUrl + "/api/Projects/search?";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_ShortName !== undefined && filter_ShortName !== null)
            url_ += "Filter.ShortName=" + encodeURIComponent("" + filter_ShortName) + "&";
        if (filter_Address !== undefined && filter_Address !== null)
            url_ += "Filter.Address=" + encodeURIComponent("" + filter_Address) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (filter_City !== undefined && filter_City !== null)
            url_ += "Filter.City=" + encodeURIComponent("" + filter_City) + "&";
        if (filter_Project_Investor !== undefined && filter_Project_Investor !== null)
            url_ += "Filter.Project_Investor=" + encodeURIComponent("" + filter_Project_Investor) + "&";
        if (filter_ProjectStatusId !== undefined && filter_ProjectStatusId !== null)
            filter_ProjectStatusId && filter_ProjectStatusId.forEach(item => { url_ += "Filter.ProjectStatusId=" + encodeURIComponent("" + item) + "&"; });
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfProjectVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfProjectVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfProjectVm>(null as any);
    }

    getById(id: number): Promise<ProjectDetailVm> {
        let url_ = this.baseUrl + "/api/Projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ProjectDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDetailVm>(null as any);
    }

    update(id: number, command: UpdateProjectCommandOfProject): Promise<ProjectDetailVm> {
        let url_ = this.baseUrl + "/api/Projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ProjectDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getProjectCooperators(projectId: number): Promise<ProjectCooperatorVm[]> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ProjectCooperators";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectCooperators(_response));
        });
    }

    protected processGetProjectCooperators(response: Response): Promise<ProjectCooperatorVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectCooperatorVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCooperatorVm[]>(null as any);
    }

    getProjectCooperatorItems(projectId: number): Promise<ProjectCooperatorItemVm[]> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ProjectCooperatorItems";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectCooperatorItems(_response));
        });
    }

    protected processGetProjectCooperatorItems(response: Response): Promise<ProjectCooperatorItemVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectCooperatorItemVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCooperatorItemVm[]>(null as any);
    }

    getProjectDocuments(projectId: number): Promise<AttachmentVm[]> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ProjectDocuments";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectDocuments(_response));
        });
    }

    protected processGetProjectDocuments(response: Response): Promise<AttachmentVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentVm[]>(null as any);
    }

    getProjectEmployees(projectId: number, status: string | null | undefined): Promise<ProjectEmployeeVm[]> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ProjectEmployees?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectEmployees(_response));
        });
    }

    protected processGetProjectEmployees(response: Response): Promise<ProjectEmployeeVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectEmployeeVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectEmployeeVm[]>(null as any);
    }

    getProjectItems(projectId: number): Promise<ProjectItemVm[]> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ProjectItems";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectItems(_response));
        });
    }

    protected processGetProjectItems(response: Response): Promise<ProjectItemVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectItemVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectItemVm[]>(null as any);
    }

    getProjectSituations(projectId: number): Promise<ProjectSituationVm[]> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ProjectSituations";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectSituations(_response));
        });
    }

    protected processGetProjectSituations(response: Response): Promise<ProjectSituationVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectSituationVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSituationVm[]>(null as any);
    }

    getProjectSituationItems(projectId: number): Promise<ProjectSituationItemVm[]> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ProjectSituationItems";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectSituationItems(_response));
        });
    }

    protected processGetProjectSituationItems(response: Response): Promise<ProjectSituationItemVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectSituationItemVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSituationItemVm[]>(null as any);
    }

    importProjectItems(projectId: number, sheetName: string | null | undefined, excelRange: string | null | undefined, labelOrder: string | null | undefined, file: FileParameter | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ImportProjectItems?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (sheetName !== undefined && sheetName !== null)
            url_ += "sheetName=" + encodeURIComponent("" + sheetName) + "&";
        if (excelRange !== undefined && excelRange !== null)
            url_ += "excelRange=" + encodeURIComponent("" + excelRange) + "&";
        if (labelOrder !== undefined && labelOrder !== null)
            url_ += "labelOrder=" + encodeURIComponent("" + labelOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportProjectItems(_response));
        });
    }

    protected processImportProjectItems(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    exportProjectItems(projectId: number, labelOrder: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ExportProjectItems?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (labelOrder !== undefined && labelOrder !== null)
            url_ += "labelOrder=" + encodeURIComponent("" + labelOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportProjectItems(_response));
        });
    }

    protected processExportProjectItems(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    importProjectContractorItems(projectId: number, contractorId: number | undefined, sheetName: string | null | undefined, excelRange: string | null | undefined, labelOrder: string | null | undefined, file: FileParameter | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ImportProjectContractorItems?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (contractorId === null)
            throw new Error("The parameter 'contractorId' cannot be null.");
        else if (contractorId !== undefined)
            url_ += "contractorId=" + encodeURIComponent("" + contractorId) + "&";
        if (sheetName !== undefined && sheetName !== null)
            url_ += "sheetName=" + encodeURIComponent("" + sheetName) + "&";
        if (excelRange !== undefined && excelRange !== null)
            url_ += "excelRange=" + encodeURIComponent("" + excelRange) + "&";
        if (labelOrder !== undefined && labelOrder !== null)
            url_ += "labelOrder=" + encodeURIComponent("" + labelOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportProjectContractorItems(_response));
        });
    }

    protected processImportProjectContractorItems(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    exportProjectContractorItems(projectId: number, contractorId: number | undefined, labelOrder: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ExportProjectContractorItems?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (contractorId === null)
            throw new Error("The parameter 'contractorId' cannot be null.");
        else if (contractorId !== undefined)
            url_ += "contractorId=" + encodeURIComponent("" + contractorId) + "&";
        if (labelOrder !== undefined && labelOrder !== null)
            url_ += "labelOrder=" + encodeURIComponent("" + labelOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportProjectContractorItems(_response));
        });
    }

    protected processExportProjectContractorItems(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportProjectSituationItems(projectId: number, situationId: number | undefined, labelOrder: string | null | undefined, contractorId: number | null | undefined, subcontractorIds: string | null | undefined, showAllItems: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ExportProjectSituationItems?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (situationId === null)
            throw new Error("The parameter 'situationId' cannot be null.");
        else if (situationId !== undefined)
            url_ += "situationId=" + encodeURIComponent("" + situationId) + "&";
        if (labelOrder !== undefined && labelOrder !== null)
            url_ += "labelOrder=" + encodeURIComponent("" + labelOrder) + "&";
        if (contractorId !== undefined && contractorId !== null)
            url_ += "contractorId=" + encodeURIComponent("" + contractorId) + "&";
        if (subcontractorIds !== undefined && subcontractorIds !== null)
            url_ += "subcontractorIds=" + encodeURIComponent("" + subcontractorIds) + "&";
        if (showAllItems === null)
            throw new Error("The parameter 'showAllItems' cannot be null.");
        else if (showAllItems !== undefined)
            url_ += "showAllItems=" + encodeURIComponent("" + showAllItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportProjectSituationItems(_response));
        });
    }

    protected processExportProjectSituationItems(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    importProjectSituationItems(projectId: number, situationId: number | undefined, contractorId: number | null | undefined, sheetName: string | null | undefined, excelRange: string | null | undefined, labelOrder: string | null | undefined, data: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/ImportProjectSituationItems?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (situationId === null)
            throw new Error("The parameter 'situationId' cannot be null.");
        else if (situationId !== undefined)
            url_ += "situationId=" + encodeURIComponent("" + situationId) + "&";
        if (contractorId !== undefined && contractorId !== null)
            url_ += "contractorId=" + encodeURIComponent("" + contractorId) + "&";
        if (sheetName !== undefined && sheetName !== null)
            url_ += "sheetName=" + encodeURIComponent("" + sheetName) + "&";
        if (excelRange !== undefined && excelRange !== null)
            url_ += "excelRange=" + encodeURIComponent("" + excelRange) + "&";
        if (labelOrder !== undefined && labelOrder !== null)
            url_ += "labelOrder=" + encodeURIComponent("" + labelOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data !== null && data !== undefined)
            content_.append("data", data.data, data.fileName ? data.fileName : "data");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportProjectSituationItems(_response));
        });
    }

    protected processImportProjectSituationItems(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectSituationItemsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<ProjectSituationItemVm> {
        let url_ = this.baseUrl + "/api/ProjectSituationItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ProjectSituationItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSituationItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSituationItemVm>(null as any);
    }

    update(id: number, command: UpdateProjectSituationItemCommandOfProjectSituationItem): Promise<ProjectSituationItemVm> {
        let url_ = this.baseUrl + "/api/ProjectSituationItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ProjectSituationItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSituationItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSituationItemVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ProjectSituationItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    create(command: CreateProjectSituationItemCommandOfProjectSituationItem): Promise<ProjectSituationItemVm> {
        let url_ = this.baseUrl + "/api/ProjectSituationItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjectSituationItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProjectSituationItemVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSituationItemVm>(null as any);
    }
}

export class ProjectSituationsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<ProjectSituationVm> {
        let url_ = this.baseUrl + "/api/ProjectSituations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ProjectSituationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSituationVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSituationVm>(null as any);
    }

    update(id: number, command: UpdateProjectSituationCommandOfProjectSituation): Promise<ProjectSituationVm> {
        let url_ = this.baseUrl + "/api/ProjectSituations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ProjectSituationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSituationVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSituationVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ProjectSituations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    create(command: CreateProjectSituationCommandOfProjectSituation): Promise<ProjectSituationVm> {
        let url_ = this.baseUrl + "/api/ProjectSituations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjectSituationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProjectSituationVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSituationVm>(null as any);
    }
}

export class SalariesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(companyId: number | undefined, month: number | undefined, year: number | undefined): Promise<EmployeeSalaryVm[]> {
        let url_ = this.baseUrl + "/api/Salaries?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<EmployeeSalaryVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeSalaryVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeSalaryVm[]>(null as any);
    }

    create(command: CreateSalaryCommand): Promise<SalaryVm> {
        let url_ = this.baseUrl + "/api/Salaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<SalaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SalaryVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalaryVm>(null as any);
    }

    getPaginated(filter_Employee_Name: string | null | undefined, filter_CompanyId: number | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined, month: number | undefined, year: number | undefined): Promise<SalariesPaginatedListOfEmployeeSalaryVm> {
        let url_ = this.baseUrl + "/api/Salaries/search?";
        if (filter_Employee_Name !== undefined && filter_Employee_Name !== null)
            url_ += "Filter.Employee_Name=" + encodeURIComponent("" + filter_Employee_Name) + "&";
        if (filter_CompanyId === null)
            throw new Error("The parameter 'filter_CompanyId' cannot be null.");
        else if (filter_CompanyId !== undefined)
            url_ += "Filter.CompanyId=" + encodeURIComponent("" + filter_CompanyId) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<SalariesPaginatedListOfEmployeeSalaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalariesPaginatedListOfEmployeeSalaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalariesPaginatedListOfEmployeeSalaryVm>(null as any);
    }

    getById(id: number): Promise<EmployeeSalaryVm> {
        let url_ = this.baseUrl + "/api/Salaries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<EmployeeSalaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeSalaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeSalaryVm>(null as any);
    }

    update(id: number, command: UpdateSalaryCommand): Promise<SalaryVm> {
        let url_ = this.baseUrl + "/api/Salaries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<SalaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalaryVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Salaries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    copyBatch(command: CopySalariesCommand): Promise<SalaryVm[]> {
        let url_ = this.baseUrl + "/api/Salaries/CopyBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopyBatch(_response));
        });
    }

    protected processCopyBatch(response: Response): Promise<SalaryVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalaryVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalaryVm[]>(null as any);
    }

    exportSalaries(command: ExportSalariesXlsxCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Salaries/ExportSalaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportSalaries(_response));
        });
    }

    protected processExportSalaries(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ToolsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<ToolVm[]> {
        let url_ = this.baseUrl + "/api/Tools";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ToolVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ToolVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ToolVm[]>(null as any);
    }

    create(command: CreateToolCommandOfTool): Promise<ToolDetailVm> {
        let url_ = this.baseUrl + "/api/Tools";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ToolDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ToolDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ToolDetailVm>(null as any);
    }

    getById(id: number): Promise<ToolDetailVm> {
        let url_ = this.baseUrl + "/api/Tools/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ToolDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ToolDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ToolDetailVm>(null as any);
    }

    update(id: number, command: UpdateToolCommandOfTool): Promise<ToolDetailVm> {
        let url_ = this.baseUrl + "/api/Tools/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ToolDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ToolDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ToolDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Tools/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPaginated(filter_Name: string | null | undefined, filter_Description: string | null | undefined, filter_IsArchived: boolean | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfToolVm> {
        let url_ = this.baseUrl + "/api/Tools/search?";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Description !== undefined && filter_Description !== null)
            url_ += "Filter.Description=" + encodeURIComponent("" + filter_Description) + "&";
        if (filter_IsArchived !== undefined && filter_IsArchived !== null)
            url_ += "Filter.IsArchived=" + encodeURIComponent("" + filter_IsArchived) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfToolVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfToolVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfToolVm>(null as any);
    }

    getToolDocuments(toolId: number): Promise<AttachmentVm[]> {
        let url_ = this.baseUrl + "/api/Tools/{toolId}/documents";
        if (toolId === undefined || toolId === null)
            throw new Error("The parameter 'toolId' must be defined.");
        url_ = url_.replace("{toolId}", encodeURIComponent("" + toolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetToolDocuments(_response));
        });
    }

    protected processGetToolDocuments(response: Response): Promise<AttachmentVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentVm[]>(null as any);
    }
}

export class UnitOfMeasurementsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<UnitOfMeasurementVm> {
        let url_ = this.baseUrl + "/api/UnitOfMeasurements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<UnitOfMeasurementVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitOfMeasurementVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitOfMeasurementVm>(null as any);
    }

    update(id: number, command: UpdateUnitOfMeasurementCommandOfUnitOfMeasurement): Promise<UnitOfMeasurementVm> {
        let url_ = this.baseUrl + "/api/UnitOfMeasurements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<UnitOfMeasurementVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitOfMeasurementVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitOfMeasurementVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/UnitOfMeasurements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAll(): Promise<UnitOfMeasurementVm[]> {
        let url_ = this.baseUrl + "/api/UnitOfMeasurements";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<UnitOfMeasurementVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitOfMeasurementVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitOfMeasurementVm[]>(null as any);
    }

    create(command: CreateUnitOfMeasurementCommandOfUnitOfMeasurement): Promise<UnitOfMeasurementVm> {
        let url_ = this.baseUrl + "/api/UnitOfMeasurements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<UnitOfMeasurementVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UnitOfMeasurementVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitOfMeasurementVm>(null as any);
    }
}

export class UsersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(inactive: boolean | undefined): Promise<UserVm[]> {
        let url_ = this.baseUrl + "/api/Users?";
        if (inactive === null)
            throw new Error("The parameter 'inactive' cannot be null.");
        else if (inactive !== undefined)
            url_ += "inactive=" + encodeURIComponent("" + inactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<UserVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm[]>(null as any);
    }

    create(command: CreateUserCommand): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UserVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm>(null as any);
    }

    getById(id: string): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm>(null as any);
    }

    update(id: string, command: UpdateUserCommand): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm>(null as any);
    }

    delete(id: string): Promise<string> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class VerificationsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(fileName: string | null | undefined, url: string | null | undefined, verificationStatusId: VerificationStatusEnum | undefined, verificationStatus: string | null | undefined, remark: string | null | undefined, projectId: number | null | undefined, documentId: number | null | undefined, createdById: string | null | undefined, verificationsStatusId: number[] | null | undefined): Promise<VerificationVm[]> {
        let url_ = this.baseUrl + "/api/Verifications?";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (url !== undefined && url !== null)
            url_ += "Url=" + encodeURIComponent("" + url) + "&";
        if (verificationStatusId === null)
            throw new Error("The parameter 'verificationStatusId' cannot be null.");
        else if (verificationStatusId !== undefined)
            url_ += "VerificationStatusId=" + encodeURIComponent("" + verificationStatusId) + "&";
        if (verificationStatus !== undefined && verificationStatus !== null)
            url_ += "VerificationStatus=" + encodeURIComponent("" + verificationStatus) + "&";
        if (remark !== undefined && remark !== null)
            url_ += "Remark=" + encodeURIComponent("" + remark) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (createdById !== undefined && createdById !== null)
            url_ += "CreatedById=" + encodeURIComponent("" + createdById) + "&";
        if (verificationsStatusId !== undefined && verificationsStatusId !== null)
            verificationsStatusId && verificationsStatusId.forEach(item => { url_ += "VerificationsStatusId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<VerificationVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VerificationVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationVm[]>(null as any);
    }

    create(file: FileParameter | null | undefined, projectId: number | null | undefined, documentId: number | null | undefined, verificationStatusId: VerificationStatusEnum | undefined, remark: string | null | undefined): Promise<VerificationVm> {
        let url_ = this.baseUrl + "/api/Verifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (documentId !== null && documentId !== undefined)
            content_.append("DocumentId", documentId.toString());
        if (verificationStatusId === null || verificationStatusId === undefined)
            throw new Error("The parameter 'verificationStatusId' cannot be null.");
        else
            content_.append("VerificationStatusId", verificationStatusId.toString());
        if (remark !== null && remark !== undefined)
            content_.append("Remark", remark.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<VerificationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = VerificationVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationVm>(null as any);
    }

    update(verificationId: number, id: number | undefined, file: FileParameter | null | undefined, projectId: number | null | undefined, documentId: number | null | undefined, verificationStatusId: VerificationStatusEnum | undefined, remark: string | null | undefined): Promise<VerificationVm> {
        let url_ = this.baseUrl + "/api/Verifications/{verificationId}";
        if (verificationId === undefined || verificationId === null)
            throw new Error("The parameter 'verificationId' must be defined.");
        url_ = url_.replace("{verificationId}", encodeURIComponent("" + verificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (documentId !== null && documentId !== undefined)
            content_.append("DocumentId", documentId.toString());
        if (verificationStatusId === null || verificationStatusId === undefined)
            throw new Error("The parameter 'verificationStatusId' cannot be null.");
        else
            content_.append("VerificationStatusId", verificationStatusId.toString());
        if (remark !== null && remark !== undefined)
            content_.append("Remark", remark.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<VerificationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Verifications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadFile(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Verifications/{id}/Download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class WarehouseClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<WarehouseVm[]> {
        let url_ = this.baseUrl + "/api/Warehouse";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<WarehouseVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseVm[]>(null as any);
    }

    getPaginated(filter_ProjectId: number | null | undefined, filter_Project_Name: string | null | undefined, filter_Project_Address: string | null | undefined, filter_Project_City_NameUniversal: string | null | undefined, filter_Project_Country_NameUniversal: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfWarehouseVm> {
        let url_ = this.baseUrl + "/api/Warehouse/search?";
        if (filter_ProjectId !== undefined && filter_ProjectId !== null)
            url_ += "Filter.ProjectId=" + encodeURIComponent("" + filter_ProjectId) + "&";
        if (filter_Project_Name !== undefined && filter_Project_Name !== null)
            url_ += "Filter.Project_Name=" + encodeURIComponent("" + filter_Project_Name) + "&";
        if (filter_Project_Address !== undefined && filter_Project_Address !== null)
            url_ += "Filter.Project_Address=" + encodeURIComponent("" + filter_Project_Address) + "&";
        if (filter_Project_City_NameUniversal !== undefined && filter_Project_City_NameUniversal !== null)
            url_ += "Filter.Project_City_NameUniversal=" + encodeURIComponent("" + filter_Project_City_NameUniversal) + "&";
        if (filter_Project_Country_NameUniversal !== undefined && filter_Project_Country_NameUniversal !== null)
            url_ += "Filter.Project_Country_NameUniversal=" + encodeURIComponent("" + filter_Project_Country_NameUniversal) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfWarehouseVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfWarehouseVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfWarehouseVm>(null as any);
    }

    getById(id: number): Promise<WarehouseDetailVm> {
        let url_ = this.baseUrl + "/api/Warehouse/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<WarehouseDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDetailVm>(null as any);
    }

    getByProjectId(id: number): Promise<WarehouseDetailVm> {
        let url_ = this.baseUrl + "/api/Warehouse/project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByProjectId(_response));
        });
    }

    protected processGetByProjectId(response: Response): Promise<WarehouseDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDetailVm>(null as any);
    }

    getWarehouseItems(warehouseId: number, filter_WarehouseId: number | null | undefined, filter_Name: string | null | undefined, filter_Supplier_Name: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfWarehouseItemVm> {
        let url_ = this.baseUrl + "/api/Warehouse/{warehouseId}/WarehouseItems?";
        if (warehouseId === undefined || warehouseId === null)
            throw new Error("The parameter 'warehouseId' must be defined.");
        url_ = url_.replace("{warehouseId}", encodeURIComponent("" + warehouseId));
        if (filter_WarehouseId !== undefined && filter_WarehouseId !== null)
            url_ += "Filter.WarehouseId=" + encodeURIComponent("" + filter_WarehouseId) + "&";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Supplier_Name !== undefined && filter_Supplier_Name !== null)
            url_ += "Filter.Supplier_Name=" + encodeURIComponent("" + filter_Supplier_Name) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWarehouseItems(_response));
        });
    }

    protected processGetWarehouseItems(response: Response): Promise<PaginatedListOfWarehouseItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfWarehouseItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfWarehouseItemVm>(null as any);
    }
}

export class WarehouseItemsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<WarehouseItemVm[]> {
        let url_ = this.baseUrl + "/api/WarehouseItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<WarehouseItemVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseItemVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseItemVm[]>(null as any);
    }

    getPaginated(filter_WarehouseId: number | null | undefined, filter_Name: string | null | undefined, filter_Supplier_Name: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfWarehouseItemVm> {
        let url_ = this.baseUrl + "/api/WarehouseItems/search?";
        if (filter_WarehouseId !== undefined && filter_WarehouseId !== null)
            url_ += "Filter.WarehouseId=" + encodeURIComponent("" + filter_WarehouseId) + "&";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Supplier_Name !== undefined && filter_Supplier_Name !== null)
            url_ += "Filter.Supplier_Name=" + encodeURIComponent("" + filter_Supplier_Name) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfWarehouseItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfWarehouseItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfWarehouseItemVm>(null as any);
    }

    getById(id: number): Promise<WarehouseItemVm> {
        let url_ = this.baseUrl + "/api/WarehouseItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<WarehouseItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseItemVm>(null as any);
    }

    update(id: number, command: UpdateWarehouseItemCommandOfWarehouseItem): Promise<WarehouseItemVm> {
        let url_ = this.baseUrl + "/api/WarehouseItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<WarehouseItemVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseItemVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseItemVm>(null as any);
    }

    projectHasWarehouseItems(projectId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/WarehouseItems/hasWarehouseItems/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProjectHasWarehouseItems(_response));
        });
    }

    protected processProjectHasWarehouseItems(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class WorkHourRecordsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<WorkHourRecordVm> {
        let url_ = this.baseUrl + "/api/WorkHourRecords/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<WorkHourRecordVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkHourRecordVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkHourRecordVm>(null as any);
    }

    update(id: number, command: UpdateWorkHourRecordCommand): Promise<WorkHourRecordVm> {
        let url_ = this.baseUrl + "/api/WorkHourRecords/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<WorkHourRecordVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkHourRecordVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkHourRecordVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/WorkHourRecords/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getWorkHourRecords(projectId: number | null | undefined, employeeId: number | null | undefined, year: number | undefined, month: number | undefined): Promise<WorkHourRecordVm[]> {
        let url_ = this.baseUrl + "/api/WorkHourRecords?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkHourRecords(_response));
        });
    }

    protected processGetWorkHourRecords(response: Response): Promise<WorkHourRecordVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkHourRecordVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkHourRecordVm[]>(null as any);
    }

    create(command: CreateWorkHourRecordCommand): Promise<WorkHourRecordVm> {
        let url_ = this.baseUrl + "/api/WorkHourRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<WorkHourRecordVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WorkHourRecordVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkHourRecordVm>(null as any);
    }

    copyBatch(command: CopyWorkHourRecordCommand): Promise<WorkHourRecordVm[]> {
        let url_ = this.baseUrl + "/api/WorkHourRecords/CopyBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopyBatch(_response));
        });
    }

    protected processCopyBatch(response: Response): Promise<WorkHourRecordVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkHourRecordVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkHourRecordVm[]>(null as any);
    }

    exportByDay(command: ExportWorkHourRecordsByDayXlsxCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/WorkHourRecords/ExportXlsx";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportByDay(_response));
        });
    }

    protected processExportByDay(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportByProject(command: ExportWorkHourRecordsByProjectsXlsxCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/WorkHourRecords/ExportSummedXlsx";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportByProject(_response));
        });
    }

    protected processExportByProject(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    import(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/WorkHourRecords/ImportEmployeeGearXlsx";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateAllProjectsWorkHourDeadline(command: UpdateAllProjectsWorkHourDeadlineCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/WorkHourRecords/UpdateAllProjectsWorkHourDeadline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAllProjectsWorkHourDeadline(_response));
        });
    }

    protected processUpdateAllProjectsWorkHourDeadline(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class WorkRecordCoefficientsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<WorkRecordCoefficientVm[]> {
        let url_ = this.baseUrl + "/api/WorkRecordCoefficients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<WorkRecordCoefficientVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkRecordCoefficientVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkRecordCoefficientVm[]>(null as any);
    }

    create(command: CreateWorkRecordCoefficientCommandOfWorkRecordCoefficient): Promise<WorkRecordCoefficientVm> {
        let url_ = this.baseUrl + "/api/WorkRecordCoefficients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<WorkRecordCoefficientVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WorkRecordCoefficientVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkRecordCoefficientVm>(null as any);
    }

    getById(id: number): Promise<WorkRecordCoefficientVm> {
        let url_ = this.baseUrl + "/api/WorkRecordCoefficients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<WorkRecordCoefficientVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkRecordCoefficientVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkRecordCoefficientVm>(null as any);
    }

    update(id: number, command: UpdateWorkRecordCoefficientCommandOfWorkRecordCoefficient): Promise<WorkRecordCoefficientVm> {
        let url_ = this.baseUrl + "/api/WorkRecordCoefficients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<WorkRecordCoefficientVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkRecordCoefficientVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkRecordCoefficientVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/WorkRecordCoefficients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AttachmentVm implements IAttachmentVm {
    id!: number;
    fileName!: string;
    url!: string;
    description!: string | undefined;
    projectId!: number | undefined;
    employeeId!: number | undefined;
    documentId!: number | undefined;
    projectHodogramId!: number | undefined;
    toolId!: number | undefined;
    isMultimedia!: boolean;
    createdBy!: string | undefined;
    createdDate!: Date;

    constructor(data?: IAttachmentVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.employeeId = _data["employeeId"];
            this.documentId = _data["documentId"];
            this.projectHodogramId = _data["projectHodogramId"];
            this.toolId = _data["toolId"];
            this.isMultimedia = _data["isMultimedia"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AttachmentVm {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["employeeId"] = this.employeeId;
        data["documentId"] = this.documentId;
        data["projectHodogramId"] = this.projectHodogramId;
        data["toolId"] = this.toolId;
        data["isMultimedia"] = this.isMultimedia;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAttachmentVm {
    id: number;
    fileName: string;
    url: string;
    description: string | undefined;
    projectId: number | undefined;
    employeeId: number | undefined;
    documentId: number | undefined;
    projectHodogramId: number | undefined;
    toolId: number | undefined;
    isMultimedia: boolean;
    createdBy: string | undefined;
    createdDate: Date;
}

export class CityVm implements ICityVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    countryId!: number;
    country!: string;

    constructor(data?: ICityVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CityVm {
        data = typeof data === 'object' ? data : {};
        let result = new CityVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        return data;
    }
}

export interface ICityVm {
    id: number;
    name: string;
    nameUniversal: string;
    countryId: number;
    country: string;
}

export class CreateCityCommandOfCity implements ICreateCityCommandOfCity {
    name!: string;
    nameUniversal!: string;
    countryId!: number;

    constructor(data?: ICreateCityCommandOfCity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CreateCityCommandOfCity {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCityCommandOfCity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ICreateCityCommandOfCity {
    name: string;
    nameUniversal: string;
    countryId: number;
}

export class UpdateCityCommandOfCity extends CreateCityCommandOfCity implements IUpdateCityCommandOfCity {
    id!: number;

    constructor(data?: IUpdateCityCommandOfCity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCityCommandOfCity {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCityCommandOfCity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCityCommandOfCity extends ICreateCityCommandOfCity {
    id: number;
}

export class SelectOptionVm implements ISelectOptionVm {
    value!: number;
    label!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    disabled!: boolean;

    constructor(data?: ISelectOptionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): SelectOptionVm {
        data = typeof data === 'object' ? data : {};
        let result = new SelectOptionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["name"] = this.name;
        data["description"] = this.description;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface ISelectOptionVm {
    value: number;
    label: string | undefined;
    name: string | undefined;
    description: string | undefined;
    disabled: boolean;
}

export class CompanyVm implements ICompanyVm {
    id!: number;
    name!: string;

    constructor(data?: ICompanyVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CompanyVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICompanyVm {
    id: number;
    name: string;
}

export class ConfigurableConstantsVm implements IConfigurableConstantsVm {
    id!: number;
    hourlyRateDividerBOL!: number;
    hourlyRateDividerBOLWorkInjury!: number;
    hourlyRateDividerGO!: number;
    amountOfFieldAllowance!: number;
    maxAmountOfAnnualBonus!: number;
    maxAmountOfFieldAllowance!: number;

    constructor(data?: IConfigurableConstantsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hourlyRateDividerBOL = _data["hourlyRateDividerBOL"];
            this.hourlyRateDividerBOLWorkInjury = _data["hourlyRateDividerBOLWorkInjury"];
            this.hourlyRateDividerGO = _data["hourlyRateDividerGO"];
            this.amountOfFieldAllowance = _data["amountOfFieldAllowance"];
            this.maxAmountOfAnnualBonus = _data["maxAmountOfAnnualBonus"];
            this.maxAmountOfFieldAllowance = _data["maxAmountOfFieldAllowance"];
        }
    }

    static fromJS(data: any): ConfigurableConstantsVm {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurableConstantsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hourlyRateDividerBOL"] = this.hourlyRateDividerBOL;
        data["hourlyRateDividerBOLWorkInjury"] = this.hourlyRateDividerBOLWorkInjury;
        data["hourlyRateDividerGO"] = this.hourlyRateDividerGO;
        data["amountOfFieldAllowance"] = this.amountOfFieldAllowance;
        data["maxAmountOfAnnualBonus"] = this.maxAmountOfAnnualBonus;
        data["maxAmountOfFieldAllowance"] = this.maxAmountOfFieldAllowance;
        return data;
    }
}

export interface IConfigurableConstantsVm {
    id: number;
    hourlyRateDividerBOL: number;
    hourlyRateDividerBOLWorkInjury: number;
    hourlyRateDividerGO: number;
    amountOfFieldAllowance: number;
    maxAmountOfAnnualBonus: number;
    maxAmountOfFieldAllowance: number;
}

export class UpdateConfigurableConstantsCommand implements IUpdateConfigurableConstantsCommand {
    id!: number;
    hourlyRateDividerBOL!: number;
    hourlyRateDividerBOLWorkInjury!: number;
    hourlyRateDividerGO!: number;
    amountOfFieldAllowance!: number;
    maxAmountOfAnnualBonus!: number;
    maxAmountOfFieldAllowance!: number;

    constructor(data?: IUpdateConfigurableConstantsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hourlyRateDividerBOL = _data["hourlyRateDividerBOL"];
            this.hourlyRateDividerBOLWorkInjury = _data["hourlyRateDividerBOLWorkInjury"];
            this.hourlyRateDividerGO = _data["hourlyRateDividerGO"];
            this.amountOfFieldAllowance = _data["amountOfFieldAllowance"];
            this.maxAmountOfAnnualBonus = _data["maxAmountOfAnnualBonus"];
            this.maxAmountOfFieldAllowance = _data["maxAmountOfFieldAllowance"];
        }
    }

    static fromJS(data: any): UpdateConfigurableConstantsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigurableConstantsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hourlyRateDividerBOL"] = this.hourlyRateDividerBOL;
        data["hourlyRateDividerBOLWorkInjury"] = this.hourlyRateDividerBOLWorkInjury;
        data["hourlyRateDividerGO"] = this.hourlyRateDividerGO;
        data["amountOfFieldAllowance"] = this.amountOfFieldAllowance;
        data["maxAmountOfAnnualBonus"] = this.maxAmountOfAnnualBonus;
        data["maxAmountOfFieldAllowance"] = this.maxAmountOfFieldAllowance;
        return data;
    }
}

export interface IUpdateConfigurableConstantsCommand {
    id: number;
    hourlyRateDividerBOL: number;
    hourlyRateDividerBOLWorkInjury: number;
    hourlyRateDividerGO: number;
    amountOfFieldAllowance: number;
    maxAmountOfAnnualBonus: number;
    maxAmountOfFieldAllowance: number;
}

export class CooperatorContactVm implements ICooperatorContactVm {
    id!: number;
    cooperatorId!: number;
    name!: string;
    email!: string | undefined;
    phone!: string | undefined;
    address!: string | undefined;
    cityId!: number | undefined;
    countryId!: number | undefined;
    cityName!: string | undefined;
    countryName!: string | undefined;
    cooperatorName!: string | undefined;

    constructor(data?: ICooperatorContactVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cooperatorId = _data["cooperatorId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.cityId = _data["cityId"];
            this.countryId = _data["countryId"];
            this.cityName = _data["cityName"];
            this.countryName = _data["countryName"];
            this.cooperatorName = _data["cooperatorName"];
        }
    }

    static fromJS(data: any): CooperatorContactVm {
        data = typeof data === 'object' ? data : {};
        let result = new CooperatorContactVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cooperatorId"] = this.cooperatorId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["cityName"] = this.cityName;
        data["countryName"] = this.countryName;
        data["cooperatorName"] = this.cooperatorName;
        return data;
    }
}

export interface ICooperatorContactVm {
    id: number;
    cooperatorId: number;
    name: string;
    email: string | undefined;
    phone: string | undefined;
    address: string | undefined;
    cityId: number | undefined;
    countryId: number | undefined;
    cityName: string | undefined;
    countryName: string | undefined;
    cooperatorName: string | undefined;
}

export class CreateCooperatorContactCommandOfCooperatorContact implements ICreateCooperatorContactCommandOfCooperatorContact {
    cooperatorId!: number;
    name!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    address!: string | undefined;
    cityId!: number | undefined;
    countryId!: number | undefined;

    constructor(data?: ICreateCooperatorContactCommandOfCooperatorContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cooperatorId = _data["cooperatorId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.cityId = _data["cityId"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CreateCooperatorContactCommandOfCooperatorContact {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCooperatorContactCommandOfCooperatorContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cooperatorId"] = this.cooperatorId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ICreateCooperatorContactCommandOfCooperatorContact {
    cooperatorId: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    address: string | undefined;
    cityId: number | undefined;
    countryId: number | undefined;
}

export class UpdateCooperatorContactCommandOfCooperatorContact extends CreateCooperatorContactCommandOfCooperatorContact implements IUpdateCooperatorContactCommandOfCooperatorContact {
    id!: number;

    constructor(data?: IUpdateCooperatorContactCommandOfCooperatorContact) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCooperatorContactCommandOfCooperatorContact {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCooperatorContactCommandOfCooperatorContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCooperatorContactCommandOfCooperatorContact extends ICreateCooperatorContactCommandOfCooperatorContact {
    id: number;
}

export class CooperatorVm implements ICooperatorVm {
    id!: number;
    name!: string;
    oib!: string | undefined;
    personTypeId!: PersonTypeEnum;
    associateTypeId!: AssociateTypeEnum;
    mbg!: string | undefined;
    mb!: string | undefined;
    address!: string | undefined;
    zip!: string | undefined;
    cityId!: number | undefined;
    countryId!: number | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    web!: string | undefined;
    iban!: string | undefined;
    city!: string | undefined;
    country!: string | undefined;
    personType!: string | undefined;
    associateType!: string | undefined;

    constructor(data?: ICooperatorVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.oib = _data["oib"];
            this.personTypeId = _data["personTypeId"];
            this.associateTypeId = _data["associateTypeId"];
            this.mbg = _data["mbg"];
            this.mb = _data["mb"];
            this.address = _data["address"];
            this.zip = _data["zip"];
            this.cityId = _data["cityId"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.web = _data["web"];
            this.iban = _data["iban"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.personType = _data["personType"];
            this.associateType = _data["associateType"];
        }
    }

    static fromJS(data: any): CooperatorVm {
        data = typeof data === 'object' ? data : {};
        let result = new CooperatorVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["oib"] = this.oib;
        data["personTypeId"] = this.personTypeId;
        data["associateTypeId"] = this.associateTypeId;
        data["mbg"] = this.mbg;
        data["mb"] = this.mb;
        data["address"] = this.address;
        data["zip"] = this.zip;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["web"] = this.web;
        data["iban"] = this.iban;
        data["city"] = this.city;
        data["country"] = this.country;
        data["personType"] = this.personType;
        data["associateType"] = this.associateType;
        return data;
    }
}

export interface ICooperatorVm {
    id: number;
    name: string;
    oib: string | undefined;
    personTypeId: PersonTypeEnum;
    associateTypeId: AssociateTypeEnum;
    mbg: string | undefined;
    mb: string | undefined;
    address: string | undefined;
    zip: string | undefined;
    cityId: number | undefined;
    countryId: number | undefined;
    email: string | undefined;
    phone: string | undefined;
    web: string | undefined;
    iban: string | undefined;
    city: string | undefined;
    country: string | undefined;
    personType: string | undefined;
    associateType: string | undefined;
}

export enum PersonTypeEnum {
    LegalPerson = 300,
    NaturalPerson = 301,
}

export enum AssociateTypeEnum {
    ProjectAssociate = 1300,
    Supplier = 1301,
    FoodSupplier = 1302,
    AccommodationSupplier = 1303,
    EmploymentAgency = 1304,
}

export class PaginatedListOfCooperatorVm implements IPaginatedListOfCooperatorVm {
    pageItems!: CooperatorVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfCooperatorVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(CooperatorVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfCooperatorVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCooperatorVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfCooperatorVm {
    pageItems: CooperatorVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class CooperatorDetailVm extends CooperatorVm implements ICooperatorDetailVm {
    projects!: ProjectCooperatorVm[] | undefined;
    contacts!: CooperatorContactVm[] | undefined;

    constructor(data?: ICooperatorDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectCooperatorVm.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(CooperatorContactVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CooperatorDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new CooperatorDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICooperatorDetailVm extends ICooperatorVm {
    projects: ProjectCooperatorVm[] | undefined;
    contacts: CooperatorContactVm[] | undefined;
}

export class ProjectCooperatorVm implements IProjectCooperatorVm {
    id!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    projectId!: number;
    cooperatorId!: number;
    cooperatorContactId!: number | undefined;
    clientId!: number;
    cooperatorTypeId!: CooperatorTypeEnum;
    hasBoq!: boolean;
    cooperatorType!: string | undefined;
    cooperatorName!: string | undefined;
    clientName!: string | undefined;
    projectName!: string | undefined;
    cooperatorContactSummary!: string | undefined;

    constructor(data?: IProjectCooperatorVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.projectId = _data["projectId"];
            this.cooperatorId = _data["cooperatorId"];
            this.cooperatorContactId = _data["cooperatorContactId"];
            this.clientId = _data["clientId"];
            this.cooperatorTypeId = _data["cooperatorTypeId"];
            this.hasBoq = _data["hasBoq"];
            this.cooperatorType = _data["cooperatorType"];
            this.cooperatorName = _data["cooperatorName"];
            this.clientName = _data["clientName"];
            this.projectName = _data["projectName"];
            this.cooperatorContactSummary = _data["cooperatorContactSummary"];
        }
    }

    static fromJS(data: any): ProjectCooperatorVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCooperatorVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["projectId"] = this.projectId;
        data["cooperatorId"] = this.cooperatorId;
        data["cooperatorContactId"] = this.cooperatorContactId;
        data["clientId"] = this.clientId;
        data["cooperatorTypeId"] = this.cooperatorTypeId;
        data["hasBoq"] = this.hasBoq;
        data["cooperatorType"] = this.cooperatorType;
        data["cooperatorName"] = this.cooperatorName;
        data["clientName"] = this.clientName;
        data["projectName"] = this.projectName;
        data["cooperatorContactSummary"] = this.cooperatorContactSummary;
        return data;
    }
}

export interface IProjectCooperatorVm {
    id: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    projectId: number;
    cooperatorId: number;
    cooperatorContactId: number | undefined;
    clientId: number;
    cooperatorTypeId: CooperatorTypeEnum;
    hasBoq: boolean;
    cooperatorType: string | undefined;
    cooperatorName: string | undefined;
    clientName: string | undefined;
    projectName: string | undefined;
    cooperatorContactSummary: string | undefined;
}

export enum CooperatorTypeEnum {
    Oversight = 500,
    Client = 501,
    Investor = 502,
    Designer = 503,
    LeadPartner = 504,
    Partner = 505,
    Cooperator = 506,
    UnlistedCooperator = 507,
}

export class CreateCooperatorCommandOfCooperator implements ICreateCooperatorCommandOfCooperator {
    name!: string;
    oib!: string | undefined;
    personTypeId!: PersonTypeEnum;
    associateTypeId!: AssociateTypeEnum;
    mbg!: string | undefined;
    mb!: string | undefined;
    address!: string | undefined;
    zip!: string | undefined;
    cityId!: number | undefined;
    countryId!: number | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    iban!: string | undefined;
    web!: string | undefined;

    constructor(data?: ICreateCooperatorCommandOfCooperator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.oib = _data["oib"];
            this.personTypeId = _data["personTypeId"];
            this.associateTypeId = _data["associateTypeId"];
            this.mbg = _data["mbg"];
            this.mb = _data["mb"];
            this.address = _data["address"];
            this.zip = _data["zip"];
            this.cityId = _data["cityId"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.iban = _data["iban"];
            this.web = _data["web"];
        }
    }

    static fromJS(data: any): CreateCooperatorCommandOfCooperator {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCooperatorCommandOfCooperator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["oib"] = this.oib;
        data["personTypeId"] = this.personTypeId;
        data["associateTypeId"] = this.associateTypeId;
        data["mbg"] = this.mbg;
        data["mb"] = this.mb;
        data["address"] = this.address;
        data["zip"] = this.zip;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["iban"] = this.iban;
        data["web"] = this.web;
        return data;
    }
}

export interface ICreateCooperatorCommandOfCooperator {
    name: string;
    oib: string | undefined;
    personTypeId: PersonTypeEnum;
    associateTypeId: AssociateTypeEnum;
    mbg: string | undefined;
    mb: string | undefined;
    address: string | undefined;
    zip: string | undefined;
    cityId: number | undefined;
    countryId: number | undefined;
    email: string | undefined;
    phone: string | undefined;
    iban: string | undefined;
    web: string | undefined;
}

export class UpdateCooperatorCommandOfCooperator extends CreateCooperatorCommandOfCooperator implements IUpdateCooperatorCommandOfCooperator {
    id!: number;

    constructor(data?: IUpdateCooperatorCommandOfCooperator) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCooperatorCommandOfCooperator {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCooperatorCommandOfCooperator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCooperatorCommandOfCooperator extends ICreateCooperatorCommandOfCooperator {
    id: number;
}

export class CountryVm implements ICountryVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    code!: string | undefined;

    constructor(data?: ICountryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CountryVm {
        data = typeof data === 'object' ? data : {};
        let result = new CountryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["code"] = this.code;
        return data;
    }
}

export interface ICountryVm {
    id: number;
    name: string;
    nameUniversal: string;
    code: string | undefined;
}

export class CountryDetailVm extends CountryVm implements ICountryDetailVm {
    cities!: CityVm[];

    constructor(data?: ICountryDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CityVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICountryDetailVm extends ICountryVm {
    cities: CityVm[];
}

export class CreateCountryCommandOfCountry implements ICreateCountryCommandOfCountry {
    name!: string;
    nameUniversal!: string;
    code!: string | undefined;

    constructor(data?: ICreateCountryCommandOfCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateCountryCommandOfCountry {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryCommandOfCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateCountryCommandOfCountry {
    name: string;
    nameUniversal: string;
    code: string | undefined;
}

export class UpdateCountryCommandOfCountry extends CreateCountryCommandOfCountry implements IUpdateCountryCommandOfCountry {
    id!: number;

    constructor(data?: IUpdateCountryCommandOfCountry) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCountryCommandOfCountry {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryCommandOfCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCountryCommandOfCountry extends ICreateCountryCommandOfCountry {
    id: number;
}

export class DocumentItemVm implements IDocumentItemVm {
    id!: number;
    documentId!: number;
    documentTypeId!: DocumentTypeEnum;
    code!: string | undefined;
    name!: string | undefined;
    statusId!: DocumentItemStatusEnum;
    status!: string | undefined;
    unitOfMeasurementId!: number;
    unitOfMeasurement!: UnitOfMeasurementVm | undefined;
    quantity!: number;
    unitPrice!: number | undefined;
    totalPrice!: number | undefined;
    comment!: string | undefined;
    projectItem!: string | undefined;
    parentItemId!: number | undefined;
    parentItem!: DocumentItemVm | undefined;
    parentItemDocumentId!: number | undefined;
    parentItemDocumentCode!: string | undefined;
    parentItemDocumentTypeId!: DocumentTypeEnum;
    projectId!: number | undefined;
    project!: string | undefined;
    destinationProjectId!: number | undefined;
    destinationProject!: string | undefined;
    supplierId!: number | undefined;
    supplier!: string | undefined;
    warehouseItemId!: number | undefined;
    warehouseItem!: string | undefined;
    projectItemId!: number | undefined;
    expenseGroupId!: number | undefined;
    expenseGroup!: ExpenseGroupVm | undefined;
    childrenItems!: DocumentItemVm[] | undefined;

    constructor(data?: IDocumentItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.documentTypeId = _data["documentTypeId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.unitOfMeasurementId = _data["unitOfMeasurementId"];
            this.unitOfMeasurement = _data["unitOfMeasurement"] ? UnitOfMeasurementVm.fromJS(_data["unitOfMeasurement"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.comment = _data["comment"];
            this.projectItem = _data["projectItem"];
            this.parentItemId = _data["parentItemId"];
            this.parentItem = _data["parentItem"] ? DocumentItemVm.fromJS(_data["parentItem"]) : <any>undefined;
            this.parentItemDocumentId = _data["parentItemDocumentId"];
            this.parentItemDocumentCode = _data["parentItemDocumentCode"];
            this.parentItemDocumentTypeId = _data["parentItemDocumentTypeId"];
            this.projectId = _data["projectId"];
            this.project = _data["project"];
            this.destinationProjectId = _data["destinationProjectId"];
            this.destinationProject = _data["destinationProject"];
            this.supplierId = _data["supplierId"];
            this.supplier = _data["supplier"];
            this.warehouseItemId = _data["warehouseItemId"];
            this.warehouseItem = _data["warehouseItem"];
            this.projectItemId = _data["projectItemId"];
            this.expenseGroupId = _data["expenseGroupId"];
            this.expenseGroup = _data["expenseGroup"] ? ExpenseGroupVm.fromJS(_data["expenseGroup"]) : <any>undefined;
            if (Array.isArray(_data["childrenItems"])) {
                this.childrenItems = [] as any;
                for (let item of _data["childrenItems"])
                    this.childrenItems!.push(DocumentItemVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["documentTypeId"] = this.documentTypeId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["unitOfMeasurementId"] = this.unitOfMeasurementId;
        data["unitOfMeasurement"] = this.unitOfMeasurement ? this.unitOfMeasurement.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["comment"] = this.comment;
        data["projectItem"] = this.projectItem;
        data["parentItemId"] = this.parentItemId;
        data["parentItem"] = this.parentItem ? this.parentItem.toJSON() : <any>undefined;
        data["parentItemDocumentId"] = this.parentItemDocumentId;
        data["parentItemDocumentCode"] = this.parentItemDocumentCode;
        data["parentItemDocumentTypeId"] = this.parentItemDocumentTypeId;
        data["projectId"] = this.projectId;
        data["project"] = this.project;
        data["destinationProjectId"] = this.destinationProjectId;
        data["destinationProject"] = this.destinationProject;
        data["supplierId"] = this.supplierId;
        data["supplier"] = this.supplier;
        data["warehouseItemId"] = this.warehouseItemId;
        data["warehouseItem"] = this.warehouseItem;
        data["projectItemId"] = this.projectItemId;
        data["expenseGroupId"] = this.expenseGroupId;
        data["expenseGroup"] = this.expenseGroup ? this.expenseGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.childrenItems)) {
            data["childrenItems"] = [];
            for (let item of this.childrenItems)
                data["childrenItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentItemVm {
    id: number;
    documentId: number;
    documentTypeId: DocumentTypeEnum;
    code: string | undefined;
    name: string | undefined;
    statusId: DocumentItemStatusEnum;
    status: string | undefined;
    unitOfMeasurementId: number;
    unitOfMeasurement: UnitOfMeasurementVm | undefined;
    quantity: number;
    unitPrice: number | undefined;
    totalPrice: number | undefined;
    comment: string | undefined;
    projectItem: string | undefined;
    parentItemId: number | undefined;
    parentItem: DocumentItemVm | undefined;
    parentItemDocumentId: number | undefined;
    parentItemDocumentCode: string | undefined;
    parentItemDocumentTypeId: DocumentTypeEnum;
    projectId: number | undefined;
    project: string | undefined;
    destinationProjectId: number | undefined;
    destinationProject: string | undefined;
    supplierId: number | undefined;
    supplier: string | undefined;
    warehouseItemId: number | undefined;
    warehouseItem: string | undefined;
    projectItemId: number | undefined;
    expenseGroupId: number | undefined;
    expenseGroup: ExpenseGroupVm | undefined;
    childrenItems: DocumentItemVm[] | undefined;
}

export enum DocumentTypeEnum {
    RequisitionOrder = 800,
    PurchaseOrder = 801,
    PurchaseReceivedNote = 802,
    TransferNote = 803,
    TransferReceivedNote = 804,
    ConsumptionNote = 805,
    WriteOffNote = 806,
    Liquidation = 807,
    Order = 808,
}

export enum DocumentItemStatusEnum {
    None = 1200,
    Draft = 1201,
    Processing = 1202,
    Procured = 1203,
    Canceled = 1204,
    Dispatched = 1205,
    Received = 1206,
}

export class UnitOfMeasurementVm implements IUnitOfMeasurementVm {
    id!: number;
    nameUniversal!: string;
    name!: string;
    shortName!: string | undefined;

    constructor(data?: IUnitOfMeasurementVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameUniversal = _data["nameUniversal"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): UnitOfMeasurementVm {
        data = typeof data === 'object' ? data : {};
        let result = new UnitOfMeasurementVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameUniversal"] = this.nameUniversal;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IUnitOfMeasurementVm {
    id: number;
    nameUniversal: string;
    name: string;
    shortName: string | undefined;
}

export class ExpenseGroupVm implements IExpenseGroupVm {
    id!: number;
    name!: string;
    expenseTypeId!: ExpenseTypeEnum;
    expenseType!: string;

    constructor(data?: IExpenseGroupVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseType = _data["expenseType"];
        }
    }

    static fromJS(data: any): ExpenseGroupVm {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseGroupVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseType"] = this.expenseType;
        return data;
    }
}

export interface IExpenseGroupVm {
    id: number;
    name: string;
    expenseTypeId: ExpenseTypeEnum;
    expenseType: string;
}

export enum ExpenseTypeEnum {
    Goods = 700,
    Services = 701,
    Equipment = 702,
}

export class CreateDocumentItemCommandOfDocumentItem implements ICreateDocumentItemCommandOfDocumentItem {
    documentId!: number;
    statusId!: DocumentItemStatusEnum;
    name!: string;
    unitOfMeasurementId!: number;
    quantity!: number;
    unitPrice!: number | undefined;
    comment!: string | undefined;
    projectId!: number;
    destinationProjectId!: number | undefined;
    supplierId!: number | undefined;
    warehouseItemId!: number | undefined;
    projectItemId!: number | undefined;
    expenseGroupId!: number | undefined;

    constructor(data?: ICreateDocumentItemCommandOfDocumentItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.statusId = _data["statusId"];
            this.name = _data["name"];
            this.unitOfMeasurementId = _data["unitOfMeasurementId"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.comment = _data["comment"];
            this.projectId = _data["projectId"];
            this.destinationProjectId = _data["destinationProjectId"];
            this.supplierId = _data["supplierId"];
            this.warehouseItemId = _data["warehouseItemId"];
            this.projectItemId = _data["projectItemId"];
            this.expenseGroupId = _data["expenseGroupId"];
        }
    }

    static fromJS(data: any): CreateDocumentItemCommandOfDocumentItem {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentItemCommandOfDocumentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["statusId"] = this.statusId;
        data["name"] = this.name;
        data["unitOfMeasurementId"] = this.unitOfMeasurementId;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["comment"] = this.comment;
        data["projectId"] = this.projectId;
        data["destinationProjectId"] = this.destinationProjectId;
        data["supplierId"] = this.supplierId;
        data["warehouseItemId"] = this.warehouseItemId;
        data["projectItemId"] = this.projectItemId;
        data["expenseGroupId"] = this.expenseGroupId;
        return data;
    }
}

export interface ICreateDocumentItemCommandOfDocumentItem {
    documentId: number;
    statusId: DocumentItemStatusEnum;
    name: string;
    unitOfMeasurementId: number;
    quantity: number;
    unitPrice: number | undefined;
    comment: string | undefined;
    projectId: number;
    destinationProjectId: number | undefined;
    supplierId: number | undefined;
    warehouseItemId: number | undefined;
    projectItemId: number | undefined;
    expenseGroupId: number | undefined;
}

export class UpdateDocumentItemCommandOfDocumentItem extends CreateDocumentItemCommandOfDocumentItem implements IUpdateDocumentItemCommandOfDocumentItem {
    id!: number;

    constructor(data?: IUpdateDocumentItemCommandOfDocumentItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateDocumentItemCommandOfDocumentItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentItemCommandOfDocumentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentItemCommandOfDocumentItem extends ICreateDocumentItemCommandOfDocumentItem {
    id: number;
}

export class DocumentVm implements IDocumentVm {
    id!: number;
    documentTypeId!: DocumentTypeEnum;
    code!: string | undefined;
    projectId!: number | undefined;
    currency!: string | undefined;
    comment!: string | undefined;
    destinationProjectId!: number | undefined;
    parentId!: number | undefined;
    supplierId!: number | undefined;
    supplier!: string | undefined;
    deadlineDate!: Date | undefined;
    receiptCode!: string | undefined;
    receiptAmount!: number | undefined;
    documentStatusId!: DocumentStatusEnum;
    documentStatus!: string | undefined;
    documentType!: string | undefined;
    project!: string | undefined;
    destinationProject!: string | undefined;
    createdBy!: string | undefined;
    lastModifiedDate!: Date;
    createdDate!: Date;
    stornedDocumentId!: number | undefined;
    stornedDocumentCode!: string | undefined;
    stornedDocumentTypeId!: DocumentTypeEnum;
    parentCode!: string | undefined;
    parentTypeId!: DocumentTypeEnum;
    totalPrice!: number | undefined;
    documentItems!: DocumentItemVm[] | undefined;

    constructor(data?: IDocumentVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentTypeId = _data["documentTypeId"];
            this.code = _data["code"];
            this.projectId = _data["projectId"];
            this.currency = _data["currency"];
            this.comment = _data["comment"];
            this.destinationProjectId = _data["destinationProjectId"];
            this.parentId = _data["parentId"];
            this.supplierId = _data["supplierId"];
            this.supplier = _data["supplier"];
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.receiptCode = _data["receiptCode"];
            this.receiptAmount = _data["receiptAmount"];
            this.documentStatusId = _data["documentStatusId"];
            this.documentStatus = _data["documentStatus"];
            this.documentType = _data["documentType"];
            this.project = _data["project"];
            this.destinationProject = _data["destinationProject"];
            this.createdBy = _data["createdBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.stornedDocumentId = _data["stornedDocumentId"];
            this.stornedDocumentCode = _data["stornedDocumentCode"];
            this.stornedDocumentTypeId = _data["stornedDocumentTypeId"];
            this.parentCode = _data["parentCode"];
            this.parentTypeId = _data["parentTypeId"];
            this.totalPrice = _data["totalPrice"];
            if (Array.isArray(_data["documentItems"])) {
                this.documentItems = [] as any;
                for (let item of _data["documentItems"])
                    this.documentItems!.push(DocumentItemVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentVm {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentTypeId"] = this.documentTypeId;
        data["code"] = this.code;
        data["projectId"] = this.projectId;
        data["currency"] = this.currency;
        data["comment"] = this.comment;
        data["destinationProjectId"] = this.destinationProjectId;
        data["parentId"] = this.parentId;
        data["supplierId"] = this.supplierId;
        data["supplier"] = this.supplier;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["receiptCode"] = this.receiptCode;
        data["receiptAmount"] = this.receiptAmount;
        data["documentStatusId"] = this.documentStatusId;
        data["documentStatus"] = this.documentStatus;
        data["documentType"] = this.documentType;
        data["project"] = this.project;
        data["destinationProject"] = this.destinationProject;
        data["createdBy"] = this.createdBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["stornedDocumentId"] = this.stornedDocumentId;
        data["stornedDocumentCode"] = this.stornedDocumentCode;
        data["stornedDocumentTypeId"] = this.stornedDocumentTypeId;
        data["parentCode"] = this.parentCode;
        data["parentTypeId"] = this.parentTypeId;
        data["totalPrice"] = this.totalPrice;
        if (Array.isArray(this.documentItems)) {
            data["documentItems"] = [];
            for (let item of this.documentItems)
                data["documentItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentVm {
    id: number;
    documentTypeId: DocumentTypeEnum;
    code: string | undefined;
    projectId: number | undefined;
    currency: string | undefined;
    comment: string | undefined;
    destinationProjectId: number | undefined;
    parentId: number | undefined;
    supplierId: number | undefined;
    supplier: string | undefined;
    deadlineDate: Date | undefined;
    receiptCode: string | undefined;
    receiptAmount: number | undefined;
    documentStatusId: DocumentStatusEnum;
    documentStatus: string | undefined;
    documentType: string | undefined;
    project: string | undefined;
    destinationProject: string | undefined;
    createdBy: string | undefined;
    lastModifiedDate: Date;
    createdDate: Date;
    stornedDocumentId: number | undefined;
    stornedDocumentCode: string | undefined;
    stornedDocumentTypeId: DocumentTypeEnum;
    parentCode: string | undefined;
    parentTypeId: DocumentTypeEnum;
    totalPrice: number | undefined;
    documentItems: DocumentItemVm[] | undefined;
}

export enum DocumentStatusEnum {
    Draft = 900,
    Completed = 901,
    Processing = 902,
    Processed = 903,
}

export class DocumentDetailVm extends DocumentVm implements IDocumentDetailVm {
    attachments!: AttachmentVm[] | undefined;
    children!: DocumentVm[] | undefined;
    storningDocuments!: DocumentVm[] | undefined;
    verifications!: VerificationVm[] | undefined;

    constructor(data?: IDocumentDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentVm.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(DocumentVm.fromJS(item));
            }
            if (Array.isArray(_data["storningDocuments"])) {
                this.storningDocuments = [] as any;
                for (let item of _data["storningDocuments"])
                    this.storningDocuments!.push(DocumentVm.fromJS(item));
            }
            if (Array.isArray(_data["verifications"])) {
                this.verifications = [] as any;
                for (let item of _data["verifications"])
                    this.verifications!.push(VerificationVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.storningDocuments)) {
            data["storningDocuments"] = [];
            for (let item of this.storningDocuments)
                data["storningDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.verifications)) {
            data["verifications"] = [];
            for (let item of this.verifications)
                data["verifications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentDetailVm extends IDocumentVm {
    attachments: AttachmentVm[] | undefined;
    children: DocumentVm[] | undefined;
    storningDocuments: DocumentVm[] | undefined;
    verifications: VerificationVm[] | undefined;
}

export class VerificationVm implements IVerificationVm {
    id!: number;
    fileName!: string;
    url!: string;
    verificationStatusId!: VerificationStatusEnum;
    verificationStatus!: string | undefined;
    remark!: string | undefined;
    projectId!: number | undefined;
    project!: string | undefined;
    documentId!: number | undefined;
    documentCode!: string | undefined;
    createdBy!: string | undefined;
    createdDate!: Date;

    constructor(data?: IVerificationVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            this.verificationStatusId = _data["verificationStatusId"];
            this.verificationStatus = _data["verificationStatus"];
            this.remark = _data["remark"];
            this.projectId = _data["projectId"];
            this.project = _data["project"];
            this.documentId = _data["documentId"];
            this.documentCode = _data["documentCode"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VerificationVm {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        data["verificationStatusId"] = this.verificationStatusId;
        data["verificationStatus"] = this.verificationStatus;
        data["remark"] = this.remark;
        data["projectId"] = this.projectId;
        data["project"] = this.project;
        data["documentId"] = this.documentId;
        data["documentCode"] = this.documentCode;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVerificationVm {
    id: number;
    fileName: string;
    url: string;
    verificationStatusId: VerificationStatusEnum;
    verificationStatus: string | undefined;
    remark: string | undefined;
    projectId: number | undefined;
    project: string | undefined;
    documentId: number | undefined;
    documentCode: string | undefined;
    createdBy: string | undefined;
    createdDate: Date;
}

export enum VerificationStatusEnum {
    Unverified = 1400,
    Verified = 1401,
    Rejected = 1402,
}

export class CreateDocumentCommandOfDocument implements ICreateDocumentCommandOfDocument {
    documentTypeId!: DocumentTypeEnum;
    code!: string | undefined;
    projectId!: number | undefined;
    destinationProjectId!: number | undefined;
    currency!: string | undefined;
    comment!: string | undefined;
    parentId!: number | undefined;
    supplierId!: number | undefined;
    deadlineDate!: Date | undefined;
    receiptCode!: string | undefined;
    receiptAmount!: number | undefined;
    documentItemIds!: number[] | undefined;
    warehouseItemIds!: number[] | undefined;

    constructor(data?: ICreateDocumentCommandOfDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeId = _data["documentTypeId"];
            this.code = _data["code"];
            this.projectId = _data["projectId"];
            this.destinationProjectId = _data["destinationProjectId"];
            this.currency = _data["currency"];
            this.comment = _data["comment"];
            this.parentId = _data["parentId"];
            this.supplierId = _data["supplierId"];
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.receiptCode = _data["receiptCode"];
            this.receiptAmount = _data["receiptAmount"];
            if (Array.isArray(_data["documentItemIds"])) {
                this.documentItemIds = [] as any;
                for (let item of _data["documentItemIds"])
                    this.documentItemIds!.push(item);
            }
            if (Array.isArray(_data["warehouseItemIds"])) {
                this.warehouseItemIds = [] as any;
                for (let item of _data["warehouseItemIds"])
                    this.warehouseItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDocumentCommandOfDocument {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentCommandOfDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeId"] = this.documentTypeId;
        data["code"] = this.code;
        data["projectId"] = this.projectId;
        data["destinationProjectId"] = this.destinationProjectId;
        data["currency"] = this.currency;
        data["comment"] = this.comment;
        data["parentId"] = this.parentId;
        data["supplierId"] = this.supplierId;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["receiptCode"] = this.receiptCode;
        data["receiptAmount"] = this.receiptAmount;
        if (Array.isArray(this.documentItemIds)) {
            data["documentItemIds"] = [];
            for (let item of this.documentItemIds)
                data["documentItemIds"].push(item);
        }
        if (Array.isArray(this.warehouseItemIds)) {
            data["warehouseItemIds"] = [];
            for (let item of this.warehouseItemIds)
                data["warehouseItemIds"].push(item);
        }
        return data;
    }
}

export interface ICreateDocumentCommandOfDocument {
    documentTypeId: DocumentTypeEnum;
    code: string | undefined;
    projectId: number | undefined;
    destinationProjectId: number | undefined;
    currency: string | undefined;
    comment: string | undefined;
    parentId: number | undefined;
    supplierId: number | undefined;
    deadlineDate: Date | undefined;
    receiptCode: string | undefined;
    receiptAmount: number | undefined;
    documentItemIds: number[] | undefined;
    warehouseItemIds: number[] | undefined;
}

export class UpdateDocumentCommandOfDocument extends CreateDocumentCommandOfDocument implements IUpdateDocumentCommandOfDocument {
    id!: number;

    constructor(data?: IUpdateDocumentCommandOfDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateDocumentCommandOfDocument {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentCommandOfDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentCommandOfDocument extends ICreateDocumentCommandOfDocument {
    id: number;
}

export class CompleteDocumentCommand implements ICompleteDocumentCommand {
    documentId!: number;

    constructor(data?: ICompleteDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): CompleteDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ICompleteDocumentCommand {
    documentId: number;
}

export class ProcessDocumentCommand implements IProcessDocumentCommand {
    documentId!: number;

    constructor(data?: IProcessDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): ProcessDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IProcessDocumentCommand {
    documentId: number;
}

export class CopyDocumentCommand implements ICopyDocumentCommand {
    sourceDocumentId!: number;
    destTypeId!: DocumentTypeEnum;
    isStorno!: boolean;

    constructor(data?: ICopyDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceDocumentId = _data["sourceDocumentId"];
            this.destTypeId = _data["destTypeId"];
            this.isStorno = _data["isStorno"];
        }
    }

    static fromJS(data: any): CopyDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceDocumentId"] = this.sourceDocumentId;
        data["destTypeId"] = this.destTypeId;
        data["isStorno"] = this.isStorno;
        return data;
    }
}

export interface ICopyDocumentCommand {
    sourceDocumentId: number;
    destTypeId: DocumentTypeEnum;
    isStorno: boolean;
}

export class ExportOrderPDFCommand implements IExportOrderPDFCommand {
    id!: number;

    constructor(data?: IExportOrderPDFCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExportOrderPDFCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderPDFCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IExportOrderPDFCommand {
    id: number;
}

export class ExportOrderXLSXCommand implements IExportOrderXLSXCommand {
    id!: number;

    constructor(data?: IExportOrderXLSXCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExportOrderXLSXCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderXLSXCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IExportOrderXLSXCommand {
    id: number;
}

export class EmployeeExpensesPaginated implements IEmployeeExpensesPaginated {
    employeeExpenses!: EmployeeExpenseEmployeeVm[] | undefined;
    projectColumns!: ProjectColumn[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IEmployeeExpensesPaginated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeExpenses"])) {
                this.employeeExpenses = [] as any;
                for (let item of _data["employeeExpenses"])
                    this.employeeExpenses!.push(EmployeeExpenseEmployeeVm.fromJS(item));
            }
            if (Array.isArray(_data["projectColumns"])) {
                this.projectColumns = [] as any;
                for (let item of _data["projectColumns"])
                    this.projectColumns!.push(ProjectColumn.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EmployeeExpensesPaginated {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeExpensesPaginated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeExpenses)) {
            data["employeeExpenses"] = [];
            for (let item of this.employeeExpenses)
                data["employeeExpenses"].push(item.toJSON());
        }
        if (Array.isArray(this.projectColumns)) {
            data["projectColumns"] = [];
            for (let item of this.projectColumns)
                data["projectColumns"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEmployeeExpensesPaginated {
    employeeExpenses: EmployeeExpenseEmployeeVm[] | undefined;
    projectColumns: ProjectColumn[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class EmployeeExpenseEmployeeVm implements IEmployeeExpenseEmployeeVm {
    employee!: EmployeeInfoVm | undefined;
    employeeExpense!: EmployeeExpenseVm[] | undefined;

    constructor(data?: IEmployeeExpenseEmployeeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeInfoVm.fromJS(_data["employee"]) : <any>undefined;
            if (Array.isArray(_data["employeeExpense"])) {
                this.employeeExpense = [] as any;
                for (let item of _data["employeeExpense"])
                    this.employeeExpense!.push(EmployeeExpenseVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeExpenseEmployeeVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeExpenseEmployeeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        if (Array.isArray(this.employeeExpense)) {
            data["employeeExpense"] = [];
            for (let item of this.employeeExpense)
                data["employeeExpense"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeeExpenseEmployeeVm {
    employee: EmployeeInfoVm | undefined;
    employeeExpense: EmployeeExpenseVm[] | undefined;
}

export class EmployeeInfoVm implements IEmployeeInfoVm {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;
    companyId!: number;
    company!: Company | undefined;

    constructor(data?: IEmployeeInfoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeInfoVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInfoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeInfoVm {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    companyId: number;
    company: Company | undefined;
}

export class Company implements ICompany {
    id!: number;
    name!: string;
    isActive!: boolean;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICompany {
    id: number;
    name: string;
    isActive: boolean;
}

export class EmployeeExpenseVm implements IEmployeeExpenseVm {
    id!: number;
    month!: number;
    year!: number;
    companyId!: number;
    amount!: number;
    projectId!: number | undefined;
    employeeId!: number;

    constructor(data?: IEmployeeExpenseVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.companyId = _data["companyId"];
            this.amount = _data["amount"];
            this.projectId = _data["projectId"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EmployeeExpenseVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeExpenseVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month;
        data["year"] = this.year;
        data["companyId"] = this.companyId;
        data["amount"] = this.amount;
        data["projectId"] = this.projectId;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEmployeeExpenseVm {
    id: number;
    month: number;
    year: number;
    companyId: number;
    amount: number;
    projectId: number | undefined;
    employeeId: number;
}

export class ProjectColumn implements IProjectColumn {
    projectId!: number;
    projectName!: string | undefined;

    constructor(data?: IProjectColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ProjectColumn {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IProjectColumn {
    projectId: number;
    projectName: string | undefined;
}

export class EmployeeVm implements IEmployeeVm {
    id!: number;
    name!: string;
    surname!: string;
    fullName!: string;
    oib!: string;
    birthDate!: Date;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    genderId!: GenderEnum;
    gender!: string;
    address!: string;
    cityId!: number | undefined;
    city!: string | undefined;
    countryId!: number | undefined;
    country!: string | undefined;
    temporaryAddress!: string | undefined;
    temporaryCityId!: number | undefined;
    temporaryCity!: string | undefined;
    temporaryCountryId!: number | undefined;
    temporaryCountry!: string | undefined;
    email!: string | undefined;
    phone!: string;
    photo!: string | undefined;
    employeeRoleId!: number | undefined;
    employeeRole!: string | undefined;
    usedBonusAmountBeforeEmployment!: number | undefined;
    identificationNumber!: string | undefined;
    agencyId!: number | undefined;
    agency!: string | undefined;
    position!: string;
    companyId!: number | undefined;
    company!: Company | undefined;
    company2Id!: number | undefined;
    company2!: Company | undefined;
    isSupervised!: boolean | undefined;
    supervisionDecisionExpirationDate!: Date | undefined;
    isCompetentForSafeWork!: boolean | undefined;
    isCompetentForFireProtection!: boolean | undefined;
    isCompetentForFirstAid!: boolean | undefined;
    isAuthorizedForWorkSafety!: boolean | undefined;
    authorizationExpirationDate!: Date | undefined;
    isMedicalExaminationRequired!: boolean | undefined;
    medicalExaminationExpirationDate!: Date | undefined;
    medicalExaminationBy!: string | undefined;
    medicalExaminationNotes!: string | undefined;
    pointList!: string | undefined;
    isCompetentForToxicology!: boolean | undefined;
    isResponsibleForToxicology!: boolean | undefined;
    isExecutantForToxicology!: boolean | undefined;
    toxicologyExpirationDate!: Date | undefined;
    workShoesSize!: string | undefined;
    workPantsSize!: string | undefined;
    workJacketSize!: string | undefined;
    hasWorkingPermission!: boolean | undefined;
    workingPermissionExpirationDate!: Date | undefined;
    workingPermissionExtensionStartDate!: Date | undefined;
    workingPermissionExtensionRequestDate!: Date | undefined;

    constructor(data?: IEmployeeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.oib = _data["oib"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.genderId = _data["genderId"];
            this.gender = _data["gender"];
            this.address = _data["address"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.temporaryAddress = _data["temporaryAddress"];
            this.temporaryCityId = _data["temporaryCityId"];
            this.temporaryCity = _data["temporaryCity"];
            this.temporaryCountryId = _data["temporaryCountryId"];
            this.temporaryCountry = _data["temporaryCountry"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.photo = _data["photo"];
            this.employeeRoleId = _data["employeeRoleId"];
            this.employeeRole = _data["employeeRole"];
            this.usedBonusAmountBeforeEmployment = _data["usedBonusAmountBeforeEmployment"];
            this.identificationNumber = _data["identificationNumber"];
            this.agencyId = _data["agencyId"];
            this.agency = _data["agency"];
            this.position = _data["position"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.company2Id = _data["company2Id"];
            this.company2 = _data["company2"] ? Company.fromJS(_data["company2"]) : <any>undefined;
            this.isSupervised = _data["isSupervised"];
            this.supervisionDecisionExpirationDate = _data["supervisionDecisionExpirationDate"] ? new Date(_data["supervisionDecisionExpirationDate"].toString()) : <any>undefined;
            this.isCompetentForSafeWork = _data["isCompetentForSafeWork"];
            this.isCompetentForFireProtection = _data["isCompetentForFireProtection"];
            this.isCompetentForFirstAid = _data["isCompetentForFirstAid"];
            this.isAuthorizedForWorkSafety = _data["isAuthorizedForWorkSafety"];
            this.authorizationExpirationDate = _data["authorizationExpirationDate"] ? new Date(_data["authorizationExpirationDate"].toString()) : <any>undefined;
            this.isMedicalExaminationRequired = _data["isMedicalExaminationRequired"];
            this.medicalExaminationExpirationDate = _data["medicalExaminationExpirationDate"] ? new Date(_data["medicalExaminationExpirationDate"].toString()) : <any>undefined;
            this.medicalExaminationBy = _data["medicalExaminationBy"];
            this.medicalExaminationNotes = _data["medicalExaminationNotes"];
            this.pointList = _data["pointList"];
            this.isCompetentForToxicology = _data["isCompetentForToxicology"];
            this.isResponsibleForToxicology = _data["isResponsibleForToxicology"];
            this.isExecutantForToxicology = _data["isExecutantForToxicology"];
            this.toxicologyExpirationDate = _data["toxicologyExpirationDate"] ? new Date(_data["toxicologyExpirationDate"].toString()) : <any>undefined;
            this.workShoesSize = _data["workShoesSize"];
            this.workPantsSize = _data["workPantsSize"];
            this.workJacketSize = _data["workJacketSize"];
            this.hasWorkingPermission = _data["hasWorkingPermission"];
            this.workingPermissionExpirationDate = _data["workingPermissionExpirationDate"] ? new Date(_data["workingPermissionExpirationDate"].toString()) : <any>undefined;
            this.workingPermissionExtensionStartDate = _data["workingPermissionExtensionStartDate"] ? new Date(_data["workingPermissionExtensionStartDate"].toString()) : <any>undefined;
            this.workingPermissionExtensionRequestDate = _data["workingPermissionExtensionRequestDate"] ? new Date(_data["workingPermissionExtensionRequestDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["oib"] = this.oib;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["genderId"] = this.genderId;
        data["gender"] = this.gender;
        data["address"] = this.address;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["temporaryAddress"] = this.temporaryAddress;
        data["temporaryCityId"] = this.temporaryCityId;
        data["temporaryCity"] = this.temporaryCity;
        data["temporaryCountryId"] = this.temporaryCountryId;
        data["temporaryCountry"] = this.temporaryCountry;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["photo"] = this.photo;
        data["employeeRoleId"] = this.employeeRoleId;
        data["employeeRole"] = this.employeeRole;
        data["usedBonusAmountBeforeEmployment"] = this.usedBonusAmountBeforeEmployment;
        data["identificationNumber"] = this.identificationNumber;
        data["agencyId"] = this.agencyId;
        data["agency"] = this.agency;
        data["position"] = this.position;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["company2Id"] = this.company2Id;
        data["company2"] = this.company2 ? this.company2.toJSON() : <any>undefined;
        data["isSupervised"] = this.isSupervised;
        data["supervisionDecisionExpirationDate"] = this.supervisionDecisionExpirationDate ? this.supervisionDecisionExpirationDate.toISOString() : <any>undefined;
        data["isCompetentForSafeWork"] = this.isCompetentForSafeWork;
        data["isCompetentForFireProtection"] = this.isCompetentForFireProtection;
        data["isCompetentForFirstAid"] = this.isCompetentForFirstAid;
        data["isAuthorizedForWorkSafety"] = this.isAuthorizedForWorkSafety;
        data["authorizationExpirationDate"] = this.authorizationExpirationDate ? this.authorizationExpirationDate.toISOString() : <any>undefined;
        data["isMedicalExaminationRequired"] = this.isMedicalExaminationRequired;
        data["medicalExaminationExpirationDate"] = this.medicalExaminationExpirationDate ? this.medicalExaminationExpirationDate.toISOString() : <any>undefined;
        data["medicalExaminationBy"] = this.medicalExaminationBy;
        data["medicalExaminationNotes"] = this.medicalExaminationNotes;
        data["pointList"] = this.pointList;
        data["isCompetentForToxicology"] = this.isCompetentForToxicology;
        data["isResponsibleForToxicology"] = this.isResponsibleForToxicology;
        data["isExecutantForToxicology"] = this.isExecutantForToxicology;
        data["toxicologyExpirationDate"] = this.toxicologyExpirationDate ? this.toxicologyExpirationDate.toISOString() : <any>undefined;
        data["workShoesSize"] = this.workShoesSize;
        data["workPantsSize"] = this.workPantsSize;
        data["workJacketSize"] = this.workJacketSize;
        data["hasWorkingPermission"] = this.hasWorkingPermission;
        data["workingPermissionExpirationDate"] = this.workingPermissionExpirationDate ? this.workingPermissionExpirationDate.toISOString() : <any>undefined;
        data["workingPermissionExtensionStartDate"] = this.workingPermissionExtensionStartDate ? this.workingPermissionExtensionStartDate.toISOString() : <any>undefined;
        data["workingPermissionExtensionRequestDate"] = this.workingPermissionExtensionRequestDate ? this.workingPermissionExtensionRequestDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployeeVm {
    id: number;
    name: string;
    surname: string;
    fullName: string;
    oib: string;
    birthDate: Date;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    genderId: GenderEnum;
    gender: string;
    address: string;
    cityId: number | undefined;
    city: string | undefined;
    countryId: number | undefined;
    country: string | undefined;
    temporaryAddress: string | undefined;
    temporaryCityId: number | undefined;
    temporaryCity: string | undefined;
    temporaryCountryId: number | undefined;
    temporaryCountry: string | undefined;
    email: string | undefined;
    phone: string;
    photo: string | undefined;
    employeeRoleId: number | undefined;
    employeeRole: string | undefined;
    usedBonusAmountBeforeEmployment: number | undefined;
    identificationNumber: string | undefined;
    agencyId: number | undefined;
    agency: string | undefined;
    position: string;
    companyId: number | undefined;
    company: Company | undefined;
    company2Id: number | undefined;
    company2: Company | undefined;
    isSupervised: boolean | undefined;
    supervisionDecisionExpirationDate: Date | undefined;
    isCompetentForSafeWork: boolean | undefined;
    isCompetentForFireProtection: boolean | undefined;
    isCompetentForFirstAid: boolean | undefined;
    isAuthorizedForWorkSafety: boolean | undefined;
    authorizationExpirationDate: Date | undefined;
    isMedicalExaminationRequired: boolean | undefined;
    medicalExaminationExpirationDate: Date | undefined;
    medicalExaminationBy: string | undefined;
    medicalExaminationNotes: string | undefined;
    pointList: string | undefined;
    isCompetentForToxicology: boolean | undefined;
    isResponsibleForToxicology: boolean | undefined;
    isExecutantForToxicology: boolean | undefined;
    toxicologyExpirationDate: Date | undefined;
    workShoesSize: string | undefined;
    workPantsSize: string | undefined;
    workJacketSize: string | undefined;
    hasWorkingPermission: boolean | undefined;
    workingPermissionExpirationDate: Date | undefined;
    workingPermissionExtensionStartDate: Date | undefined;
    workingPermissionExtensionRequestDate: Date | undefined;
}

export enum GenderEnum {
    Male = 200,
    Female = 201,
}

export class PaginatedListOfEmployeeVm implements IPaginatedListOfEmployeeVm {
    pageItems!: EmployeeVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfEmployeeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(EmployeeVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfEmployeeVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfEmployeeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfEmployeeVm {
    pageItems: EmployeeVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class EmployeeDetailVm extends EmployeeVm implements IEmployeeDetailVm {
    attachments!: AttachmentVm[] | undefined;

    constructor(data?: IEmployeeDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEmployeeDetailVm extends IEmployeeVm {
    attachments: AttachmentVm[] | undefined;
}

export class CreateEmployeeCommand implements ICreateEmployeeCommand {
    name!: string;
    surname!: string;
    oib!: string;
    birthDate!: Date;
    activeFrom!: Date;
    activeTo!: Date | undefined;
    genderId!: GenderEnum;
    address!: string | undefined;
    cityId!: number | undefined;
    countryId!: number | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    photo!: string | undefined;
    companyId!: number | undefined;
    company2Id!: number | undefined;
    employeeRoleId!: number | undefined;
    usedBonusAmountBeforeEmployment!: number | undefined;
    identificationNumber!: string | undefined;
    agencyId!: number | undefined;
    position!: string | undefined;
    temporaryAddress!: string | undefined;
    temporaryCityId!: number | undefined;
    temporaryCountryId!: number | undefined;
    isSupervised!: boolean | undefined;
    supervisionDecisionExpirationDate!: Date | undefined;
    isCompetentForSafeWork!: boolean | undefined;
    isCompetentForFireProtection!: boolean | undefined;
    isCompetentForFirstAid!: boolean | undefined;
    isAuthorizedForWorkSafety!: boolean | undefined;
    authorizationExpirationDate!: Date | undefined;
    isMedicalExaminationRequired!: boolean | undefined;
    medicalExaminationExpirationDate!: Date | undefined;
    medicalExaminationBy!: string | undefined;
    medicalExaminationNotes!: string | undefined;
    pointList!: string | undefined;
    isCompetentForToxicology!: boolean | undefined;
    isResponsibleForToxicology!: boolean | undefined;
    isExecutantForToxicology!: boolean | undefined;
    toxicologyExpirationDate!: Date | undefined;
    workShoesSize!: string | undefined;
    workPantsSize!: string | undefined;
    workJacketSize!: string | undefined;
    hasWorkingPermission!: boolean | undefined;
    workingPermissionExpirationDate!: Date | undefined;
    workingPermissionExtensionStartDate!: Date | undefined;
    workingPermissionExtensionRequestDate!: Date | undefined;

    constructor(data?: ICreateEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.oib = _data["oib"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.genderId = _data["genderId"];
            this.address = _data["address"];
            this.cityId = _data["cityId"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.photo = _data["photo"];
            this.companyId = _data["companyId"];
            this.company2Id = _data["company2Id"];
            this.employeeRoleId = _data["employeeRoleId"];
            this.usedBonusAmountBeforeEmployment = _data["usedBonusAmountBeforeEmployment"];
            this.identificationNumber = _data["identificationNumber"];
            this.agencyId = _data["agencyId"];
            this.position = _data["position"];
            this.temporaryAddress = _data["temporaryAddress"];
            this.temporaryCityId = _data["temporaryCityId"];
            this.temporaryCountryId = _data["temporaryCountryId"];
            this.isSupervised = _data["isSupervised"];
            this.supervisionDecisionExpirationDate = _data["supervisionDecisionExpirationDate"] ? new Date(_data["supervisionDecisionExpirationDate"].toString()) : <any>undefined;
            this.isCompetentForSafeWork = _data["isCompetentForSafeWork"];
            this.isCompetentForFireProtection = _data["isCompetentForFireProtection"];
            this.isCompetentForFirstAid = _data["isCompetentForFirstAid"];
            this.isAuthorizedForWorkSafety = _data["isAuthorizedForWorkSafety"];
            this.authorizationExpirationDate = _data["authorizationExpirationDate"] ? new Date(_data["authorizationExpirationDate"].toString()) : <any>undefined;
            this.isMedicalExaminationRequired = _data["isMedicalExaminationRequired"];
            this.medicalExaminationExpirationDate = _data["medicalExaminationExpirationDate"] ? new Date(_data["medicalExaminationExpirationDate"].toString()) : <any>undefined;
            this.medicalExaminationBy = _data["medicalExaminationBy"];
            this.medicalExaminationNotes = _data["medicalExaminationNotes"];
            this.pointList = _data["pointList"];
            this.isCompetentForToxicology = _data["isCompetentForToxicology"];
            this.isResponsibleForToxicology = _data["isResponsibleForToxicology"];
            this.isExecutantForToxicology = _data["isExecutantForToxicology"];
            this.toxicologyExpirationDate = _data["toxicologyExpirationDate"] ? new Date(_data["toxicologyExpirationDate"].toString()) : <any>undefined;
            this.workShoesSize = _data["workShoesSize"];
            this.workPantsSize = _data["workPantsSize"];
            this.workJacketSize = _data["workJacketSize"];
            this.hasWorkingPermission = _data["hasWorkingPermission"];
            this.workingPermissionExpirationDate = _data["workingPermissionExpirationDate"] ? new Date(_data["workingPermissionExpirationDate"].toString()) : <any>undefined;
            this.workingPermissionExtensionStartDate = _data["workingPermissionExtensionStartDate"] ? new Date(_data["workingPermissionExtensionStartDate"].toString()) : <any>undefined;
            this.workingPermissionExtensionRequestDate = _data["workingPermissionExtensionRequestDate"] ? new Date(_data["workingPermissionExtensionRequestDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["oib"] = this.oib;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["genderId"] = this.genderId;
        data["address"] = this.address;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["photo"] = this.photo;
        data["companyId"] = this.companyId;
        data["company2Id"] = this.company2Id;
        data["employeeRoleId"] = this.employeeRoleId;
        data["usedBonusAmountBeforeEmployment"] = this.usedBonusAmountBeforeEmployment;
        data["identificationNumber"] = this.identificationNumber;
        data["agencyId"] = this.agencyId;
        data["position"] = this.position;
        data["temporaryAddress"] = this.temporaryAddress;
        data["temporaryCityId"] = this.temporaryCityId;
        data["temporaryCountryId"] = this.temporaryCountryId;
        data["isSupervised"] = this.isSupervised;
        data["supervisionDecisionExpirationDate"] = this.supervisionDecisionExpirationDate ? this.supervisionDecisionExpirationDate.toISOString() : <any>undefined;
        data["isCompetentForSafeWork"] = this.isCompetentForSafeWork;
        data["isCompetentForFireProtection"] = this.isCompetentForFireProtection;
        data["isCompetentForFirstAid"] = this.isCompetentForFirstAid;
        data["isAuthorizedForWorkSafety"] = this.isAuthorizedForWorkSafety;
        data["authorizationExpirationDate"] = this.authorizationExpirationDate ? this.authorizationExpirationDate.toISOString() : <any>undefined;
        data["isMedicalExaminationRequired"] = this.isMedicalExaminationRequired;
        data["medicalExaminationExpirationDate"] = this.medicalExaminationExpirationDate ? this.medicalExaminationExpirationDate.toISOString() : <any>undefined;
        data["medicalExaminationBy"] = this.medicalExaminationBy;
        data["medicalExaminationNotes"] = this.medicalExaminationNotes;
        data["pointList"] = this.pointList;
        data["isCompetentForToxicology"] = this.isCompetentForToxicology;
        data["isResponsibleForToxicology"] = this.isResponsibleForToxicology;
        data["isExecutantForToxicology"] = this.isExecutantForToxicology;
        data["toxicologyExpirationDate"] = this.toxicologyExpirationDate ? this.toxicologyExpirationDate.toISOString() : <any>undefined;
        data["workShoesSize"] = this.workShoesSize;
        data["workPantsSize"] = this.workPantsSize;
        data["workJacketSize"] = this.workJacketSize;
        data["hasWorkingPermission"] = this.hasWorkingPermission;
        data["workingPermissionExpirationDate"] = this.workingPermissionExpirationDate ? this.workingPermissionExpirationDate.toISOString() : <any>undefined;
        data["workingPermissionExtensionStartDate"] = this.workingPermissionExtensionStartDate ? this.workingPermissionExtensionStartDate.toISOString() : <any>undefined;
        data["workingPermissionExtensionRequestDate"] = this.workingPermissionExtensionRequestDate ? this.workingPermissionExtensionRequestDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateEmployeeCommand {
    name: string;
    surname: string;
    oib: string;
    birthDate: Date;
    activeFrom: Date;
    activeTo: Date | undefined;
    genderId: GenderEnum;
    address: string | undefined;
    cityId: number | undefined;
    countryId: number | undefined;
    email: string | undefined;
    phone: string | undefined;
    photo: string | undefined;
    companyId: number | undefined;
    company2Id: number | undefined;
    employeeRoleId: number | undefined;
    usedBonusAmountBeforeEmployment: number | undefined;
    identificationNumber: string | undefined;
    agencyId: number | undefined;
    position: string | undefined;
    temporaryAddress: string | undefined;
    temporaryCityId: number | undefined;
    temporaryCountryId: number | undefined;
    isSupervised: boolean | undefined;
    supervisionDecisionExpirationDate: Date | undefined;
    isCompetentForSafeWork: boolean | undefined;
    isCompetentForFireProtection: boolean | undefined;
    isCompetentForFirstAid: boolean | undefined;
    isAuthorizedForWorkSafety: boolean | undefined;
    authorizationExpirationDate: Date | undefined;
    isMedicalExaminationRequired: boolean | undefined;
    medicalExaminationExpirationDate: Date | undefined;
    medicalExaminationBy: string | undefined;
    medicalExaminationNotes: string | undefined;
    pointList: string | undefined;
    isCompetentForToxicology: boolean | undefined;
    isResponsibleForToxicology: boolean | undefined;
    isExecutantForToxicology: boolean | undefined;
    toxicologyExpirationDate: Date | undefined;
    workShoesSize: string | undefined;
    workPantsSize: string | undefined;
    workJacketSize: string | undefined;
    hasWorkingPermission: boolean | undefined;
    workingPermissionExpirationDate: Date | undefined;
    workingPermissionExtensionStartDate: Date | undefined;
    workingPermissionExtensionRequestDate: Date | undefined;
}

export class UpdateEmployeeCommand extends CreateEmployeeCommand implements IUpdateEmployeeCommand {
    id!: number;

    constructor(data?: IUpdateEmployeeCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateEmployeeCommand extends ICreateEmployeeCommand {
    id: number;
}

export class EmployeeGearRecordVm implements IEmployeeGearRecordVm {
    id!: number;
    date!: Date;
    shoes!: number;
    shoesPro!: number;
    pants!: number;
    overalls!: number;
    workJacket!: number;
    winterJacket!: number;
    fleeseJacket!: number;
    helmet!: number;
    vest!: number;
    protectionGloves!: number;
    goggles!: number;
    hydrodemolitionSuit!: number;
    safetyBelt!: number;
    projectId!: number;
    project!: string | undefined;
    employeeId!: number;
    employee!: string | undefined;
    attachmentId!: number | undefined;
    attachmentName!: string | undefined;
    attachmentUrl!: string | undefined;

    constructor(data?: IEmployeeGearRecordVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.shoes = _data["shoes"];
            this.shoesPro = _data["shoesPro"];
            this.pants = _data["pants"];
            this.overalls = _data["overalls"];
            this.workJacket = _data["workJacket"];
            this.winterJacket = _data["winterJacket"];
            this.fleeseJacket = _data["fleeseJacket"];
            this.helmet = _data["helmet"];
            this.vest = _data["vest"];
            this.protectionGloves = _data["protectionGloves"];
            this.goggles = _data["goggles"];
            this.hydrodemolitionSuit = _data["hydrodemolitionSuit"];
            this.safetyBelt = _data["safetyBelt"];
            this.projectId = _data["projectId"];
            this.project = _data["project"];
            this.employeeId = _data["employeeId"];
            this.employee = _data["employee"];
            this.attachmentId = _data["attachmentId"];
            this.attachmentName = _data["attachmentName"];
            this.attachmentUrl = _data["attachmentUrl"];
        }
    }

    static fromJS(data: any): EmployeeGearRecordVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGearRecordVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["shoes"] = this.shoes;
        data["shoesPro"] = this.shoesPro;
        data["pants"] = this.pants;
        data["overalls"] = this.overalls;
        data["workJacket"] = this.workJacket;
        data["winterJacket"] = this.winterJacket;
        data["fleeseJacket"] = this.fleeseJacket;
        data["helmet"] = this.helmet;
        data["vest"] = this.vest;
        data["protectionGloves"] = this.protectionGloves;
        data["goggles"] = this.goggles;
        data["hydrodemolitionSuit"] = this.hydrodemolitionSuit;
        data["safetyBelt"] = this.safetyBelt;
        data["projectId"] = this.projectId;
        data["project"] = this.project;
        data["employeeId"] = this.employeeId;
        data["employee"] = this.employee;
        data["attachmentId"] = this.attachmentId;
        data["attachmentName"] = this.attachmentName;
        data["attachmentUrl"] = this.attachmentUrl;
        return data;
    }
}

export interface IEmployeeGearRecordVm {
    id: number;
    date: Date;
    shoes: number;
    shoesPro: number;
    pants: number;
    overalls: number;
    workJacket: number;
    winterJacket: number;
    fleeseJacket: number;
    helmet: number;
    vest: number;
    protectionGloves: number;
    goggles: number;
    hydrodemolitionSuit: number;
    safetyBelt: number;
    projectId: number;
    project: string | undefined;
    employeeId: number;
    employee: string | undefined;
    attachmentId: number | undefined;
    attachmentName: string | undefined;
    attachmentUrl: string | undefined;
}

export class CreateExpenseGroupCommandOfExpenseGroup implements ICreateExpenseGroupCommandOfExpenseGroup {
    name!: string;
    expenseTypeId!: ExpenseTypeEnum;

    constructor(data?: ICreateExpenseGroupCommandOfExpenseGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.expenseTypeId = _data["expenseTypeId"];
        }
    }

    static fromJS(data: any): CreateExpenseGroupCommandOfExpenseGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpenseGroupCommandOfExpenseGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["expenseTypeId"] = this.expenseTypeId;
        return data;
    }
}

export interface ICreateExpenseGroupCommandOfExpenseGroup {
    name: string;
    expenseTypeId: ExpenseTypeEnum;
}

export class UpdateExpenseGroupCommandOfExpenseGroup extends CreateExpenseGroupCommandOfExpenseGroup implements IUpdateExpenseGroupCommandOfExpenseGroup {
    id!: number;

    constructor(data?: IUpdateExpenseGroupCommandOfExpenseGroup) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateExpenseGroupCommandOfExpenseGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpenseGroupCommandOfExpenseGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateExpenseGroupCommandOfExpenseGroup extends ICreateExpenseGroupCommandOfExpenseGroup {
    id: number;
}

/** Represents HttpRequest and HttpResponse headers */
export abstract class IHeaderDictionary implements IIHeaderDictionary {
    item!: any[];
    /** Strongly typed access to the Content-Length header. Implementations must keep this in sync with the string representation. */
    contentLength!: number | undefined;

    constructor(data?: IIHeaderDictionary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Item"])) {
                this.item = [] as any;
                for (let item of _data["Item"])
                    this.item!.push(item);
            }
            this.contentLength = _data["ContentLength"];
        }
    }

    static fromJS(data: any): IHeaderDictionary {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IHeaderDictionary' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item)) {
            data["Item"] = [];
            for (let item of this.item)
                data["Item"].push(item);
        }
        data["ContentLength"] = this.contentLength;
        return data;
    }
}

/** Represents HttpRequest and HttpResponse headers */
export interface IIHeaderDictionary {
    item: any[];
    /** Strongly typed access to the Content-Length header. Implementations must keep this in sync with the string representation. */
    contentLength: number | undefined;
}

export class FormTemplateVm implements IFormTemplateVm {
    id!: number;
    fileName!: string;
    url!: string;
    remark!: string | undefined;
    createdBy!: string | undefined;
    createdDate!: Date;

    constructor(data?: IFormTemplateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            this.remark = _data["remark"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FormTemplateVm {
        data = typeof data === 'object' ? data : {};
        let result = new FormTemplateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        data["remark"] = this.remark;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFormTemplateVm {
    id: number;
    fileName: string;
    url: string;
    remark: string | undefined;
    createdBy: string | undefined;
    createdDate: Date;
}

export class HodogramVm implements IHodogramVm {
    id!: number;
    ordinal!: number;
    code!: string | undefined;
    name!: string;
    description!: string | undefined;
    isActive!: boolean;
    parentId!: number | undefined;
    children!: HodogramVm[] | undefined;

    constructor(data?: IHodogramVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ordinal = _data["ordinal"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(HodogramVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HodogramVm {
        data = typeof data === 'object' ? data : {};
        let result = new HodogramVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ordinal"] = this.ordinal;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHodogramVm {
    id: number;
    ordinal: number;
    code: string | undefined;
    name: string;
    description: string | undefined;
    isActive: boolean;
    parentId: number | undefined;
    children: HodogramVm[] | undefined;
}

export class UpdateEntireHodogramCommand implements IUpdateEntireHodogramCommand {
    hodogramEntities!: UpdateHodogramCommand[] | undefined;

    constructor(data?: IUpdateEntireHodogramCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hodogramEntities"])) {
                this.hodogramEntities = [] as any;
                for (let item of _data["hodogramEntities"])
                    this.hodogramEntities!.push(UpdateHodogramCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEntireHodogramCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEntireHodogramCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hodogramEntities)) {
            data["hodogramEntities"] = [];
            for (let item of this.hodogramEntities)
                data["hodogramEntities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEntireHodogramCommand {
    hodogramEntities: UpdateHodogramCommand[] | undefined;
}

export class UpdateHodogramCommand implements IUpdateHodogramCommand {
    id!: number;
    ordinal!: number;
    code!: string | undefined;
    name!: string;
    description!: string | undefined;
    isActive!: boolean;
    parentId!: number | undefined;
    children!: UpdateHodogramCommand[] | undefined;

    constructor(data?: IUpdateHodogramCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ordinal = _data["ordinal"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(UpdateHodogramCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateHodogramCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHodogramCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ordinal"] = this.ordinal;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateHodogramCommand {
    id: number;
    ordinal: number;
    code: string | undefined;
    name: string;
    description: string | undefined;
    isActive: boolean;
    parentId: number | undefined;
    children: UpdateHodogramCommand[] | undefined;
}

export class ProjectHodogramVm implements IProjectHodogramVm {
    id!: number;
    ordinal!: number;
    code!: string | undefined;
    name!: string;
    description!: string | undefined;
    isActive!: boolean;
    parentId!: number | undefined;
    isCompleted!: boolean;
    projectId!: number;
    children!: ProjectHodogramVm[] | undefined;
    attachments!: AttachmentVm[] | undefined;

    constructor(data?: IProjectHodogramVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ordinal = _data["ordinal"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.parentId = _data["parentId"];
            this.isCompleted = _data["isCompleted"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ProjectHodogramVm.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectHodogramVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectHodogramVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ordinal"] = this.ordinal;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["parentId"] = this.parentId;
        data["isCompleted"] = this.isCompleted;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectHodogramVm {
    id: number;
    ordinal: number;
    code: string | undefined;
    name: string;
    description: string | undefined;
    isActive: boolean;
    parentId: number | undefined;
    isCompleted: boolean;
    projectId: number;
    children: ProjectHodogramVm[] | undefined;
    attachments: AttachmentVm[] | undefined;
}

export class UpdateProjectHodogramCommand implements IUpdateProjectHodogramCommand {
    projectId!: number;
    completedIds!: number[] | undefined;

    constructor(data?: IUpdateProjectHodogramCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["completedIds"])) {
                this.completedIds = [] as any;
                for (let item of _data["completedIds"])
                    this.completedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProjectHodogramCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectHodogramCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.completedIds)) {
            data["completedIds"] = [];
            for (let item of this.completedIds)
                data["completedIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateProjectHodogramCommand {
    projectId: number;
    completedIds: number[] | undefined;
}

export class HolidayVm implements IHolidayVm {
    date!: Date;
    localName!: string | undefined;
    name!: string | undefined;
    countryCode!: string | undefined;
    fixed!: boolean;
    global!: boolean | undefined;
    counties!: any | undefined;
    launchYear!: any | undefined;
    types!: string[] | undefined;

    constructor(data?: IHolidayVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.localName = _data["localName"];
            this.name = _data["name"];
            this.countryCode = _data["countryCode"];
            this.fixed = _data["fixed"];
            this.global = _data["global"];
            this.counties = _data["counties"];
            this.launchYear = _data["launchYear"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static fromJS(data: any): HolidayVm {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["localName"] = this.localName;
        data["name"] = this.name;
        data["countryCode"] = this.countryCode;
        data["fixed"] = this.fixed;
        data["global"] = this.global;
        data["counties"] = this.counties;
        data["launchYear"] = this.launchYear;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface IHolidayVm {
    date: Date;
    localName: string | undefined;
    name: string | undefined;
    countryCode: string | undefined;
    fixed: boolean;
    global: boolean | undefined;
    counties: any | undefined;
    launchYear: any | undefined;
    types: string[] | undefined;
}

export class NewsVm implements INewsVm {
    id!: number;
    title!: string;
    text!: string;
    date!: Date;
    author!: string;
    isArchived!: boolean;
    isFeatured!: boolean;

    constructor(data?: INewsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.isArchived = _data["isArchived"];
            this.isFeatured = _data["isFeatured"];
        }
    }

    static fromJS(data: any): NewsVm {
        data = typeof data === 'object' ? data : {};
        let result = new NewsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["text"] = this.text;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["author"] = this.author;
        data["isArchived"] = this.isArchived;
        data["isFeatured"] = this.isFeatured;
        return data;
    }
}

export interface INewsVm {
    id: number;
    title: string;
    text: string;
    date: Date;
    author: string;
    isArchived: boolean;
    isFeatured: boolean;
}

export class PaginatedListOfNewsVm implements IPaginatedListOfNewsVm {
    pageItems!: NewsVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfNewsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(NewsVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfNewsVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfNewsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfNewsVm {
    pageItems: NewsVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class CreateNewsCommandOfNews implements ICreateNewsCommandOfNews {
    title!: string;
    text!: string;
    date!: Date;
    author!: string;
    isFeatured!: boolean;

    constructor(data?: ICreateNewsCommandOfNews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.text = _data["text"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.isFeatured = _data["isFeatured"];
        }
    }

    static fromJS(data: any): CreateNewsCommandOfNews {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewsCommandOfNews();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["text"] = this.text;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["author"] = this.author;
        data["isFeatured"] = this.isFeatured;
        return data;
    }
}

export interface ICreateNewsCommandOfNews {
    title: string;
    text: string;
    date: Date;
    author: string;
    isFeatured: boolean;
}

export class UpdateNewsCommandOfNews extends CreateNewsCommandOfNews implements IUpdateNewsCommandOfNews {
    id!: number;
    isArchived!: boolean;

    constructor(data?: IUpdateNewsCommandOfNews) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): UpdateNewsCommandOfNews {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNewsCommandOfNews();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isArchived"] = this.isArchived;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateNewsCommandOfNews extends ICreateNewsCommandOfNews {
    id: number;
    isArchived: boolean;
}

export class PayrollVm implements IPayrollVm {
    id!: number;
    month!: number;
    year!: number;
    isApproved!: boolean;
    employeePayrolls!: EmployeePayrollVm[] | undefined;

    constructor(data?: IPayrollVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.isApproved = _data["isApproved"];
            if (Array.isArray(_data["employeePayrolls"])) {
                this.employeePayrolls = [] as any;
                for (let item of _data["employeePayrolls"])
                    this.employeePayrolls!.push(EmployeePayrollVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PayrollVm {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month;
        data["year"] = this.year;
        data["isApproved"] = this.isApproved;
        if (Array.isArray(this.employeePayrolls)) {
            data["employeePayrolls"] = [];
            for (let item of this.employeePayrolls)
                data["employeePayrolls"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPayrollVm {
    id: number;
    month: number;
    year: number;
    isApproved: boolean;
    employeePayrolls: EmployeePayrollVm[] | undefined;
}

export class EmployeePayrollVm implements IEmployeePayrollVm {
    employee!: EmployeeInfoVm;
    payrollItem!: PayrollItemVm | undefined;

    constructor(data?: IEmployeePayrollVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeInfoVm.fromJS(_data["employee"]) : <any>undefined;
            this.payrollItem = _data["payrollItem"] ? PayrollItemVm.fromJS(_data["payrollItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeePayrollVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePayrollVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["payrollItem"] = this.payrollItem ? this.payrollItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeePayrollVm {
    employee: EmployeeInfoVm;
    payrollItem: PayrollItemVm | undefined;
}

export class PayrollItemVm implements IPayrollItemVm {
    id!: number;
    payrollId!: number;
    idNumber!: string | undefined;
    sickLeaveHourlyRate!: number;
    otherAbsenceHourlyRate!: number;
    vacationHourlyRate!: number;
    paidLeaveHourlyRate!: number;
    regularWorkHours!: number;
    sickLeaveHours!: number;
    otherAbsenceHours!: number;
    vacationHours!: number;
    paidLeaveHours!: number;
    unpaidLeaveHours!: number | undefined;
    fieldDays!: number;
    totalRegularWork!: number;
    totalSickLeave!: number;
    totalOtherAbsence!: number;
    totalVacation!: number;
    totalPaidLeave!: number;
    totalFieldWork!: number;
    allowances!: number;
    total!: number;
    netAmount!: number;
    numberOfWorkingDaysInMonth!: number;
    fieldWorkFundDays!: number;
    fieldWorkFundDaysTotal!: number;
    numberOfFieldDaysForPayment!: number;
    fieldAllowance!: number;
    bonus!: number;
    incentives!: number;
    accountingTotal!: number;

    constructor(data?: IPayrollItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payrollId = _data["payrollId"];
            this.idNumber = _data["idNumber"];
            this.sickLeaveHourlyRate = _data["sickLeaveHourlyRate"];
            this.otherAbsenceHourlyRate = _data["otherAbsenceHourlyRate"];
            this.vacationHourlyRate = _data["vacationHourlyRate"];
            this.paidLeaveHourlyRate = _data["paidLeaveHourlyRate"];
            this.regularWorkHours = _data["regularWorkHours"];
            this.sickLeaveHours = _data["sickLeaveHours"];
            this.otherAbsenceHours = _data["otherAbsenceHours"];
            this.vacationHours = _data["vacationHours"];
            this.paidLeaveHours = _data["paidLeaveHours"];
            this.unpaidLeaveHours = _data["unpaidLeaveHours"];
            this.fieldDays = _data["fieldDays"];
            this.totalRegularWork = _data["totalRegularWork"];
            this.totalSickLeave = _data["totalSickLeave"];
            this.totalOtherAbsence = _data["totalOtherAbsence"];
            this.totalVacation = _data["totalVacation"];
            this.totalPaidLeave = _data["totalPaidLeave"];
            this.totalFieldWork = _data["totalFieldWork"];
            this.allowances = _data["allowances"];
            this.total = _data["total"];
            this.netAmount = _data["netAmount"];
            this.numberOfWorkingDaysInMonth = _data["numberOfWorkingDaysInMonth"];
            this.fieldWorkFundDays = _data["fieldWorkFundDays"];
            this.fieldWorkFundDaysTotal = _data["fieldWorkFundDaysTotal"];
            this.numberOfFieldDaysForPayment = _data["numberOfFieldDaysForPayment"];
            this.fieldAllowance = _data["fieldAllowance"];
            this.bonus = _data["bonus"];
            this.incentives = _data["incentives"];
            this.accountingTotal = _data["accountingTotal"];
        }
    }

    static fromJS(data: any): PayrollItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payrollId"] = this.payrollId;
        data["idNumber"] = this.idNumber;
        data["sickLeaveHourlyRate"] = this.sickLeaveHourlyRate;
        data["otherAbsenceHourlyRate"] = this.otherAbsenceHourlyRate;
        data["vacationHourlyRate"] = this.vacationHourlyRate;
        data["paidLeaveHourlyRate"] = this.paidLeaveHourlyRate;
        data["regularWorkHours"] = this.regularWorkHours;
        data["sickLeaveHours"] = this.sickLeaveHours;
        data["otherAbsenceHours"] = this.otherAbsenceHours;
        data["vacationHours"] = this.vacationHours;
        data["paidLeaveHours"] = this.paidLeaveHours;
        data["unpaidLeaveHours"] = this.unpaidLeaveHours;
        data["fieldDays"] = this.fieldDays;
        data["totalRegularWork"] = this.totalRegularWork;
        data["totalSickLeave"] = this.totalSickLeave;
        data["totalOtherAbsence"] = this.totalOtherAbsence;
        data["totalVacation"] = this.totalVacation;
        data["totalPaidLeave"] = this.totalPaidLeave;
        data["totalFieldWork"] = this.totalFieldWork;
        data["allowances"] = this.allowances;
        data["total"] = this.total;
        data["netAmount"] = this.netAmount;
        data["numberOfWorkingDaysInMonth"] = this.numberOfWorkingDaysInMonth;
        data["fieldWorkFundDays"] = this.fieldWorkFundDays;
        data["fieldWorkFundDaysTotal"] = this.fieldWorkFundDaysTotal;
        data["numberOfFieldDaysForPayment"] = this.numberOfFieldDaysForPayment;
        data["fieldAllowance"] = this.fieldAllowance;
        data["bonus"] = this.bonus;
        data["incentives"] = this.incentives;
        data["accountingTotal"] = this.accountingTotal;
        return data;
    }
}

export interface IPayrollItemVm {
    id: number;
    payrollId: number;
    idNumber: string | undefined;
    sickLeaveHourlyRate: number;
    otherAbsenceHourlyRate: number;
    vacationHourlyRate: number;
    paidLeaveHourlyRate: number;
    regularWorkHours: number;
    sickLeaveHours: number;
    otherAbsenceHours: number;
    vacationHours: number;
    paidLeaveHours: number;
    unpaidLeaveHours: number | undefined;
    fieldDays: number;
    totalRegularWork: number;
    totalSickLeave: number;
    totalOtherAbsence: number;
    totalVacation: number;
    totalPaidLeave: number;
    totalFieldWork: number;
    allowances: number;
    total: number;
    netAmount: number;
    numberOfWorkingDaysInMonth: number;
    fieldWorkFundDays: number;
    fieldWorkFundDaysTotal: number;
    numberOfFieldDaysForPayment: number;
    fieldAllowance: number;
    bonus: number;
    incentives: number;
    accountingTotal: number;
}

export class PayrollPaginated implements IPayrollPaginated {
    pageItems!: PayrollVm | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPayrollPaginated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageItems = _data["pageItems"] ? PayrollVm.fromJS(_data["pageItems"]) : <any>undefined;
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PayrollPaginated {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollPaginated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageItems"] = this.pageItems ? this.pageItems.toJSON() : <any>undefined;
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPayrollPaginated {
    pageItems: PayrollVm | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class CreatePayrollCommand implements ICreatePayrollCommand {
    companyId!: number;
    month!: number;
    year!: number;

    constructor(data?: ICreatePayrollCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): CreatePayrollCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePayrollCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface ICreatePayrollCommand {
    companyId: number;
    month: number;
    year: number;
}

export class UpdatePayrollCommand implements IUpdatePayrollCommand {
    id!: number;
    netAmount!: number;
    numberOfWorkingDaysInMonth!: number;
    fieldWorkFundDays!: number;
    numberOfFieldDaysForPayment!: number;
    fieldAllowance!: number;
    bonus!: number;
    incentives!: number;
    accountingTotal!: number;

    constructor(data?: IUpdatePayrollCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.netAmount = _data["netAmount"];
            this.numberOfWorkingDaysInMonth = _data["numberOfWorkingDaysInMonth"];
            this.fieldWorkFundDays = _data["fieldWorkFundDays"];
            this.numberOfFieldDaysForPayment = _data["numberOfFieldDaysForPayment"];
            this.fieldAllowance = _data["fieldAllowance"];
            this.bonus = _data["bonus"];
            this.incentives = _data["incentives"];
            this.accountingTotal = _data["accountingTotal"];
        }
    }

    static fromJS(data: any): UpdatePayrollCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePayrollCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["netAmount"] = this.netAmount;
        data["numberOfWorkingDaysInMonth"] = this.numberOfWorkingDaysInMonth;
        data["fieldWorkFundDays"] = this.fieldWorkFundDays;
        data["numberOfFieldDaysForPayment"] = this.numberOfFieldDaysForPayment;
        data["fieldAllowance"] = this.fieldAllowance;
        data["bonus"] = this.bonus;
        data["incentives"] = this.incentives;
        data["accountingTotal"] = this.accountingTotal;
        return data;
    }
}

export interface IUpdatePayrollCommand {
    id: number;
    netAmount: number;
    numberOfWorkingDaysInMonth: number;
    fieldWorkFundDays: number;
    numberOfFieldDaysForPayment: number;
    fieldAllowance: number;
    bonus: number;
    incentives: number;
    accountingTotal: number;
}

export class ToggleLockPayrollCommand implements IToggleLockPayrollCommand {
    payrollId!: number;
    isLocked!: boolean;

    constructor(data?: IToggleLockPayrollCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollId = _data["payrollId"];
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): ToggleLockPayrollCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleLockPayrollCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollId"] = this.payrollId;
        data["isLocked"] = this.isLocked;
        return data;
    }
}

export interface IToggleLockPayrollCommand {
    payrollId: number;
    isLocked: boolean;
}

export enum PeopleScheduleXslxTypeEnum {
    ByDefault = 0,
    ByAccomodation = 1,
}

export class ProjectCooperatorItemVm implements IProjectCooperatorItemVm {
    id!: number;
    quantity!: number;
    unitPrice!: number;
    totalPrice!: number;
    projectItemId!: number;
    projectCooperatorId!: number;

    constructor(data?: IProjectCooperatorItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.projectItemId = _data["projectItemId"];
            this.projectCooperatorId = _data["projectCooperatorId"];
        }
    }

    static fromJS(data: any): ProjectCooperatorItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCooperatorItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["projectItemId"] = this.projectItemId;
        data["projectCooperatorId"] = this.projectCooperatorId;
        return data;
    }
}

export interface IProjectCooperatorItemVm {
    id: number;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
    projectItemId: number;
    projectCooperatorId: number;
}

export class PaginatedListOfProjectCooperatorItemsOverviewVm implements IPaginatedListOfProjectCooperatorItemsOverviewVm {
    pageItems!: ProjectCooperatorItemsOverviewVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfProjectCooperatorItemsOverviewVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(ProjectCooperatorItemsOverviewVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfProjectCooperatorItemsOverviewVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfProjectCooperatorItemsOverviewVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfProjectCooperatorItemsOverviewVm {
    pageItems: ProjectCooperatorItemsOverviewVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class ProjectCooperatorItemsOverviewVm implements IProjectCooperatorItemsOverviewVm {
    ordinal!: number;
    quantity!: number;
    unitPrice!: number;
    totalPrice!: number;
    projectItem!: string | undefined;
    unit!: string | undefined;
    project!: string | undefined;
    projectCode!: string | undefined;
    cooperator!: string | undefined;
    client!: string | undefined;
    year!: number;

    constructor(data?: IProjectCooperatorItemsOverviewVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinal = _data["ordinal"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.projectItem = _data["projectItem"];
            this.unit = _data["unit"];
            this.project = _data["project"];
            this.projectCode = _data["projectCode"];
            this.cooperator = _data["cooperator"];
            this.client = _data["client"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): ProjectCooperatorItemsOverviewVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCooperatorItemsOverviewVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinal"] = this.ordinal;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["projectItem"] = this.projectItem;
        data["unit"] = this.unit;
        data["project"] = this.project;
        data["projectCode"] = this.projectCode;
        data["cooperator"] = this.cooperator;
        data["client"] = this.client;
        data["year"] = this.year;
        return data;
    }
}

export interface IProjectCooperatorItemsOverviewVm {
    ordinal: number;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
    projectItem: string | undefined;
    unit: string | undefined;
    project: string | undefined;
    projectCode: string | undefined;
    cooperator: string | undefined;
    client: string | undefined;
    year: number;
}

export class CreateProjectCooperatorItemCommandOfProjectCooperatorItem implements ICreateProjectCooperatorItemCommandOfProjectCooperatorItem {
    quantity!: number;
    unitPrice!: number;
    projectItemId!: number;
    projectCooperatorId!: number;

    constructor(data?: ICreateProjectCooperatorItemCommandOfProjectCooperatorItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.projectItemId = _data["projectItemId"];
            this.projectCooperatorId = _data["projectCooperatorId"];
        }
    }

    static fromJS(data: any): CreateProjectCooperatorItemCommandOfProjectCooperatorItem {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectCooperatorItemCommandOfProjectCooperatorItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["projectItemId"] = this.projectItemId;
        data["projectCooperatorId"] = this.projectCooperatorId;
        return data;
    }
}

export interface ICreateProjectCooperatorItemCommandOfProjectCooperatorItem {
    quantity: number;
    unitPrice: number;
    projectItemId: number;
    projectCooperatorId: number;
}

export class UpdateProjectCooperatorItemCommandOfProjectCooperatorItem extends CreateProjectCooperatorItemCommandOfProjectCooperatorItem implements IUpdateProjectCooperatorItemCommandOfProjectCooperatorItem {
    id!: number;

    constructor(data?: IUpdateProjectCooperatorItemCommandOfProjectCooperatorItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProjectCooperatorItemCommandOfProjectCooperatorItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectCooperatorItemCommandOfProjectCooperatorItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProjectCooperatorItemCommandOfProjectCooperatorItem extends ICreateProjectCooperatorItemCommandOfProjectCooperatorItem {
    id: number;
}

export class CreateProjectCooperatorCommandOfProjectCooperator implements ICreateProjectCooperatorCommandOfProjectCooperator {
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    projectId!: number;
    cooperatorId!: number;
    clientId!: number | undefined;
    cooperatorContactId!: number | undefined;
    cooperatorTypeId!: CooperatorTypeEnum;
    hasBoq!: boolean;

    constructor(data?: ICreateProjectCooperatorCommandOfProjectCooperator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.projectId = _data["projectId"];
            this.cooperatorId = _data["cooperatorId"];
            this.clientId = _data["clientId"];
            this.cooperatorContactId = _data["cooperatorContactId"];
            this.cooperatorTypeId = _data["cooperatorTypeId"];
            this.hasBoq = _data["hasBoq"];
        }
    }

    static fromJS(data: any): CreateProjectCooperatorCommandOfProjectCooperator {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectCooperatorCommandOfProjectCooperator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["projectId"] = this.projectId;
        data["cooperatorId"] = this.cooperatorId;
        data["clientId"] = this.clientId;
        data["cooperatorContactId"] = this.cooperatorContactId;
        data["cooperatorTypeId"] = this.cooperatorTypeId;
        data["hasBoq"] = this.hasBoq;
        return data;
    }
}

export interface ICreateProjectCooperatorCommandOfProjectCooperator {
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    projectId: number;
    cooperatorId: number;
    clientId: number | undefined;
    cooperatorContactId: number | undefined;
    cooperatorTypeId: CooperatorTypeEnum;
    hasBoq: boolean;
}

export class UpdateProjectCooperatorCommandOfProjectCooperator extends CreateProjectCooperatorCommandOfProjectCooperator implements IUpdateProjectCooperatorCommandOfProjectCooperator {
    id!: number;

    constructor(data?: IUpdateProjectCooperatorCommandOfProjectCooperator) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProjectCooperatorCommandOfProjectCooperator {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectCooperatorCommandOfProjectCooperator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProjectCooperatorCommandOfProjectCooperator extends ICreateProjectCooperatorCommandOfProjectCooperator {
    id: number;
}

export class ProjectEmployeeVm implements IProjectEmployeeVm {
    id!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    projectId!: number;
    employeeId!: number;
    employee!: EmployeeVm;
    employeeRoleId!: number;
    employeeName!: string;

    constructor(data?: IProjectEmployeeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.projectId = _data["projectId"];
            this.employeeId = _data["employeeId"];
            this.employee = _data["employee"] ? EmployeeVm.fromJS(_data["employee"]) : <any>undefined;
            this.employeeRoleId = _data["employeeRoleId"];
            this.employeeName = _data["employeeName"];
        }
    }

    static fromJS(data: any): ProjectEmployeeVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectEmployeeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["projectId"] = this.projectId;
        data["employeeId"] = this.employeeId;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["employeeRoleId"] = this.employeeRoleId;
        data["employeeName"] = this.employeeName;
        return data;
    }
}

export interface IProjectEmployeeVm {
    id: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    projectId: number;
    employeeId: number;
    employee: EmployeeVm;
    employeeRoleId: number;
    employeeName: string;
}

export class CreateProjectEmployeeCommandOfProjectEmployee implements ICreateProjectEmployeeCommandOfProjectEmployee {
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    projectId!: number;
    employeeId!: number;

    constructor(data?: ICreateProjectEmployeeCommandOfProjectEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.projectId = _data["projectId"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): CreateProjectEmployeeCommandOfProjectEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectEmployeeCommandOfProjectEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["projectId"] = this.projectId;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface ICreateProjectEmployeeCommandOfProjectEmployee {
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    projectId: number;
    employeeId: number;
}

export class UpdateProjectEmployeeCommandOfProjectEmployee extends CreateProjectEmployeeCommandOfProjectEmployee implements IUpdateProjectEmployeeCommandOfProjectEmployee {
    id!: number;

    constructor(data?: IUpdateProjectEmployeeCommandOfProjectEmployee) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProjectEmployeeCommandOfProjectEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectEmployeeCommandOfProjectEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProjectEmployeeCommandOfProjectEmployee extends ICreateProjectEmployeeCommandOfProjectEmployee {
    id: number;
}

export class ProjectItemVm implements IProjectItemVm {
    id!: number;
    ordinal!: number;
    ordinalDisplay!: string | undefined;
    code!: string | undefined;
    name!: string | undefined;
    quantity!: number | undefined;
    unitPrice!: number | undefined;
    totalPrice!: number | undefined;
    unitOfMeasurementId!: number | undefined;
    projectId!: number;
    parentId!: number | undefined;
    isGroup!: boolean;
    unitOfMeasurement!: UnitOfMeasurementVm | undefined;
    parentGroup!: ProjectItemVm | undefined;
    children!: ProjectItemVm[] | undefined;

    constructor(data?: IProjectItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ordinal = _data["ordinal"];
            this.ordinalDisplay = _data["ordinalDisplay"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.unitOfMeasurementId = _data["unitOfMeasurementId"];
            this.projectId = _data["projectId"];
            this.parentId = _data["parentId"];
            this.isGroup = _data["isGroup"];
            this.unitOfMeasurement = _data["unitOfMeasurement"] ? UnitOfMeasurementVm.fromJS(_data["unitOfMeasurement"]) : <any>undefined;
            this.parentGroup = _data["parentGroup"] ? ProjectItemVm.fromJS(_data["parentGroup"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ProjectItemVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ordinal"] = this.ordinal;
        data["ordinalDisplay"] = this.ordinalDisplay;
        data["code"] = this.code;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["unitOfMeasurementId"] = this.unitOfMeasurementId;
        data["projectId"] = this.projectId;
        data["parentId"] = this.parentId;
        data["isGroup"] = this.isGroup;
        data["unitOfMeasurement"] = this.unitOfMeasurement ? this.unitOfMeasurement.toJSON() : <any>undefined;
        data["parentGroup"] = this.parentGroup ? this.parentGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectItemVm {
    id: number;
    ordinal: number;
    ordinalDisplay: string | undefined;
    code: string | undefined;
    name: string | undefined;
    quantity: number | undefined;
    unitPrice: number | undefined;
    totalPrice: number | undefined;
    unitOfMeasurementId: number | undefined;
    projectId: number;
    parentId: number | undefined;
    isGroup: boolean;
    unitOfMeasurement: UnitOfMeasurementVm | undefined;
    parentGroup: ProjectItemVm | undefined;
    children: ProjectItemVm[] | undefined;
}

export class CreateProjectItemCommand implements ICreateProjectItemCommand {
    code!: string | undefined;
    name!: string;
    quantity!: number;
    unitPrice!: number;
    unitOfMeasurementId!: number;
    projectId!: number;
    parentId!: number | undefined;
    isGroup!: boolean;

    constructor(data?: ICreateProjectItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.unitOfMeasurementId = _data["unitOfMeasurementId"];
            this.projectId = _data["projectId"];
            this.parentId = _data["parentId"];
            this.isGroup = _data["isGroup"];
        }
    }

    static fromJS(data: any): CreateProjectItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["unitOfMeasurementId"] = this.unitOfMeasurementId;
        data["projectId"] = this.projectId;
        data["parentId"] = this.parentId;
        data["isGroup"] = this.isGroup;
        return data;
    }
}

export interface ICreateProjectItemCommand {
    code: string | undefined;
    name: string;
    quantity: number;
    unitPrice: number;
    unitOfMeasurementId: number;
    projectId: number;
    parentId: number | undefined;
    isGroup: boolean;
}

export class UpdateProjectItemCommandOfProjectItem extends CreateProjectItemCommand implements IUpdateProjectItemCommandOfProjectItem {
    id!: number;
    ordinal!: number;

    constructor(data?: IUpdateProjectItemCommandOfProjectItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.ordinal = _data["ordinal"];
        }
    }

    static fromJS(data: any): UpdateProjectItemCommandOfProjectItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectItemCommandOfProjectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ordinal"] = this.ordinal;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProjectItemCommandOfProjectItem extends ICreateProjectItemCommand {
    id: number;
    ordinal: number;
}

export class ProjectVm implements IProjectVm {
    id!: number;
    warehouseId!: number | undefined;
    name!: string;
    shortName!: string;
    code!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    bankGuarantees!: string | undefined;
    paymentMethod!: string | undefined;
    paymentTerms!: string | undefined;
    description!: string | undefined;
    address!: string | undefined;
    cityId!: number | undefined;
    countryId!: number | undefined;
    longitude!: number | undefined;
    latitude!: number | undefined;
    country!: string | undefined;
    city!: string | undefined;
    projectStatusId!: ProjectStatusEnum;
    workHourEntryDeadlineExtensionInDays!: number | undefined;
    defaultWorkRecordCoefficientId!: number | undefined;
    defaultWorkRecordCoefficient!: string | undefined;
    projectStatus!: string | undefined;
    investor!: string | undefined;

    constructor(data?: IProjectVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.warehouseId = _data["warehouseId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.bankGuarantees = _data["bankGuarantees"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentTerms = _data["paymentTerms"];
            this.description = _data["description"];
            this.address = _data["address"];
            this.cityId = _data["cityId"];
            this.countryId = _data["countryId"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.projectStatusId = _data["projectStatusId"];
            this.workHourEntryDeadlineExtensionInDays = _data["workHourEntryDeadlineExtensionInDays"];
            this.defaultWorkRecordCoefficientId = _data["defaultWorkRecordCoefficientId"];
            this.defaultWorkRecordCoefficient = _data["defaultWorkRecordCoefficient"];
            this.projectStatus = _data["projectStatus"];
            this.investor = _data["investor"];
        }
    }

    static fromJS(data: any): ProjectVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["warehouseId"] = this.warehouseId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["bankGuarantees"] = this.bankGuarantees;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentTerms"] = this.paymentTerms;
        data["description"] = this.description;
        data["address"] = this.address;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["country"] = this.country;
        data["city"] = this.city;
        data["projectStatusId"] = this.projectStatusId;
        data["workHourEntryDeadlineExtensionInDays"] = this.workHourEntryDeadlineExtensionInDays;
        data["defaultWorkRecordCoefficientId"] = this.defaultWorkRecordCoefficientId;
        data["defaultWorkRecordCoefficient"] = this.defaultWorkRecordCoefficient;
        data["projectStatus"] = this.projectStatus;
        data["investor"] = this.investor;
        return data;
    }
}

export interface IProjectVm {
    id: number;
    warehouseId: number | undefined;
    name: string;
    shortName: string;
    code: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    bankGuarantees: string | undefined;
    paymentMethod: string | undefined;
    paymentTerms: string | undefined;
    description: string | undefined;
    address: string | undefined;
    cityId: number | undefined;
    countryId: number | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    country: string | undefined;
    city: string | undefined;
    projectStatusId: ProjectStatusEnum;
    workHourEntryDeadlineExtensionInDays: number | undefined;
    defaultWorkRecordCoefficientId: number | undefined;
    defaultWorkRecordCoefficient: string | undefined;
    projectStatus: string | undefined;
    investor: string | undefined;
}

export enum ProjectStatusEnum {
    Active = 1000,
    Inactive = 1001,
    Completed = 1002,
}

export class PaginatedListOfProjectVm implements IPaginatedListOfProjectVm {
    pageItems!: ProjectVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfProjectVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(ProjectVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfProjectVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfProjectVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfProjectVm {
    pageItems: ProjectVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class ProjectDetailVm extends ProjectVm implements IProjectDetailVm {
    cooperators!: ProjectCooperatorVm[] | undefined;
    attachments!: AttachmentVm[] | undefined;
    situations!: ProjectSituationVm[] | undefined;

    constructor(data?: IProjectDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["cooperators"])) {
                this.cooperators = [] as any;
                for (let item of _data["cooperators"])
                    this.cooperators!.push(ProjectCooperatorVm.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentVm.fromJS(item));
            }
            if (Array.isArray(_data["situations"])) {
                this.situations = [] as any;
                for (let item of _data["situations"])
                    this.situations!.push(ProjectSituationVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cooperators)) {
            data["cooperators"] = [];
            for (let item of this.cooperators)
                data["cooperators"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.situations)) {
            data["situations"] = [];
            for (let item of this.situations)
                data["situations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProjectDetailVm extends IProjectVm {
    cooperators: ProjectCooperatorVm[] | undefined;
    attachments: AttachmentVm[] | undefined;
    situations: ProjectSituationVm[] | undefined;
}

export class ProjectSituationVm implements IProjectSituationVm {
    id!: number;
    name!: string;
    activeFrom!: Date;
    activeTo!: Date;
    description!: string | undefined;
    projectId!: number;

    constructor(data?: IProjectSituationVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProjectSituationVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSituationVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProjectSituationVm {
    id: number;
    name: string;
    activeFrom: Date;
    activeTo: Date;
    description: string | undefined;
    projectId: number;
}

export class CreateProjectCommandOfProject implements ICreateProjectCommandOfProject {
    name!: string;
    shortName!: string | undefined;
    code!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    bankGuarantees!: string | undefined;
    paymentMethod!: string | undefined;
    paymentTerms!: string | undefined;
    description!: string | undefined;
    address!: string | undefined;
    cityId!: number | undefined;
    countryId!: number | undefined;
    longitude!: number | undefined;
    latitude!: number | undefined;
    workHourEntryDeadlineExtensionInDays!: number | undefined;
    defaultWorkRecordCoefficientId!: number | undefined;
    projectStatusId!: ProjectStatusEnum;

    constructor(data?: ICreateProjectCommandOfProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.bankGuarantees = _data["bankGuarantees"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentTerms = _data["paymentTerms"];
            this.description = _data["description"];
            this.address = _data["address"];
            this.cityId = _data["cityId"];
            this.countryId = _data["countryId"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.workHourEntryDeadlineExtensionInDays = _data["workHourEntryDeadlineExtensionInDays"];
            this.defaultWorkRecordCoefficientId = _data["defaultWorkRecordCoefficientId"];
            this.projectStatusId = _data["projectStatusId"];
        }
    }

    static fromJS(data: any): CreateProjectCommandOfProject {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectCommandOfProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["bankGuarantees"] = this.bankGuarantees;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentTerms"] = this.paymentTerms;
        data["description"] = this.description;
        data["address"] = this.address;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["workHourEntryDeadlineExtensionInDays"] = this.workHourEntryDeadlineExtensionInDays;
        data["defaultWorkRecordCoefficientId"] = this.defaultWorkRecordCoefficientId;
        data["projectStatusId"] = this.projectStatusId;
        return data;
    }
}

export interface ICreateProjectCommandOfProject {
    name: string;
    shortName: string | undefined;
    code: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    bankGuarantees: string | undefined;
    paymentMethod: string | undefined;
    paymentTerms: string | undefined;
    description: string | undefined;
    address: string | undefined;
    cityId: number | undefined;
    countryId: number | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    workHourEntryDeadlineExtensionInDays: number | undefined;
    defaultWorkRecordCoefficientId: number | undefined;
    projectStatusId: ProjectStatusEnum;
}

export class UpdateProjectCommandOfProject extends CreateProjectCommandOfProject implements IUpdateProjectCommandOfProject {
    id!: number;

    constructor(data?: IUpdateProjectCommandOfProject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProjectCommandOfProject {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectCommandOfProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProjectCommandOfProject extends ICreateProjectCommandOfProject {
    id: number;
}

export class ProjectSituationItemVm implements IProjectSituationItemVm {
    id!: number;
    quantity!: number;
    totalPrice!: number;
    projectCooperatorItemId!: number;
    projectCooperatorId!: number;
    projectSituationId!: number;
    projectItemId!: number;

    constructor(data?: IProjectSituationItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.totalPrice = _data["totalPrice"];
            this.projectCooperatorItemId = _data["projectCooperatorItemId"];
            this.projectCooperatorId = _data["projectCooperatorId"];
            this.projectSituationId = _data["projectSituationId"];
            this.projectItemId = _data["projectItemId"];
        }
    }

    static fromJS(data: any): ProjectSituationItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSituationItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["totalPrice"] = this.totalPrice;
        data["projectCooperatorItemId"] = this.projectCooperatorItemId;
        data["projectCooperatorId"] = this.projectCooperatorId;
        data["projectSituationId"] = this.projectSituationId;
        data["projectItemId"] = this.projectItemId;
        return data;
    }
}

export interface IProjectSituationItemVm {
    id: number;
    quantity: number;
    totalPrice: number;
    projectCooperatorItemId: number;
    projectCooperatorId: number;
    projectSituationId: number;
    projectItemId: number;
}

export class CreateProjectSituationItemCommandOfProjectSituationItem implements ICreateProjectSituationItemCommandOfProjectSituationItem {
    quantity!: number;
    projectCooperatorItemId!: number;
    projectSituationId!: number;

    constructor(data?: ICreateProjectSituationItemCommandOfProjectSituationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.projectCooperatorItemId = _data["projectCooperatorItemId"];
            this.projectSituationId = _data["projectSituationId"];
        }
    }

    static fromJS(data: any): CreateProjectSituationItemCommandOfProjectSituationItem {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectSituationItemCommandOfProjectSituationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["projectCooperatorItemId"] = this.projectCooperatorItemId;
        data["projectSituationId"] = this.projectSituationId;
        return data;
    }
}

export interface ICreateProjectSituationItemCommandOfProjectSituationItem {
    quantity: number;
    projectCooperatorItemId: number;
    projectSituationId: number;
}

export class UpdateProjectSituationItemCommandOfProjectSituationItem extends CreateProjectSituationItemCommandOfProjectSituationItem implements IUpdateProjectSituationItemCommandOfProjectSituationItem {
    id!: number;

    constructor(data?: IUpdateProjectSituationItemCommandOfProjectSituationItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProjectSituationItemCommandOfProjectSituationItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectSituationItemCommandOfProjectSituationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProjectSituationItemCommandOfProjectSituationItem extends ICreateProjectSituationItemCommandOfProjectSituationItem {
    id: number;
}

export class CreateProjectSituationCommandOfProjectSituation implements ICreateProjectSituationCommandOfProjectSituation {
    name!: string;
    activeFrom!: Date;
    activeTo!: Date;
    description!: string | undefined;
    projectId!: number;

    constructor(data?: ICreateProjectSituationCommandOfProjectSituation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateProjectSituationCommandOfProjectSituation {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectSituationCommandOfProjectSituation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICreateProjectSituationCommandOfProjectSituation {
    name: string;
    activeFrom: Date;
    activeTo: Date;
    description: string | undefined;
    projectId: number;
}

export class UpdateProjectSituationCommandOfProjectSituation extends CreateProjectSituationCommandOfProjectSituation implements IUpdateProjectSituationCommandOfProjectSituation {
    id!: number;

    constructor(data?: IUpdateProjectSituationCommandOfProjectSituation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProjectSituationCommandOfProjectSituation {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectSituationCommandOfProjectSituation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProjectSituationCommandOfProjectSituation extends ICreateProjectSituationCommandOfProjectSituation {
    id: number;
}

export class EmployeeSalaryVm implements IEmployeeSalaryVm {
    employee!: EmployeeInfoVm;
    salary!: SalaryVm | undefined;

    constructor(data?: IEmployeeSalaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeInfoVm.fromJS(_data["employee"]) : <any>undefined;
            this.salary = _data["salary"] ? SalaryVm.fromJS(_data["salary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeSalaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSalaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["salary"] = this.salary ? this.salary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeSalaryVm {
    employee: EmployeeInfoVm;
    salary: SalaryVm | undefined;
}

export class SalaryVm implements ISalaryVm {
    id!: number;
    month!: number;
    year!: number;
    employeeId!: number;
    contractedAmount!: number;
    netAmount!: number;
    sickLeaveGrossAmount!: number | undefined;
    taxAndSurtaxAmount!: number | undefined;
    agreedAmount!: number | undefined;
    hourlyRate!: number | undefined;
    additionRecurring!: number | undefined;
    additionOneTime!: number | undefined;
    note!: string | undefined;
    fieldWorkDaysFund!: number | undefined;

    constructor(data?: ISalaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.employeeId = _data["employeeId"];
            this.contractedAmount = _data["contractedAmount"];
            this.netAmount = _data["netAmount"];
            this.sickLeaveGrossAmount = _data["sickLeaveGrossAmount"];
            this.taxAndSurtaxAmount = _data["taxAndSurtaxAmount"];
            this.agreedAmount = _data["agreedAmount"];
            this.hourlyRate = _data["hourlyRate"];
            this.additionRecurring = _data["additionRecurring"];
            this.additionOneTime = _data["additionOneTime"];
            this.note = _data["note"];
            this.fieldWorkDaysFund = _data["fieldWorkDaysFund"];
        }
    }

    static fromJS(data: any): SalaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month;
        data["year"] = this.year;
        data["employeeId"] = this.employeeId;
        data["contractedAmount"] = this.contractedAmount;
        data["netAmount"] = this.netAmount;
        data["sickLeaveGrossAmount"] = this.sickLeaveGrossAmount;
        data["taxAndSurtaxAmount"] = this.taxAndSurtaxAmount;
        data["agreedAmount"] = this.agreedAmount;
        data["hourlyRate"] = this.hourlyRate;
        data["additionRecurring"] = this.additionRecurring;
        data["additionOneTime"] = this.additionOneTime;
        data["note"] = this.note;
        data["fieldWorkDaysFund"] = this.fieldWorkDaysFund;
        return data;
    }
}

export interface ISalaryVm {
    id: number;
    month: number;
    year: number;
    employeeId: number;
    contractedAmount: number;
    netAmount: number;
    sickLeaveGrossAmount: number | undefined;
    taxAndSurtaxAmount: number | undefined;
    agreedAmount: number | undefined;
    hourlyRate: number | undefined;
    additionRecurring: number | undefined;
    additionOneTime: number | undefined;
    note: string | undefined;
    fieldWorkDaysFund: number | undefined;
}

export class SalariesPaginatedListOfEmployeeSalaryVm implements ISalariesPaginatedListOfEmployeeSalaryVm {
    pageItems!: EmployeeSalaryVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: ISalariesPaginatedListOfEmployeeSalaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(EmployeeSalaryVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): SalariesPaginatedListOfEmployeeSalaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new SalariesPaginatedListOfEmployeeSalaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface ISalariesPaginatedListOfEmployeeSalaryVm {
    pageItems: EmployeeSalaryVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class CreateSalaryCommand implements ICreateSalaryCommand {
    month!: number;
    year!: number;
    employeeId!: number;
    contractedAmount!: number;
    netAmount!: number;
    sickLeaveGrossAmount!: number | undefined;
    taxAndSurtaxAmount!: number | undefined;
    agreedAmount!: number | undefined;
    hourlyRate!: number | undefined;
    additionRecurring!: number | undefined;
    additionOneTime!: number | undefined;
    note!: string | undefined;
    fieldWorkDaysFund!: number | undefined;
    companyId!: number;

    constructor(data?: ICreateSalaryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.employeeId = _data["employeeId"];
            this.contractedAmount = _data["contractedAmount"];
            this.netAmount = _data["netAmount"];
            this.sickLeaveGrossAmount = _data["sickLeaveGrossAmount"];
            this.taxAndSurtaxAmount = _data["taxAndSurtaxAmount"];
            this.agreedAmount = _data["agreedAmount"];
            this.hourlyRate = _data["hourlyRate"];
            this.additionRecurring = _data["additionRecurring"];
            this.additionOneTime = _data["additionOneTime"];
            this.note = _data["note"];
            this.fieldWorkDaysFund = _data["fieldWorkDaysFund"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CreateSalaryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalaryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["employeeId"] = this.employeeId;
        data["contractedAmount"] = this.contractedAmount;
        data["netAmount"] = this.netAmount;
        data["sickLeaveGrossAmount"] = this.sickLeaveGrossAmount;
        data["taxAndSurtaxAmount"] = this.taxAndSurtaxAmount;
        data["agreedAmount"] = this.agreedAmount;
        data["hourlyRate"] = this.hourlyRate;
        data["additionRecurring"] = this.additionRecurring;
        data["additionOneTime"] = this.additionOneTime;
        data["note"] = this.note;
        data["fieldWorkDaysFund"] = this.fieldWorkDaysFund;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICreateSalaryCommand {
    month: number;
    year: number;
    employeeId: number;
    contractedAmount: number;
    netAmount: number;
    sickLeaveGrossAmount: number | undefined;
    taxAndSurtaxAmount: number | undefined;
    agreedAmount: number | undefined;
    hourlyRate: number | undefined;
    additionRecurring: number | undefined;
    additionOneTime: number | undefined;
    note: string | undefined;
    fieldWorkDaysFund: number | undefined;
    companyId: number;
}

export class UpdateSalaryCommand implements IUpdateSalaryCommand {
    id!: number;
    month!: number;
    year!: number;
    employeeId!: number;
    contractedAmount!: number | undefined;
    netAmount!: number | undefined;
    sickLeaveGrossAmount!: number | undefined;
    taxAndSurtaxAmount!: number | undefined;
    agreedAmount!: number | undefined;
    hourlyRate!: number | undefined;
    additionRecurring!: number | undefined;
    additionOneTime!: number | undefined;
    note!: string | undefined;
    fieldWorkDaysFund!: number | undefined;
    companyId!: number;

    constructor(data?: IUpdateSalaryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.employeeId = _data["employeeId"];
            this.contractedAmount = _data["contractedAmount"];
            this.netAmount = _data["netAmount"];
            this.sickLeaveGrossAmount = _data["sickLeaveGrossAmount"];
            this.taxAndSurtaxAmount = _data["taxAndSurtaxAmount"];
            this.agreedAmount = _data["agreedAmount"];
            this.hourlyRate = _data["hourlyRate"];
            this.additionRecurring = _data["additionRecurring"];
            this.additionOneTime = _data["additionOneTime"];
            this.note = _data["note"];
            this.fieldWorkDaysFund = _data["fieldWorkDaysFund"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): UpdateSalaryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSalaryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month;
        data["year"] = this.year;
        data["employeeId"] = this.employeeId;
        data["contractedAmount"] = this.contractedAmount;
        data["netAmount"] = this.netAmount;
        data["sickLeaveGrossAmount"] = this.sickLeaveGrossAmount;
        data["taxAndSurtaxAmount"] = this.taxAndSurtaxAmount;
        data["agreedAmount"] = this.agreedAmount;
        data["hourlyRate"] = this.hourlyRate;
        data["additionRecurring"] = this.additionRecurring;
        data["additionOneTime"] = this.additionOneTime;
        data["note"] = this.note;
        data["fieldWorkDaysFund"] = this.fieldWorkDaysFund;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IUpdateSalaryCommand {
    id: number;
    month: number;
    year: number;
    employeeId: number;
    contractedAmount: number | undefined;
    netAmount: number | undefined;
    sickLeaveGrossAmount: number | undefined;
    taxAndSurtaxAmount: number | undefined;
    agreedAmount: number | undefined;
    hourlyRate: number | undefined;
    additionRecurring: number | undefined;
    additionOneTime: number | undefined;
    note: string | undefined;
    fieldWorkDaysFund: number | undefined;
    companyId: number;
}

export class CopySalariesCommand implements ICopySalariesCommand {
    companyId!: number;
    fromMonth!: number;
    fromYear!: number;
    toMonth!: number;
    toYear!: number;

    constructor(data?: ICopySalariesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.fromMonth = _data["fromMonth"];
            this.fromYear = _data["fromYear"];
            this.toMonth = _data["toMonth"];
            this.toYear = _data["toYear"];
        }
    }

    static fromJS(data: any): CopySalariesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopySalariesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["fromMonth"] = this.fromMonth;
        data["fromYear"] = this.fromYear;
        data["toMonth"] = this.toMonth;
        data["toYear"] = this.toYear;
        return data;
    }
}

export interface ICopySalariesCommand {
    companyId: number;
    fromMonth: number;
    fromYear: number;
    toMonth: number;
    toYear: number;
}

export class ExportSalariesXlsxCommand implements IExportSalariesXlsxCommand {
    companyId!: number;
    month!: number;
    year!: number;

    constructor(data?: IExportSalariesXlsxCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): ExportSalariesXlsxCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSalariesXlsxCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface IExportSalariesXlsxCommand {
    companyId: number;
    month: number;
    year: number;
}

export class ToolVm implements IToolVm {
    id!: number;
    name!: string;
    description!: string | undefined;
    isArchived!: boolean;
    thumbnailAttachmentId!: number | undefined;

    constructor(data?: IToolVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isArchived = _data["isArchived"];
            this.thumbnailAttachmentId = _data["thumbnailAttachmentId"];
        }
    }

    static fromJS(data: any): ToolVm {
        data = typeof data === 'object' ? data : {};
        let result = new ToolVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isArchived"] = this.isArchived;
        data["thumbnailAttachmentId"] = this.thumbnailAttachmentId;
        return data;
    }
}

export interface IToolVm {
    id: number;
    name: string;
    description: string | undefined;
    isArchived: boolean;
    thumbnailAttachmentId: number | undefined;
}

export class ToolDetailVm extends ToolVm implements IToolDetailVm {
    coverAttachmentId!: number | undefined;
    attachments!: AttachmentVm[] | undefined;

    constructor(data?: IToolDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.coverAttachmentId = _data["coverAttachmentId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ToolDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new ToolDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coverAttachmentId"] = this.coverAttachmentId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IToolDetailVm extends IToolVm {
    coverAttachmentId: number | undefined;
    attachments: AttachmentVm[] | undefined;
}

export class PaginatedListOfToolVm implements IPaginatedListOfToolVm {
    pageItems!: ToolVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfToolVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(ToolVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfToolVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfToolVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfToolVm {
    pageItems: ToolVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class CreateToolCommandOfTool implements ICreateToolCommandOfTool {
    name!: string;
    description!: string | undefined;
    isArchived!: boolean;
    thumbnailAttachmentId!: number | undefined;

    constructor(data?: ICreateToolCommandOfTool) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isArchived = _data["isArchived"];
            this.thumbnailAttachmentId = _data["thumbnailAttachmentId"];
        }
    }

    static fromJS(data: any): CreateToolCommandOfTool {
        data = typeof data === 'object' ? data : {};
        let result = new CreateToolCommandOfTool();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isArchived"] = this.isArchived;
        data["thumbnailAttachmentId"] = this.thumbnailAttachmentId;
        return data;
    }
}

export interface ICreateToolCommandOfTool {
    name: string;
    description: string | undefined;
    isArchived: boolean;
    thumbnailAttachmentId: number | undefined;
}

export class UpdateToolCommandOfTool extends CreateToolCommandOfTool implements IUpdateToolCommandOfTool {
    id!: number;

    constructor(data?: IUpdateToolCommandOfTool) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateToolCommandOfTool {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateToolCommandOfTool();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateToolCommandOfTool extends ICreateToolCommandOfTool {
    id: number;
}

export class CreateUnitOfMeasurementCommandOfUnitOfMeasurement implements ICreateUnitOfMeasurementCommandOfUnitOfMeasurement {
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;

    constructor(data?: ICreateUnitOfMeasurementCommandOfUnitOfMeasurement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): CreateUnitOfMeasurementCommandOfUnitOfMeasurement {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUnitOfMeasurementCommandOfUnitOfMeasurement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface ICreateUnitOfMeasurementCommandOfUnitOfMeasurement {
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
}

export class UpdateUnitOfMeasurementCommandOfUnitOfMeasurement extends CreateUnitOfMeasurementCommandOfUnitOfMeasurement implements IUpdateUnitOfMeasurementCommandOfUnitOfMeasurement {
    id!: number;

    constructor(data?: IUpdateUnitOfMeasurementCommandOfUnitOfMeasurement) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateUnitOfMeasurementCommandOfUnitOfMeasurement {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUnitOfMeasurementCommandOfUnitOfMeasurement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUnitOfMeasurementCommandOfUnitOfMeasurement extends ICreateUnitOfMeasurementCommandOfUnitOfMeasurement {
    id: number;
}

export class UserVm implements IUserVm {
    id!: string;
    userName!: string;
    name!: string;
    surname!: string;
    email!: string;
    emailConfirmed!: boolean;
    roleId!: RoleEnum;
    role!: string;
    employeeId!: number | undefined;
    employee!: string | undefined;
    isActive!: boolean;

    constructor(data?: IUserVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.roleId = _data["roleId"];
            this.role = _data["role"];
            this.employeeId = _data["employeeId"];
            this.employee = _data["employee"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["roleId"] = this.roleId;
        data["role"] = this.role;
        data["employeeId"] = this.employeeId;
        data["employee"] = this.employee;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUserVm {
    id: string;
    userName: string;
    name: string;
    surname: string;
    email: string;
    emailConfirmed: boolean;
    roleId: RoleEnum;
    role: string;
    employeeId: number | undefined;
    employee: string | undefined;
    isActive: boolean;
}

export enum RoleEnum {
    Admin = 100,
    SiteManager = 101,
    Procurement = 102,
    Warehouse = 103,
    SuperAdmin = 104,
    Accounting = 105,
    Management = 106,
}

export class CreateUserCommand implements ICreateUserCommand {
    name!: string | undefined;
    surname!: string | undefined;
    email!: string;
    roleId!: RoleEnum;
    employeeId!: number;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.roleId = _data["roleId"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["roleId"] = this.roleId;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface ICreateUserCommand {
    name: string | undefined;
    surname: string | undefined;
    email: string;
    roleId: RoleEnum;
    employeeId: number;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    name!: string | undefined;
    surname!: string | undefined;
    id!: string | undefined;
    roleId!: RoleEnum;
    employeeId!: number;
    isActive!: boolean;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.employeeId = _data["employeeId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["employeeId"] = this.employeeId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateUserCommand {
    name: string | undefined;
    surname: string | undefined;
    id: string | undefined;
    roleId: RoleEnum;
    employeeId: number;
    isActive: boolean;
}

export class WarehouseVm implements IWarehouseVm {
    id!: number;
    projectId!: number;
    name!: string;
    address!: string | undefined;
    cityId!: number;
    city!: string | undefined;
    countryId!: number;
    country!: string | undefined;

    constructor(data?: IWarehouseVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): WarehouseVm {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        return data;
    }
}

export interface IWarehouseVm {
    id: number;
    projectId: number;
    name: string;
    address: string | undefined;
    cityId: number;
    city: string | undefined;
    countryId: number;
    country: string | undefined;
}

export class PaginatedListOfWarehouseVm implements IPaginatedListOfWarehouseVm {
    pageItems!: WarehouseVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfWarehouseVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(WarehouseVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfWarehouseVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfWarehouseVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfWarehouseVm {
    pageItems: WarehouseVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class WarehouseDetailVm extends WarehouseVm implements IWarehouseDetailVm {
    warehouseItems!: WarehouseItemVm[] | undefined;

    constructor(data?: IWarehouseDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["warehouseItems"])) {
                this.warehouseItems = [] as any;
                for (let item of _data["warehouseItems"])
                    this.warehouseItems!.push(WarehouseItemVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouseItems)) {
            data["warehouseItems"] = [];
            for (let item of this.warehouseItems)
                data["warehouseItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWarehouseDetailVm extends IWarehouseVm {
    warehouseItems: WarehouseItemVm[] | undefined;
}

export class WarehouseItemVm implements IWarehouseItemVm {
    id!: number;
    warehouseId!: number;
    projectName!: string | undefined;
    supplier!: string | undefined;
    sourceDocumentItemId!: number | undefined;
    sourceDocumentItemDocumentId!: number | undefined;
    sourceDocumentItemDocumentCode!: string | undefined;
    sourceDocumentItemDocumentTypeId!: DocumentTypeEnum;
    name!: string;
    quantity!: number;
    unitPrice!: number;
    totalPrice!: number;
    description!: string | undefined;
    unitOfMeasurementId!: number;
    unitOfMeasurement!: UnitOfMeasurementVm | undefined;

    constructor(data?: IWarehouseItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.warehouseId = _data["warehouseId"];
            this.projectName = _data["projectName"];
            this.supplier = _data["supplier"];
            this.sourceDocumentItemId = _data["sourceDocumentItemId"];
            this.sourceDocumentItemDocumentId = _data["sourceDocumentItemDocumentId"];
            this.sourceDocumentItemDocumentCode = _data["sourceDocumentItemDocumentCode"];
            this.sourceDocumentItemDocumentTypeId = _data["sourceDocumentItemDocumentTypeId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.unitOfMeasurementId = _data["unitOfMeasurementId"];
            this.unitOfMeasurement = _data["unitOfMeasurement"] ? UnitOfMeasurementVm.fromJS(_data["unitOfMeasurement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WarehouseItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["warehouseId"] = this.warehouseId;
        data["projectName"] = this.projectName;
        data["supplier"] = this.supplier;
        data["sourceDocumentItemId"] = this.sourceDocumentItemId;
        data["sourceDocumentItemDocumentId"] = this.sourceDocumentItemDocumentId;
        data["sourceDocumentItemDocumentCode"] = this.sourceDocumentItemDocumentCode;
        data["sourceDocumentItemDocumentTypeId"] = this.sourceDocumentItemDocumentTypeId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["unitOfMeasurementId"] = this.unitOfMeasurementId;
        data["unitOfMeasurement"] = this.unitOfMeasurement ? this.unitOfMeasurement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWarehouseItemVm {
    id: number;
    warehouseId: number;
    projectName: string | undefined;
    supplier: string | undefined;
    sourceDocumentItemId: number | undefined;
    sourceDocumentItemDocumentId: number | undefined;
    sourceDocumentItemDocumentCode: string | undefined;
    sourceDocumentItemDocumentTypeId: DocumentTypeEnum;
    name: string;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
    description: string | undefined;
    unitOfMeasurementId: number;
    unitOfMeasurement: UnitOfMeasurementVm | undefined;
}

export class PaginatedListOfWarehouseItemVm implements IPaginatedListOfWarehouseItemVm {
    pageItems!: WarehouseItemVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfWarehouseItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(WarehouseItemVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfWarehouseItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfWarehouseItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfWarehouseItemVm {
    pageItems: WarehouseItemVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class UpdateWarehouseItemCommandOfWarehouseItem implements IUpdateWarehouseItemCommandOfWarehouseItem {
    id!: number;
    name!: string;
    description!: string | undefined;

    constructor(data?: IUpdateWarehouseItemCommandOfWarehouseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateWarehouseItemCommandOfWarehouseItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWarehouseItemCommandOfWarehouseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateWarehouseItemCommandOfWarehouseItem {
    id: number;
    name: string;
    description: string | undefined;
}

export class WorkHourRecordVm implements IWorkHourRecordVm {
    id!: number;
    projectId!: number;
    project!: string;
    projectCode!: string;
    employeeId!: number;
    employee!: string;
    hours!: number;
    date!: Date;
    workHourTypeId!: WorkHourTypeEnum;
    workHourType!: string;
    isFieldWork!: boolean;
    workRecordCoefficientId!: number | undefined;
    workRecordCoefficient!: number | undefined;
    foodSupplierId!: number | undefined;
    foodSupplier!: string | undefined;
    numberOfMeals!: number | undefined;
    accommodationSupplierId!: number | undefined;
    accommodationSupplier!: string | undefined;
    shoes!: boolean;
    shoesPro!: boolean;
    pants!: boolean;
    overalls!: boolean;
    workJacket!: boolean;
    winterJacket!: boolean;
    fleeseJacket!: boolean;
    helmet!: boolean;
    vest!: boolean;
    protectionGloves!: boolean;
    goggles!: boolean;
    hydrodemolitionSuit!: boolean;
    safetyBelt!: boolean;
    description!: string | undefined;
    createdBy!: string | undefined;
    createdDate!: Date;
    lastModifiedBy!: string | undefined;
    lastModifiedDate!: Date | undefined;

    constructor(data?: IWorkHourRecordVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.project = _data["project"];
            this.projectCode = _data["projectCode"];
            this.employeeId = _data["employeeId"];
            this.employee = _data["employee"];
            this.hours = _data["hours"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.workHourTypeId = _data["workHourTypeId"];
            this.workHourType = _data["workHourType"];
            this.isFieldWork = _data["isFieldWork"];
            this.workRecordCoefficientId = _data["workRecordCoefficientId"];
            this.workRecordCoefficient = _data["workRecordCoefficient"];
            this.foodSupplierId = _data["foodSupplierId"];
            this.foodSupplier = _data["foodSupplier"];
            this.numberOfMeals = _data["numberOfMeals"];
            this.accommodationSupplierId = _data["accommodationSupplierId"];
            this.accommodationSupplier = _data["accommodationSupplier"];
            this.shoes = _data["shoes"];
            this.shoesPro = _data["shoesPro"];
            this.pants = _data["pants"];
            this.overalls = _data["overalls"];
            this.workJacket = _data["workJacket"];
            this.winterJacket = _data["winterJacket"];
            this.fleeseJacket = _data["fleeseJacket"];
            this.helmet = _data["helmet"];
            this.vest = _data["vest"];
            this.protectionGloves = _data["protectionGloves"];
            this.goggles = _data["goggles"];
            this.hydrodemolitionSuit = _data["hydrodemolitionSuit"];
            this.safetyBelt = _data["safetyBelt"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkHourRecordVm {
        data = typeof data === 'object' ? data : {};
        let result = new WorkHourRecordVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["project"] = this.project;
        data["projectCode"] = this.projectCode;
        data["employeeId"] = this.employeeId;
        data["employee"] = this.employee;
        data["hours"] = this.hours;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["workHourTypeId"] = this.workHourTypeId;
        data["workHourType"] = this.workHourType;
        data["isFieldWork"] = this.isFieldWork;
        data["workRecordCoefficientId"] = this.workRecordCoefficientId;
        data["workRecordCoefficient"] = this.workRecordCoefficient;
        data["foodSupplierId"] = this.foodSupplierId;
        data["foodSupplier"] = this.foodSupplier;
        data["numberOfMeals"] = this.numberOfMeals;
        data["accommodationSupplierId"] = this.accommodationSupplierId;
        data["accommodationSupplier"] = this.accommodationSupplier;
        data["shoes"] = this.shoes;
        data["shoesPro"] = this.shoesPro;
        data["pants"] = this.pants;
        data["overalls"] = this.overalls;
        data["workJacket"] = this.workJacket;
        data["winterJacket"] = this.winterJacket;
        data["fleeseJacket"] = this.fleeseJacket;
        data["helmet"] = this.helmet;
        data["vest"] = this.vest;
        data["protectionGloves"] = this.protectionGloves;
        data["goggles"] = this.goggles;
        data["hydrodemolitionSuit"] = this.hydrodemolitionSuit;
        data["safetyBelt"] = this.safetyBelt;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWorkHourRecordVm {
    id: number;
    projectId: number;
    project: string;
    projectCode: string;
    employeeId: number;
    employee: string;
    hours: number;
    date: Date;
    workHourTypeId: WorkHourTypeEnum;
    workHourType: string;
    isFieldWork: boolean;
    workRecordCoefficientId: number | undefined;
    workRecordCoefficient: number | undefined;
    foodSupplierId: number | undefined;
    foodSupplier: string | undefined;
    numberOfMeals: number | undefined;
    accommodationSupplierId: number | undefined;
    accommodationSupplier: string | undefined;
    shoes: boolean;
    shoesPro: boolean;
    pants: boolean;
    overalls: boolean;
    workJacket: boolean;
    winterJacket: boolean;
    fleeseJacket: boolean;
    helmet: boolean;
    vest: boolean;
    protectionGloves: boolean;
    goggles: boolean;
    hydrodemolitionSuit: boolean;
    safetyBelt: boolean;
    description: string | undefined;
    createdBy: string | undefined;
    createdDate: Date;
    lastModifiedBy: string | undefined;
    lastModifiedDate: Date | undefined;
}

export enum WorkHourTypeEnum {
    Regular = 600,
    DayOff = 601,
    NonWorking = 602,
    Vacation = 603,
    SickLeave = 604,
    SickLeaveInjury = 605,
    PaidLeave = 606,
    UnpaidLeave = 607,
}

export class CreateWorkHourRecordCommand implements ICreateWorkHourRecordCommand {
    projectId!: number;
    employeeId!: number;
    hours!: number;
    date!: Date;
    description!: string | undefined;
    workHourTypeId!: number;
    isFieldWork!: boolean;
    workRecordCoefficientId!: number | undefined;
    accommodationSupplierId!: number | undefined;
    foodSupplierId!: number | undefined;
    numberOfMeals!: number | undefined;
    shoes!: boolean;
    shoesPro!: boolean;
    pants!: boolean;
    overalls!: boolean;
    workJacket!: boolean;
    winterJacket!: boolean;
    fleeseJacket!: boolean;
    helmet!: boolean;
    vest!: boolean;
    protectionGloves!: boolean;
    goggles!: boolean;
    hydrodemolitionSuit!: boolean;
    safetyBelt!: boolean;
    file!: string | undefined;
    hasGear!: boolean;

    constructor(data?: ICreateWorkHourRecordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.employeeId = _data["employeeId"];
            this.hours = _data["hours"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.workHourTypeId = _data["workHourTypeId"];
            this.isFieldWork = _data["isFieldWork"];
            this.workRecordCoefficientId = _data["workRecordCoefficientId"];
            this.accommodationSupplierId = _data["accommodationSupplierId"];
            this.foodSupplierId = _data["foodSupplierId"];
            this.numberOfMeals = _data["numberOfMeals"];
            this.shoes = _data["shoes"];
            this.shoesPro = _data["shoesPro"];
            this.pants = _data["pants"];
            this.overalls = _data["overalls"];
            this.workJacket = _data["workJacket"];
            this.winterJacket = _data["winterJacket"];
            this.fleeseJacket = _data["fleeseJacket"];
            this.helmet = _data["helmet"];
            this.vest = _data["vest"];
            this.protectionGloves = _data["protectionGloves"];
            this.goggles = _data["goggles"];
            this.hydrodemolitionSuit = _data["hydrodemolitionSuit"];
            this.safetyBelt = _data["safetyBelt"];
            this.file = _data["file"];
            this.hasGear = _data["hasGear"];
        }
    }

    static fromJS(data: any): CreateWorkHourRecordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkHourRecordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["employeeId"] = this.employeeId;
        data["hours"] = this.hours;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["workHourTypeId"] = this.workHourTypeId;
        data["isFieldWork"] = this.isFieldWork;
        data["workRecordCoefficientId"] = this.workRecordCoefficientId;
        data["accommodationSupplierId"] = this.accommodationSupplierId;
        data["foodSupplierId"] = this.foodSupplierId;
        data["numberOfMeals"] = this.numberOfMeals;
        data["shoes"] = this.shoes;
        data["shoesPro"] = this.shoesPro;
        data["pants"] = this.pants;
        data["overalls"] = this.overalls;
        data["workJacket"] = this.workJacket;
        data["winterJacket"] = this.winterJacket;
        data["fleeseJacket"] = this.fleeseJacket;
        data["helmet"] = this.helmet;
        data["vest"] = this.vest;
        data["protectionGloves"] = this.protectionGloves;
        data["goggles"] = this.goggles;
        data["hydrodemolitionSuit"] = this.hydrodemolitionSuit;
        data["safetyBelt"] = this.safetyBelt;
        data["file"] = this.file;
        data["hasGear"] = this.hasGear;
        return data;
    }
}

export interface ICreateWorkHourRecordCommand {
    projectId: number;
    employeeId: number;
    hours: number;
    date: Date;
    description: string | undefined;
    workHourTypeId: number;
    isFieldWork: boolean;
    workRecordCoefficientId: number | undefined;
    accommodationSupplierId: number | undefined;
    foodSupplierId: number | undefined;
    numberOfMeals: number | undefined;
    shoes: boolean;
    shoesPro: boolean;
    pants: boolean;
    overalls: boolean;
    workJacket: boolean;
    winterJacket: boolean;
    fleeseJacket: boolean;
    helmet: boolean;
    vest: boolean;
    protectionGloves: boolean;
    goggles: boolean;
    hydrodemolitionSuit: boolean;
    safetyBelt: boolean;
    file: string | undefined;
    hasGear: boolean;
}

export class CopyWorkHourRecordCommand implements ICopyWorkHourRecordCommand {
    projectId!: number;
    originDate!: Date;
    destinationDate!: Date;

    constructor(data?: ICopyWorkHourRecordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.originDate = _data["originDate"] ? new Date(_data["originDate"].toString()) : <any>undefined;
            this.destinationDate = _data["destinationDate"] ? new Date(_data["destinationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CopyWorkHourRecordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopyWorkHourRecordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["originDate"] = this.originDate ? this.originDate.toISOString() : <any>undefined;
        data["destinationDate"] = this.destinationDate ? this.destinationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICopyWorkHourRecordCommand {
    projectId: number;
    originDate: Date;
    destinationDate: Date;
}

export class UpdateWorkHourRecordCommand extends CreateWorkHourRecordCommand implements IUpdateWorkHourRecordCommand {
    id!: number;

    constructor(data?: IUpdateWorkHourRecordCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateWorkHourRecordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkHourRecordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateWorkHourRecordCommand extends ICreateWorkHourRecordCommand {
    id: number;
}

export class ExportWorkHourRecordsByDayXlsxCommand implements IExportWorkHourRecordsByDayXlsxCommand {
    projectId!: number | undefined;
    year!: number;
    month!: number;

    constructor(data?: IExportWorkHourRecordsByDayXlsxCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): ExportWorkHourRecordsByDayXlsxCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportWorkHourRecordsByDayXlsxCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }
}

export interface IExportWorkHourRecordsByDayXlsxCommand {
    projectId: number | undefined;
    year: number;
    month: number;
}

export class ExportWorkHourRecordsByProjectsXlsxCommand implements IExportWorkHourRecordsByProjectsXlsxCommand {
    year!: number;
    month!: number;

    constructor(data?: IExportWorkHourRecordsByProjectsXlsxCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): ExportWorkHourRecordsByProjectsXlsxCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportWorkHourRecordsByProjectsXlsxCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }
}

export interface IExportWorkHourRecordsByProjectsXlsxCommand {
    year: number;
    month: number;
}

export class UpdateAllProjectsWorkHourDeadlineCommand implements IUpdateAllProjectsWorkHourDeadlineCommand {
    workHourEntryDeadlineExtensionInDays!: number;

    constructor(data?: IUpdateAllProjectsWorkHourDeadlineCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workHourEntryDeadlineExtensionInDays = _data["workHourEntryDeadlineExtensionInDays"];
        }
    }

    static fromJS(data: any): UpdateAllProjectsWorkHourDeadlineCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAllProjectsWorkHourDeadlineCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workHourEntryDeadlineExtensionInDays"] = this.workHourEntryDeadlineExtensionInDays;
        return data;
    }
}

export interface IUpdateAllProjectsWorkHourDeadlineCommand {
    workHourEntryDeadlineExtensionInDays: number;
}

export class WorkRecordCoefficientVm implements IWorkRecordCoefficientVm {
    id!: number;
    name!: string;
    coefficient!: number;

    constructor(data?: IWorkRecordCoefficientVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.coefficient = _data["coefficient"];
        }
    }

    static fromJS(data: any): WorkRecordCoefficientVm {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordCoefficientVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["coefficient"] = this.coefficient;
        return data;
    }
}

export interface IWorkRecordCoefficientVm {
    id: number;
    name: string;
    coefficient: number;
}

export class CreateWorkRecordCoefficientCommandOfWorkRecordCoefficient implements ICreateWorkRecordCoefficientCommandOfWorkRecordCoefficient {
    name!: string;
    coefficient!: number;

    constructor(data?: ICreateWorkRecordCoefficientCommandOfWorkRecordCoefficient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.coefficient = _data["coefficient"];
        }
    }

    static fromJS(data: any): CreateWorkRecordCoefficientCommandOfWorkRecordCoefficient {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkRecordCoefficientCommandOfWorkRecordCoefficient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["coefficient"] = this.coefficient;
        return data;
    }
}

export interface ICreateWorkRecordCoefficientCommandOfWorkRecordCoefficient {
    name: string;
    coefficient: number;
}

export class UpdateWorkRecordCoefficientCommandOfWorkRecordCoefficient extends CreateWorkRecordCoefficientCommandOfWorkRecordCoefficient implements IUpdateWorkRecordCoefficientCommandOfWorkRecordCoefficient {
    id!: number;

    constructor(data?: IUpdateWorkRecordCoefficientCommandOfWorkRecordCoefficient) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateWorkRecordCoefficientCommandOfWorkRecordCoefficient {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkRecordCoefficientCommandOfWorkRecordCoefficient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateWorkRecordCoefficientCommandOfWorkRecordCoefficient extends ICreateWorkRecordCoefficientCommandOfWorkRecordCoefficient {
    id: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}